/* eslint-disable */
<template>
<div>
  
  <v-form v-if="$store.state.currentOrg">
    <!-- <v-form> -->
      <div
        flat
        v-if="e1 != 0"
        :class="{
          'width:100%': $vuetify.breakpoint.mdAndDown,
          xlargeWidth: $vuetify.breakpoint.xl,
        }"
      >
        <v-stepper :alt-labels="altlabel" v-model="e1" >
          <v-stepper-header
          :key="keyHeader"
            class="elevation-0"
            :class="{ smallWidth: $vuetify.breakpoint.xs }"
            v-if="!this.$vuetify.breakpoint.xs && !this.chooseEstate"
            style="height: 80px"
          >
            <v-layout justify-center>
              <v-flex v-for="(x, index) in stepHeaders" :key="index">
                <v-layout justify-center>
                  <v-flex>
                    <v-stepper-step
                      mx-1
                      px-1
                      :editable="e1 >= index + 1 ? true : false"
                      @click="x.clickEvent"
                      style="font-size: 12px"
                      :complete="e1 > index + 1"
                      :step="index + 1"
                      ><span
                        :style="{
                          color:
                            e1 >= index + 1
                              ? $store.state.currentOrg.orderPrimaryColour
                                ? $store.state.currentOrg.orderPrimaryColour
                                : $store.state.currentOrg.primaryColour
                              : 'grey',
                        }"
                        >{{ x.name }}</span
                      ></v-stepper-step
                    >
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-stepper-header>

          <v-stepper-header v-if="this.$vuetify.breakpoint.xs && !this.chooseEstate">
            <v-flex v-for="(x, index) in stepHeaders" :key="index">
              <v-stepper-step
                :editable="x.editCheck"
                @click="x.clickEvent"
                v-if="e1 >= index + 1 && max >= index + 1 && index == 0"
                style="font-size: 12px"
                :complete="e1 > index + 1"
                :step="index + 1"
              ></v-stepper-step>
              <v-stepper-step
                :editable="x.editCheck"
                @click="x.clickEvent"
                v-else-if="index == 0"
                style="font-size: 12px"
                :complete="e1 > index + 1"
                :step="index + 1"
              ></v-stepper-step>

              <v-stepper-step
                :editable="x.editCheck"
                v-if="e1 >= index + 1 && max >= index + 1 && index > 0 && index < stepHeaders.length"
                @click="x.clickEvent"
                :complete="e1 > index + 1"
                :step="index + 1"
              ></v-stepper-step>
              <v-stepper-step
                :editable="x.editCheck"
                v-else-if="e1 <= index + 1 && max >= index + 1 && index > 0 && index < stepHeaders.length"
                @click="x.clickEvent"
                :complete="e1 > index + 1"
                :step="index + 1"
              ></v-stepper-step>
              <v-stepper-step
                v-else-if="index > 0 && index < stepHeaders.length"
                :complete="e1 > index + 1"
                :step="index + 1"
              ></v-stepper-step>
            </v-flex>
          </v-stepper-header>

          <v-stepper-items>
            <v-stepper-content step="1">
              <v-card
                flat
              >
                    <AddressInfo />

                <!-- <v-container
                  :class="{
                    mobileStep: $vuetify.breakpoint.xsOnly,
                    largeWidth: $vuetify.breakpoint.smAndUp,
                  }"
                  style="
                    text-align: center;
                    padding-bottom: 0;
                    margin-bottom: 0;
                  "
                >
                  <v-row v-if="!appLoading" class="my-0 py-0">
                    <AddressInfo />
                    <v-col cols="12" sm="12">
                      <h4
                        :style="{
                          color: $store.state.currentOrg.orderSecondaryColour
                            ? $store.state.currentOrg.orderSecondaryColour
                            : $store.state.currentOrg.secondaryColour,
                        }"
                        class="text-xs-center font-weight-light pt-0 mt-0 ml-5"
                      >
                        {{ this.$store.state.currentOrg.landingPageMessage }}
                      </h4>
                    </v-col>
                    <v-col cols="12" sm="12">
                      <h2
                        :style="{
                          color: $store.state.currentOrg.orderPrimaryColour
                            ? $store.state.currentOrg.orderPrimaryColour
                            : $store.state.currentOrg.primaryColour,
                        }"
                      >
                        CHOOSE YOUR AREA
                      </h2>
                    </v-col>

                    <v-col cols="12" sm="12">
                      <v-text-field
                        v-model="searchLocation"
                        id="pac-input"
                        clearable
                        @change="reset"
                        @click:clear="reset"
                        placeholder="Find My Address"
                      ></v-text-field>
                      <div v-show="this.searchLocation && networkData && networkData.isMDU && !packagesLoading">
                        <v-autocomplete
                          v-if="networkData.isMDU"
                          class="pointer"
                          style="cursor: pointer"
                          clearable
                          v-model="locationTemplate"
                          :items="unitList"
                          :loading="appLoading"
                          flat
                           chips
                          color="primary"
                          label="Select Unit"
                          item-text="locationDescription"
                          item-value="id"
                          return-object
                          @change="setLocationInfoCard()"
                        >
                        
                <template v-slot:item="{ item }">
                  <v-avatar v-if="(item.locationNetworkSubComplex&&item.locationNetworkSubComplex.status==='Live')||
                  (networkData&&networkData.status==='Live')"
                    size="15px"
                    color="green"
                    class="title font-weight-light white--text"
                    ></v-avatar
                  >
                  <v-avatar v-else-if="(item.locationNetworkSubComplex&&item.locationNetworkSubComplex.status==='In Progress')||
                  (networkData&&networkData.status==='In Progress')"
                    size="15px"
                    color="blue"
                    class="title font-weight-light white--text"
                    ></v-avatar
                  >
                  <v-avatar v-else-if="(item.locationNetworkSubComplex&&item.locationNetworkSubComplex.status==='Planned')||
                  (networkData&&networkData.status==='Planned')"
                    size="15px"
                    color="orange"
                    class="title font-weight-light white--text"
                    ></v-avatar
                  >
                  <v-avatar v-else
                    size="15px"
                    color="green"
                    class="title font-weight-light white--text"
                    ></v-avatar
                  >
                  <v-list-item-content>
                    <v-list-item-title class="ml-3"
                      >{{ item.locationDescription }}</v-list-item-title
                    >
                  </v-list-item-content>
                </template>
                </v-autocomplete>
                         
                      </div>
                    </v-col>
                  </v-row>

                  <v-row v-if="appLoading">
                    <v-col cols="12" sm="12">
                      <vue-loaders-ball-spin-fade-loader
                        v-if="appLoading && $store.state.currentOrg.orderPrimaryColour"
                        :key="appLoading"
                        :color="$store.state.currentOrg.orderPrimaryColour"
                        scale="1"
                      ></vue-loaders-ball-spin-fade-loader>
                      <vue-loaders-ball-spin-fade-loader
                        v-else-if="appLoading && $store.state.currentOrg.primaryColour"
                        :key="appLoading"
                        :color="$store.state.currentOrg.primaryColour"
                        scale="1"
                      ></vue-loaders-ball-spin-fade-loader>
                      <br />
                      <br />
                      <h2
                        :style="{
                          color: $store.state.currentOrg.orderSecondaryColour
                            ? $store.state.currentOrg.orderSecondaryColour
                            : $store.state.currentOrg.secondaryColour,
                        }"
                        v-if="appLoading && loadingText !== null"
                      >
                        {{ loadingText }}
                      </h2>
                    </v-col>
                  </v-row>
                </v-container> -->

                <!-- Address Details -->
                <!-- <v-container v-show="!appLoading" class="my-0 py-0">
                  <v-row class="my-0 py-0">
                    <v-col cols="12" sm="12">
                      <gmap-map
                        ref="mapRef"
                        :center="center"
                        :zoom="zoom"
                        :options="{
                          styles: myStyles,
                          streetViewControl: false,
                        }"
                        style="width: 100%; height: 50vh"
                        
                        @click="getAddressData($event)"
                      >
                        <div slot="visible">
                          <v-card
                            class="ma-1"
                            style="
                      bottom: 0;
                      left: 0%;
                      height: auto;
                      position: absolute;
                    "
                            flat
                          >
                            <v-list class="py-0 my-0" dense v-for="item in networkStatus" :key="item.name">
                              <v-list-item>
                                <v-list-item-icon>
                                  <v-icon :color="item.colour">stop</v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>
                                  <v-list-item-title  v-text="item.name"></v-list-item-title>

                                </v-list-item-content>
                              </v-list-item>
                            </v-list>
                          </v-card>
                        </div>
                        <gmap-circle
                          @click="circleLocation($event)"
                          v-for="(pin, index) in wirelessHighSites"
                          :key="index"
                          :center="{ lat: pin.lat, lng: pin.lng }"
                          :radius="pin.gisPointType.deviceMakeModel.distanceRange"
                          :visible="true"
                          :options="{
                            fillColor: '#19a3d1',
                            fillOpacity: 0.2,
                            strokeColor: '#19a3d1',
                            strokeOpacity: 0.8,
                            strokeWeight: 1,
                          }"
                        >
                        </gmap-circle>
                        <gmap-marker
                          v-if="locationMarker && mapLoaded"
                          :animation="1"
                          :position="locationMarker"
                          :key="key"
                          @click="setLocationInfoCard()"
                        ></gmap-marker>

                        <gmap-info-window
                        :key="key"
                          v-if="mapLoaded"
                          :options="infoOptions"
                          :position="locationMarker"
                          :opened="addressPromptWindow && $vuetify.breakpoint.smAndUp"
                          @closeclick="addressPromptWindow = false"
                        >
                          <v-card flat color="white" v-if="addressInformation">
                            <v-card-title>We've got you covered!</v-card-title>
                            <v-card-text>
                              <v-layout justify-center align-center wrap>
                                <v-flex xs5 mx-1>
                                  <h4>Street Number:</h4>
                                </v-flex>
                                <v-flex xs5 mx-1
                                  ><span>{{ addressInformation.streetNumber }}</span></v-flex
                                >
                                <v-flex xs5 mx-1>
                                  <h4>Street:</h4>
                                </v-flex>
                                <v-flex xs5 mx-1
                                  ><span>{{ addressInformation.streetName }}</span></v-flex
                                >
                                <v-flex xs5 mx-1>
                                  <h4>Estate/Area:</h4>
                                </v-flex>
                                <v-flex xs5 mx-1
                                  ><span>{{ networkData.name }}</span></v-flex
                                >
                              </v-layout>
                            </v-card-text>
                            <v-card-actions>
                              <v-layout justify-center align-center>
                                <v-btn
                                  color="primary"
                                  class="white--text"
                                  rounded
                                  @click="
                                    resize();
                                    chooseEstate = false;
                                    choosePackage = true;
                                    detail.internetPackageSelected == false;
                                    setStepperHeader();
                                    setHeaderModal('next', 'chooseEstate', false);
                                  "
                                  >Choose a Package <v-icon color="white">chevron_right</v-icon></v-btn
                                >
                              </v-layout>
                            </v-card-actions>
                          </v-card>
                        </gmap-info-window>
                        <v-dialog v-if="$vuetify.breakpoint.xsOnly" v-model="addressPromptWindow">
                          <v-card flat color="white" v-if="addressInformation">
                            <v-card-title>We've got you covered!</v-card-title>
                            <v-card-text>
                              <v-layout justify-center align-center wrap>
                                <v-flex xs5 mx-1>
                                  <h4>Street Number:</h4>
                                </v-flex>
                                <v-flex xs5 mx-1
                                  ><span>{{ addressInformation.streetNumber }}</span></v-flex
                                >
                                <v-flex xs5 mx-1>
                                  <h4>Street:</h4>
                                </v-flex>
                                <v-flex xs5 mx-1
                                  ><span>{{ addressInformation.streetName }}</span></v-flex
                                >
                                <v-flex xs5 mx-1>
                                  <h4>Estate/Area:</h4>
                                </v-flex>
                                <v-flex xs5 mx-1
                                  ><span>{{ networkData.name }}</span></v-flex
                                >
                              </v-layout>
                            </v-card-text>
                            <v-card-actions>
                              <v-layout justify-center align-center>
                                <v-btn
                                  color="primary"
                                  class="white--text"
                                  rounded
                                  @click="
                                    max = 2;
                                    resize();
                                    e1 = 2;
                                    chooseEstate = false;
                                    choosePackage = true;
                                    detail.internetPackageSelected == false;
                                    setStepperHeader();
                                    setHeaderModal('next', 'chooseEstate', false);
                                  "
                                  >Choose a Package <v-icon color="white">chevron_right</v-icon></v-btn
                                >
                              </v-layout>
                            </v-card-actions>
                          </v-card>
                        </v-dialog>
                       
                        <gmap-info-window
                          v-if="mapLoaded && !confirmAddress"
                          :options="infoOptions"
                          :position="locationMarker"
                          :key="key"
                          :opened="errorWindow && $vuetify.breakpoint.smAndUp"
                          @closeclick="errorWindow = false; locationMarker={}; key++"
                        > <div style='width:300px;height:200px;'>
                          <v-card flat color="white">
                            <h3 style="text-align:center" class="title grey--text">
                              Possible Connections
                            </h3>
                            <v-card-text class="grey--text">
                              <v-row align="center" class="grey--text" :key="loadingFeasibility">
                                <v-col cols="6" sm="6" v-if="!loadingFeasibility">
                                  <h4>Fibre:</h4>
                                </v-col>
                                <v-col cols="6" sm="6" v-if="!loadingFeasibility">
                                  <v-icon color="red">cancel</v-icon>
                                </v-col>
                                <v-col cols="6" sm="6" v-if="!loadingFeasibility">
                                  <h4>Wireless:</h4>
                                </v-col>
                                <v-col cols="6" sm="6" v-if="!loadingFeasibility">
                                  <v-icon v-if="isInWirelessRange" color="light-green">check_circle_outline</v-icon>
                                  <v-icon v-else color="red">cancel</v-icon>
                                </v-col>
                                <v-col cols="6" sm="6" v-if="loadingFeasibility">
                                  Checking feasibility
                                </v-col>
                                <v-col cols="6" sm="6" v-if="loadingFeasibility">
                                  <v-progress-circular size="20" indeterminate color="primary"></v-progress-circular>
                                </v-col>
                              </v-row>
                           
                            <v-card-actions v-if="!loadingFeasibility">
                              <v-row justify="center">
                                <v-btn rounded color="primary" class="white--text" @click="confirmAddress = true"
                                  >Show Interest</v-btn
                                >
                              </v-row>
                            </v-card-actions> </v-card-text>
                          </v-card> </div>
                        </gmap-info-window>
                       
                        <gmap-info-window :key="key" v-if="confirmAddress" :position="locationMarker">
                         <div style='width:300px;height:160px;'> <v-card flat color="white">
                            <h3 style="text-align:center"  class="title grey--text">
                              Confirm Address
                            </h3>
                            <v-card-text class="grey--text">
                              <v-row align="center" class="grey--text">
                                <v-col cols="4" sm="4">
                                  <h4>Address:</h4>
                                </v-col>
                                <v-col cols="8" sm="8" v-if="addressInformation.locality">
                                  <h4>{{ addressInformation.streetNumber }} {{ addressInformation.streetName }}, {{ addressInformation.locality }}</h4>
                                </v-col>
                                 <v-col cols="8" sm="8" v-else>
                                  <h4>{{ addressInformation.streetNumber }} {{ addressInformation.streetName }}</h4>
                                </v-col>
                              </v-row>
                            
                            <v-card-actions>
                              <v-row justify="center">
                                <v-btn
                                  rounded
                                  color="primary"
                                  class="white--text"
                                  @click="
                                    confirmAddress = false;
                                    resize();
                                    chooseEstate = false;
                                    chooseContact = true;
                                    detail.internetPackageSelected = false;
                                    detail.showInterest = true;
                                    detail.feasibility = true;
                                    setStepperHeader();
                                    setHeaderModal('next', 'chooseEstate', false);
                                  "
                                  >Confirm</v-btn
                                >
                              </v-row>
                            </v-card-actions></v-card-text>
                          </v-card></div>
                        </gmap-info-window>
                        <v-dialog v-if="$vuetify.breakpoint.xsOnly && !confirmAddress" v-model="errorWindow">
                          <v-card flat color="white">
                            <h3 style="text-align: center" class="title grey--text mt-3">
                              Possible Connections
                            </h3>
                            <v-card-text class="grey--text">
                              <v-row align="center" class="grey--text" :key="loadingFeasibility">
                                <v-col cols="6" sm="6" v-if="!loadingFeasibility">
                                  <h4>Fibre:</h4>
                                </v-col>
                                <v-col cols="6" sm="6" v-if="!loadingFeasibility">
                                  <v-icon color="red">cancel</v-icon>
                                </v-col>
                                <v-col cols="6" sm="6" v-if="!loadingFeasibility">
                                  <h4>Wireless:</h4>
                                </v-col>
                                <v-col cols="6" sm="6" v-if="!loadingFeasibility">
                                  <v-icon v-if="isInWirelessRange" color="light-green">check_circle_outline</v-icon>
                                  <v-icon v-else color="red">cancel</v-icon>
                                </v-col>
                                <v-col cols="6" sm="6" v-if="loadingFeasibility">
                                  Checking feasibility
                                </v-col>
                                <v-col cols="6" sm="6" v-if="loadingFeasibility">
                                  <v-progress-circular size="20" indeterminate color="primary"></v-progress-circular>
                                </v-col>
                              </v-row>
                           
                            <v-card-actions v-if="!loadingFeasibility">
                              <v-row justify="center">
                                <v-btn rounded color="primary" class="white--text" @click="confirmAddress = true"
                                  >Show Interest</v-btn
                                >
                              </v-row>
                            </v-card-actions>
                             </v-card-text>
                          </v-card>
                        </v-dialog>
                        <v-dialog v-if="$vuetify.breakpoint.xsOnly" v-model="confirmAddress">
                          <v-card flat color="white">
                            <h3 style="text-align: center" class="title grey--text mt-3">
                              Confirm Address
                            </h3>
                            <v-card-text class="grey--text">
                              <v-row align="center" class="grey--text">
                                <v-col cols="6" sm="6">
                                  <h4>Address:</h4>
                                </v-col>
                             <v-col cols="6" sm="6" v-if="addressInformation.locality">
                                  <h4>{{ addressInformation.streetNumber }} {{ addressInformation.streetName }}, {{ addressInformation.locality }}</h4>
                                </v-col>
                                 <v-col cols="6" sm="6" v-else>
                                  <h4>{{ addressInformation.streetNumber }} {{ addressInformation.streetName }}</h4>
                                </v-col>
                              </v-row>
                            
                            <v-card-actions>
                              <v-row justify="center">
                                <v-btn
                                  rounded
                                  color="primary"
                                  class="white--text"
                                  @click="
                                    resize();
                                    confirmAddress = false;
                                    chooseEstate = false;
                                    chooseContact = true;
                                    detail.internetPackageSelected = false;
                                    detail.showInterest = true;
                                    detail.feasibility = true;
                                    setStepperHeader();
                                    setHeaderModal('next', 'chooseEstate', false);
                                  "
                                  >Confirm</v-btn
                                >
                              </v-row>
                            </v-card-actions>
                            </v-card-text>
                          </v-card>
                        </v-dialog>
                        <gmap-info-window :key="key"
                          v-if="mapLoaded"
                          :options="infoOptions"
                          :position="locationMarker"
                          :opened="locationInfoWindowOpen && $vuetify.breakpoint.smAndUp"
                          @closeclick="locationInfoWindowOpen = false"
                        >
                          <v-card :key="key" flat color="white" v-if="locationInfo">
                            <v-card-title>We've got you covered!</v-card-title>
                            <v-card-text>
                              <v-layout justify-center align-center wrap class="text-xs-left">
                                <v-flex xs3 mx-1>
                                  <h3 class="grey--text">Address:</h3>
                                </v-flex>
                                <v-flex xs8 mx-1>
                                  <h3 class="grey--text font-weight-light">
                                    {{ locationInfo.address }}
                                  </h3>
                                </v-flex>
                                <v-flex xs3 mx-1 v-if="locationInfo.location" mt-1>
                                  <h3 class="grey--text">Status:</h3>
                                </v-flex>
                                <v-flex xs8 mx-1 v-if="locationInfo.location" mt-1>
                                  <h3 class="white--text">
                                    <v-layout justify-left align-center v-if="locationInfo.location.fibrePulled">
                                      <v-icon color="light-green">check_circle_outline</v-icon>
                                      <span class="grey--text font-weight-light">Fibre Ready</span>
                                    </v-layout>

                                    <v-layout justify-left align-center v-else>
                                      <v-icon color="orange">warning</v-icon>
                                      <span class="grey--text font-weight-light">Installation Required</span>
                                    </v-layout>

                                  </h3>
                                </v-flex>
                              </v-layout>
                            </v-card-text>
                            <v-card-actions>
                              <v-layout justify-center>
                                <v-btn
                                  color="primary"
                                  class="white--text"
                                  rounded
                                  @click="
                                    max = 2;
                                    resize();
                                    e1 = 2;
                                    chooseEstate = false;
                                    choosePackage = true;
                                    detail.internetPackageSelected == false;
                                    setStepperHeader();
                                    setHeaderModal('next', 'chooseEstate', false);
                                  "
                                >
                                  Choose A Package
                                  <v-icon color="white">chevron_right</v-icon>
                                </v-btn>
                              </v-layout>
                            </v-card-actions>
                          </v-card>
                          <v-card v-else flat color="white">
                            <v-card-text>
                              <v-layout justify-center wrap>
                                <v-flex xs10>
                                  <v-progress-circular size="30" indeterminate color="primary"></v-progress-circular>
                                </v-flex>
                                <v-flex xs8>
                                  <h3 class="grey--text">
                                    Getting address information
                                  </h3>
                                </v-flex>
                              </v-layout>
                            </v-card-text>
                          </v-card>
                        </gmap-info-window>
                        <v-dialog v-if="$vuetify.breakpoint.xsOnly" v-model="locationInfoWindowOpen">
                          <v-card :key="key" flat color="white" v-if="locationInfo">
                       
                            <v-card-title>We've got you covered!</v-card-title>
                            <v-card-text>
                              <v-layout justify-center align-center wrap class="text-xs-left">
                                <v-flex xs4 mx-1>
                                  <h3 class="grey--text">Address:</h3>
                                </v-flex>
                                <v-flex xs7 mx-1>
                                  <h3 class="grey--text font-weight-light">
                                    {{ locationInfo.address }}
                                  </h3>
                                </v-flex>
                                <v-flex xs3 mx-1 v-if="locationInfo.location" mt-1>
                                  <h3 class="grey--text">Status:</h3>
                                </v-flex>
                                <v-flex xs8 mx-1 v-if="locationInfo.location" mt-1>
                                  <h3 class="white--text">
                                    <v-layout justify-left align-center v-if="locationInfo.location.fibrePulled">
                                      <v-icon color="light-green">check_circle_outline</v-icon>
                                      <span class="grey--text font-weight-light">Fibre Ready</span>
                                    </v-layout>

                                    <v-layout justify-left align-center v-else>
                                      <v-icon color="orange">warning</v-icon>
                                      <span class="grey--text font-weight-light">Installation Required</span>
                                    </v-layout>

                                  </h3>
                                </v-flex>
                              </v-layout>
                           
                            <v-card-actions>
                              <v-layout justify-center>
                                <v-btn
                                  color="primary"
                                  class="white--text"
                                  rounded
                                  @click="
                                    max = 2;
                                    resize();
                                    e1 = 2;
                                    chooseEstate = false;
                                    choosePackage = true;
                                    detail.internetPackageSelected == false;
                                    setStepperHeader();
                                    setHeaderModal('next', 'chooseEstate', false);
                                  "
                                >
                                  Choose A Package
                                  <v-icon color="white">chevron_right</v-icon>
                                </v-btn>
                              </v-layout>
                            </v-card-actions>
                             </v-card-text>
                          </v-card>
                          <v-card v-else flat color="white">
                            <v-card-text>
                              <v-layout justify-center wrap>
                                <v-flex xs10>
                                  <v-progress-circular size="30" indeterminate color="primary"></v-progress-circular>
                                </v-flex>
                                <v-flex xs8>
                                  <h3 class="grey--text">
                                    Getting address information
                                  </h3>
                                </v-flex>
                              </v-layout>
                            </v-card-text>
                          </v-card>
                        </v-dialog>
                        <gmap-info-window :key="key"
                          v-if="mapLoaded"
                          :options="infoOptions"
                          :position="infoWindowPos"
                          :opened="infoWinOpen && $vuetify.breakpoint.smAndUp"
                          @closeclick="infoWinOpen = false"
                        >
                          <v-card flat color="white" v-if="polyInfo.fno" width="450px">
                            <v-toolbar flat color="primary">
                              <h3 class="title white--text">
                                {{ polyInfo.name }}
                              </h3>
                            </v-toolbar>
                            <v-card-text>
                              <v-layout justify-center align-center wrap class="text-xs-left">
                                <v-flex xs5 v-if="polyInfo.fno">
                                  <h3 class="grey--text">Network Operator:</h3>
                                </v-flex>
                                <v-flex xs7 v-if="polyInfo.fno">
                                  <h3 class="grey--text font-weight-light" color="grey">
                                    {{ polyInfo.fno.name }}
                                  </h3>
                                </v-flex>
                                <v-flex xs5 v-if="polyInfo.network && polyInfo.network.networkStatus">
                                  <h3 class="grey--text">Network Status</h3>
                                </v-flex>
                                <v-flex xs7 v-if="polyInfo.network && polyInfo.network.networkStatus">
                                  <v-chip
                                    v-if="polyInfo.network.networkStatus == 'Live'"
                                    small
                                    class="white--text"
                                    color="light-green"
                                    >Live</v-chip
                                  >
                                  <v-chip
                                    v-else-if="polyInfo.network.networkStatus == 'In Progress'"
                                    small
                                    class="white--text"
                                    color="blue"
                                    >Under Construction</v-chip
                                  >
                                  <v-chip
                                    v-else-if="polyInfo.network.networkStatus == 'Planned'"
                                    small
                                    class="white--text"
                                    color="orange"
                                    >Planned</v-chip
                                  >
                                </v-flex>
                                <v-flex xs5 v-if="polyInfo.units">
                                  <h3 class="grey--text">No. of Units:</h3>
                                </v-flex>
                                <v-flex xs7 v-if="polyInfo.units">
                                  <h3 class="grey--text font-weight-light" color="grey">
                                    {{ polyInfo.units }}
                                  </h3>
                                </v-flex>
                              </v-layout>
                            </v-card-text>
                          </v-card>
                        </gmap-info-window>
                        <v-dialog v-if="$vuetify.breakpoint.xsOnly" v-model="infoWinOpen">
                          <v-card flat color="white" v-if="polyInfo.fno" width="450px">
                            <v-toolbar flat color="primary">
                              <h3 class="title white--text">
                                {{ polyInfo.name }}
                              </h3>
                            </v-toolbar>
                            <v-card-text>
                              <v-layout justify-center align-center wrap class="text-xs-left">
                                <v-flex xs5 v-if="polyInfo.fno">
                                  <h3 class="grey--text">Network Operator:</h3>
                                </v-flex>
                                <v-flex xs7 v-if="polyInfo.fno">
                                  <h3 class="grey--text font-weight-light" color="grey">
                                    {{ polyInfo.fno.name }}
                                  </h3>
                                </v-flex>
                                <v-flex xs5 v-if="polyInfo.network && polyInfo.network.networkStatus">
                                  <h3 class="grey--text">Network Status</h3>
                                </v-flex>
                                <v-flex xs7 v-if="polyInfo.network && polyInfo.network.networkStatus">
                                  <v-chip
                                    v-if="polyInfo.network.networkStatus == 'Live'"
                                    small
                                    class="white--text"
                                    color="light-green"
                                    >Live</v-chip
                                  >
                                  <v-chip
                                    v-else-if="polyInfo.network.networkStatus == 'In Progress'"
                                    small
                                    class="white--text"
                                    color="blue"
                                    >Under Construction</v-chip
                                  >
                                  <v-chip
                                    v-else-if="polyInfo.network.networkStatus == 'Planned'"
                                    small
                                    class="white--text"
                                    color="orange"
                                    >Planned</v-chip
                                  >
                                </v-flex>
                                <v-flex xs5 v-if="polyInfo.units">
                                  <h3 class="grey--text">No. of Units:</h3>
                                </v-flex>
                                <v-flex xs7 v-if="polyInfo.units">
                                  <h3 class="grey--text font-weight-light" color="grey">
                                    {{ polyInfo.units }}
                                  </h3>
                                </v-flex>
                              </v-layout>
                            </v-card-text>
                          </v-card>
                        </v-dialog>
                      </gmap-map>
                    </v-col>
                  </v-row>
                </v-container> -->
              </v-card>
            </v-stepper-content>

            <v-stepper-content :step="calculateStepContent('choosePackage')">
              <!-- Installation fee -->
              <v-card
                :class="{
                  mobileStep: $vuetify.breakpoint.xsOnly,
                  'compact-form': $vuetify.breakpoint.smAndUp,
                }"
                flat
                v-if="choosePackage"
              >
                <v-container style="text-align: center">
                  <h2
                    :style="{
                      color: $store.state.currentOrg.orderPrimaryColour
                        ? $store.state.currentOrg.orderPrimaryColour
                        : $store.state.currentOrg.primaryColour,
                    }"
                  >
                    SELECT YOUR PACKAGE
                  </h2>
                </v-container>
                <v-row v-if="installFee">
                  <v-col cols="12" sm="12">
                    <h2
                      :style="{
                        color: $store.state.currentOrg.orderSecondaryColour
                          ? $store.state.currentOrg.orderSecondaryColour
                          : $store.state.currentOrg.secondaryColour,
                      }"
                    >
                      Installation Fees:
                    </h2>
                  </v-col>
                </v-row>
                <v-row
                  :style="{
                    color: $store.state.currentOrg.orderSecondaryColour
                      ? $store.state.currentOrg.orderSecondaryColour
                      : $store.state.currentOrg.secondaryColour,
                  }"
                  v-if="installFee"
                >
                  <v-col cols="12" sm="12">
                    <h3
                      v-if="
                        installFee && flags.hasBusinessPacks && (residentialInstallFee > 0 || businessInstallFee > 0)
                      "
                      class="align-left"
                    >
                      An installation fee of
                      <b>{{ residentialInstallFee | currency }} </b> applies for Residential Packages and
                      <b>{{ businessInstallFee | currency }}</b> for Business Packages.
                    </h3>
                    <h3
                      v-else-if="installFee && !flags.hasBusinessPacks && residentialInstallFee > 0"
                      class="text-xs-left"
                    >
                      An installation fee of
                      <b>{{ residentialInstallFee | currency }}</b> may apply upon completion of your order prior to
                      installation.
                    </h3>
                  </v-col>
                </v-row>
                <br v-if="fnoPackagesResidentialPromoSpeeds.length > 0 || fnoPackagesBusinessPromoSpeeds.length > 0" />
                <v-row
                  v-if="
                    (fnoPackagesResidentialPromoSpeeds.length > 0 || fnoPackagesBusinessPromoSpeeds.length > 0) &&
                      installFee
                  "
                >
                  <v-col cols="12" sm="12">
                    <h2 class="red--text text-xs-left subheading">
                      <b>PROMO OFFER!</b>
                    </h2>
                  </v-col>
                </v-row>
                <br v-if="fnoPackagesResidentialPromoSpeeds.length > 0 || fnoPackagesBusinessPromoSpeeds.length > 0" />
                <v-row
                  :style="{
                    color: $store.state.currentOrg.orderSecondaryColour
                      ? $store.state.currentOrg.orderSecondaryColour
                      : $store.state.currentOrg.secondaryColour,
                  }"
                  v-if="
                    (fnoPackagesResidentialPromoSpeeds.length > 0 || fnoPackagesBusinessPromoSpeeds.length > 0) &&
                      installFee
                  "
                >
                  <v-col cols="12" sm="12">
                    <h3 class="text-xs-left subheading">
                      Your Fibre Installation Fee will be waived if you sign up for any of the following:
                    </h3>
                    <br
                      v-if="
                        fnoPackagesResidentialPromoSpeeds.length > 0 ||
                          fnoPackagesBusinessPromoSpeeds.length > 0 ||
                          !this.$vuetify.breakpoint.xs
                      "
                    />
                    <h3 v-if="fnoPackagesResidentialPromoSpeeds.length > 0" class="text-xs-left subheading">
                      Residential Packages:
                    </h3>
                  </v-col>
                </v-row>
                <v-row
                  :style="{
                    color: $store.state.currentOrg.orderSecondaryColour
                      ? $store.state.currentOrg.orderSecondaryColour
                      : $store.state.currentOrg.secondaryColour,
                  }"
                  v-if="fnoPackagesResidentialPromoSpeeds.length > 0 && installFee"
                >
                  <v-col cols="2" sm="2" v-for="item in fnoPackagesResidentialPromoSpeeds" :key="item.id">
                    <b> {{ item }} Mbps</b>
                  </v-col>
                </v-row>

                <br
                  v-if="
                    fnoPackagesResidentialPromoSpeeds.length > 0 ||
                      fnoPackagesBusinessPromoSpeeds.length > 0 ||
                      !this.$vuetify.breakpoint.xs
                  "
                />
                <v-row
                  :style="{
                    color: $store.state.currentOrg.orderSecondaryColour
                      ? $store.state.currentOrg.orderSecondaryColour
                      : $store.state.currentOrg.secondaryColour,
                  }"
                  v-if="fnoPackagesBusinessPromoSpeeds.length > 0 && installFee"
                >
                  <v-col cols="2" sm="2" v-for="item in fnoPackagesBusinessPromoSpeeds" :key="item.id">
                    <b> {{ item }} Mbps</b>
                  </v-col>
                </v-row>
                <!-- <v-row :style="{ color: $store.state.currentOrg.orderSecondaryColour }">
                  <h4 class="text-xs-left subheading pt-0 mt-0 mx-3">
                    Can't find the ISP you're looking for? While we are Open
                    Access, we do still have compliance criteria that need to be
                    met before ISPs can start selling services over our network.
                    If you'd like to sign up with an ISP that is not yet on our
                    network, please reach out to them, tell them you're
                    interested, and ask them to get in contact with us at
                    {{ org.salesEmailAddress }}. Want to be connected right
                    away? Why not sign up for one of the month-to-month packages
                    available.
                  </h4>
                </v-row> -->

                <v-container v-if="!flags.hasBusinessPacks && !this.$vuetify.breakpoint.xs" style="text-align: center">
                  <v-toolbar
                    flat
                    color="white"
                    v-if="
                    !req.query.isp &&
                      !this.$vuetify.breakpoint.xs &&
                        !flags.hasBusinessPacks &&
                        this.detail.internetPackageSelected === true &&
                        this.detail.address.estate != null
                    "
                  >
                    <v-container>
                      <v-row>
                        <v-col cols="12" sm="12">
                          <v-menu offset-y open-on-hover>
                            <template v-slot:activator="{ on }">
                              <v-btn block depressed color="secondary" v-on="on" Large>
                                <h2 style="color: white">SORT <v-icon>arrow_drop_down</v-icon></h2>
                              </v-btn>
                            </template>
                            <v-list>
                              <v-container style="text-align: center">
                                <v-row>
                                  <v-col cols="12" sm="12">
                                    <v-list-item @click="sortpackages('PLTH')"
                                      ><v-list-item-title
                                        :style="{
                                          color: $store.state.currentOrg.orderSecondaryColour
                                            ? $store.state.currentOrg.orderSecondaryColour
                                            : $store.state.currentOrg.secondaryColour,
                                        }"
                                        style="cursor: pointer"
                                        >Price (Low-High)</v-list-item-title
                                      >
                                    </v-list-item>
                                  </v-col>
                                </v-row>
                                <v-row>
                                  <v-col cols="12" sm="12">
                                    <v-list-item @click="sortpackages('PHTL')"
                                      ><v-list-item-title
                                        :style="{
                                          color: $store.state.currentOrg.orderSecondaryColour
                                            ? $store.state.currentOrg.orderSecondaryColour
                                            : $store.state.currentOrg.secondaryColour,
                                        }"
                                        style="cursor: pointer"
                                        >Price (High-Low)</v-list-item-title
                                      >
                                    </v-list-item>
                                  </v-col>
                                </v-row>
                                <v-row>
                                  <v-col cols="12" sm="12">
                                    <v-list-item @click="sortpackages('SLTH')"
                                      ><v-list-item-title
                                        :style="{
                                          color: $store.state.currentOrg.orderSecondaryColour
                                            ? $store.state.currentOrg.orderSecondaryColour
                                            : $store.state.currentOrg.secondaryColour,
                                        }"
                                        style="cursor: pointer"
                                        >Speed (Low-High)</v-list-item-title
                                      >
                                    </v-list-item>
                                  </v-col>
                                </v-row>
                                <v-row>
                                  <v-col cols="12" sm="12">
                                    <v-list-item @click="sortpackages('SHTL')"
                                      ><v-list-item-title
                                        :style="{
                                          color: $store.state.currentOrg.orderSecondaryColour
                                            ? $store.state.currentOrg.orderSecondaryColour
                                            : $store.state.currentOrg.secondaryColour,
                                        }"
                                        style="cursor: pointer"
                                        >Speed (High-Low)</v-list-item-title
                                      >
                                    </v-list-item>
                                  </v-col>
                                </v-row>
                              </v-container>
                            </v-list>
                          </v-menu>
                        </v-col>
                      </v-row>
                    </v-container>
                    <v-container v-if="!this.$vuetify.breakpoint.xs">
                      <v-row>
                        <v-col cols="12" sm="12">
                          <v-menu offset-y open-on-hover>
                            <template v-slot:activator="{ on }">
                              <v-btn depressed block color="secondary" v-on="on" Large>
                                <h2
                                  style="color: white"
                                  :class="{
                                    mobileStep: $vuetify.breakpoint.xsOnly,
                                  }"
                                >
                                  SPEED <v-icon>arrow_drop_down</v-icon>
                                </h2>
                              </v-btn>
                            </template>
                            <v-list>
                              <v-container style="text-align: center">
                                <v-row>
                                  <v-col cols="12" sm="12">
                                    <v-list-item-title
                                      :style="{
                                        color: $store.state.currentOrg.orderSecondaryColour
                                          ? $store.state.currentOrg.orderSecondaryColour
                                          : $store.state.currentOrg.secondaryColour,
                                      }"
                                      class="px-2 subheading font-weight-bold"
                                      >Download Speed:</v-list-item-title
                                    >
                                  </v-col></v-row
                                >
                                <v-row>
                                  <v-col cols="12" sm="12">
                                    <v-range-slider
                                      class="px-5"
                                      :style="{
                                        color: $store.state.currentOrg.orderSecondaryColour
                                          ? $store.state.currentOrg.orderSecondaryColour
                                          : $store.state.currentOrg.secondaryColour,
                                      }"
                                      v-model="filter.speedDownload"
                                      style="font-size: 15px"
                                      :value="[0, 1]"
                                      :tick-labels="filter.downloadLabels"
                                      min="0"
                                      :max="filter.downloadLabels.length - 1"
                                      @change="
                                        filterPackageSpeeds(
                                          filter.downloadLabels[filter.speedDownload[0]],
                                          filter.downloadLabels[filter.speedDownload[1]],
                                          filter.uploadLabels[filter.speedUpload[0]],
                                          filter.uploadLabels[filter.speedUpload[1]]
                                        )
                                      "
                                    >
                                    </v-range-slider>
                                  </v-col>
                                </v-row>
                                <v-row>
                                  <v-col cols="12" sm="12">
                                    <v-list-item-title
                                      :style="{
                                        color: $store.state.currentOrg.orderSecondaryColour
                                          ? $store.state.currentOrg.orderSecondaryColour
                                          : $store.state.currentOrg.secondaryColour,
                                      }"
                                      class="px-2 subheading font-weight-bold"
                                      >Upload Speed:</v-list-item-title
                                    >
                                  </v-col>
                                </v-row>
                                <v-row>
                                  <v-col cols="12" sm="12">
                                    <v-range-slider
                                      class="px-5"
                                      :style="{
                                        color: $store.state.currentOrg.orderSecondaryColour
                                          ? $store.state.currentOrg.orderSecondaryColour
                                          : $store.state.currentOrg.secondaryColour,
                                      }"
                                      v-model="filter.speedUpload"
                                      style="font-size: 15px"
                                      :value="[0, 1]"
                                      :tick-labels="filter.uploadLabels"
                                      min="0"
                                      :max="filter.uploadLabels.length - 1"
                                      @change="
                                        filterPackageSpeeds(
                                          filter.downloadLabels[filter.speedDownload[0]],
                                          filter.downloadLabels[filter.speedDownload[1]],
                                          filter.uploadLabels[filter.speedUpload[0]],
                                          filter.uploadLabels[filter.speedUpload[1]]
                                        )
                                      "
                                    ></v-range-slider>
                                  </v-col>
                                </v-row>
                              </v-container>
                            </v-list>
                          </v-menu>
                        </v-col>
                      </v-row>
                    </v-container>
                    <v-container>
                      <v-row justify="center">
                        <v-col cols="12" sm="12">
                          <v-menu offset-y open-on-hover v-if="!$route.query.isp">
                            <template v-slot:activator="{ on }">
                              <v-btn depressed block color="secondary" v-on="on" Large>
                                <h2
                                  style="color: white"
                                  :class="{
                                    mobileStep: $vuetify.breakpoint.xsOnly,
                                  }"
                                >
                                  PROVIDER <v-icon>arrow_drop_down</v-icon>
                                </h2>
                              </v-btn>
                            </template>
                            <v-list>
                              <v-container>
                                <v-row>
                                  <v-col cols="12" sm="12">
                                    <v-list-item
                                      :style="{
                                        color: $store.state.currentOrg.orderSecondaryColour
                                          ? $store.state.currentOrg.orderSecondaryColour
                                          : $store.state.currentOrg.secondaryColour,
                                      }"
                                      style="cursor: pointer"
                                      @click="filterPackages('ISP', 'All')"
                                    >
                                      <v-list-item-title
                                        style="cursor: pointer"
                                        :style="{
                                          color: $store.state.currentOrg.orderSecondaryColour
                                            ? $store.state.currentOrg.orderSecondaryColour
                                            : $store.state.currentOrg.secondaryColour,
                                        }"
                                        >All ISP's</v-list-item-title
                                      >
                                    </v-list-item>
                                  </v-col></v-row
                                >
                                <v-row>
                                  <v-col cols="12" sm="12">
                                    <v-list-item
                                      style="cursor: pointer"
                                      v-for="x in providerList"
                                      :key="x.id"
                                      @click="filterPackages('ISP', x.name)"
                                    >
                                      <v-list-item-avatar tile size="60">
                                        <v-img contain :src="x.logo"></v-img>
                                      </v-list-item-avatar>
                                      <v-list-item-content>
                                        <v-list-item-title
                                          style="cursor: pointer"
                                          :style="{
                                            color: $store.state.currentOrg.orderSecondaryColour
                                              ? $store.state.currentOrg.orderSecondaryColour
                                              : $store.state.currentOrg.secondaryColour,
                                          }"
                                          >{{ x.name }}</v-list-item-title
                                        >
                                      </v-list-item-content>
                                    </v-list-item>
                                  </v-col></v-row
                                >
                              </v-container>
                            </v-list>
                          </v-menu>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-toolbar>
                </v-container>
                <v-toolbar
                  style="text-align: center"
                  flat
                  color="white"
                  v-if="
                  !req.query.isp &&
                    !this.$vuetify.breakpoint.xs &&
                      flags.hasBusinessPacks &&
                      this.detail.internetPackageSelected === true &&
                      this.detail.address.estate != null
                  "
                >
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="12">
                        <v-menu offset-y open-on-hover>
                          <template v-slot:activator="{ on }">
                            <v-btn
                              block
                              depressed
                              :style="{
                                color: $store.state.currentOrg.orderSecondaryColour
                                  ? $store.state.currentOrg.orderSecondaryColour
                                  : $store.state.currentOrg.secondaryColour,
                              }"
                              v-on="on"
                              medium
                            >
                              <h2
                                style="color: white"
                                :class="{
                                  mobileStep: $vuetify.breakpoint.xsOnly,
                                }"
                              >
                                SORT<v-icon>arrow_drop_down</v-icon>
                              </h2>
                            </v-btn>
                          </template>
                          <v-list>
                            <v-container style="text-align: center">
                              <v-row>
                                <v-col cols="12" sm="12">
                                  <v-list-item @click="sortpackages('PLTH')"
                                    ><v-list-item-title
                                      :style="{
                                        color: $store.state.currentOrg.orderSecondaryColour
                                          ? $store.state.currentOrg.orderSecondaryColour
                                          : $store.state.currentOrg.secondaryColour,
                                      }"
                                      style="cursor: pointer"
                                      >Price (Low-High)</v-list-item-title
                                    >
                                  </v-list-item>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" sm="12">
                                  <v-list-item @click="sortpackages('PHTL')"
                                    ><v-list-item-title
                                      :style="{
                                        color: $store.state.currentOrg.orderSecondaryColour
                                          ? $store.state.currentOrg.orderSecondaryColour
                                          : $store.state.currentOrg.secondaryColour,
                                      }"
                                      style="cursor: pointer"
                                      >Price (High-Low)</v-list-item-title
                                    >
                                  </v-list-item>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" sm="12">
                                  <v-list-item @click="sortpackages('SLTH')"
                                    ><v-list-item-title
                                      :style="{
                                        color: $store.state.currentOrg.orderSecondaryColour
                                          ? $store.state.currentOrg.orderSecondaryColour
                                          : $store.state.currentOrg.secondaryColour,
                                      }"
                                      style="cursor: pointer"
                                      >Speed (Low-High)</v-list-item-title
                                    >
                                  </v-list-item>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" sm="12">
                                  <v-list-item @click="sortpackages('SHTL')"
                                    ><v-list-item-title
                                      :style="{
                                        color: $store.state.currentOrg.orderSecondaryColour
                                          ? $store.state.currentOrg.orderSecondaryColour
                                          : $store.state.currentOrg.secondaryColour,
                                      }"
                                      style="cursor: pointer"
                                      >Speed (High-Low)</v-list-item-title
                                    >
                                  </v-list-item>
                                </v-col>
                              </v-row>
                            </v-container>
                          </v-list>
                        </v-menu>
                      </v-col>
                    </v-row>
                  </v-container>

                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="12">
                        <v-menu offset-y open-on-hover>
                          <template v-slot:activator="{ on }">
                            <v-btn
                              depressed
                              block
                              :style="{
                                color: $store.state.currentOrg.orderSecondaryColour
                                  ? $store.state.currentOrg.orderSecondaryColour
                                  : $store.state.currentOrg.secondaryColour,
                              }"
                              v-on="on"
                              medium
                            >
                              <h2
                                style="color: white"
                                :class="{
                                  mobileStep: $vuetify.breakpoint.xsOnly,
                                }"
                              >
                                SPEED <v-icon>arrow_drop_down</v-icon>
                              </h2>
                            </v-btn>
                          </template>

                          <v-list>
                            <v-container style="text-align: center">
                              <v-row>
                                <v-col cols="12" sm="12">
                                  <v-list-item-title
                                    :style="{
                                      color: $store.state.currentOrg.orderSecondaryColour
                                        ? $store.state.currentOrg.orderSecondaryColour
                                        : $store.state.currentOrg.secondaryColour,
                                    }"
                                    class="px-2 pt-1 pb-2subheading font-weight-bold"
                                    >Download Speed:</v-list-item-title
                                  >
                                </v-col></v-row
                              >

                              <v-row>
                                <v-col cols="12" sm="12">
                                  <v-range-slider
                                    v-model="filter.speedDownload"
                                    :style="{
                                      color: $store.state.currentOrg.orderSecondaryColour
                                        ? $store.state.currentOrg.orderSecondaryColour
                                        : $store.state.currentOrg.secondaryColour,
                                    }"
                                    style="font-size: 15px"
                                    :value="[0, 1]"
                                    :close-on-content-click="false"
                                    :tick-labels="filter.downloadLabels"
                                    min="0"
                                    :max="filter.downloadLabels.length - 1"
                                    @change="
                                      filterPackageSpeeds(
                                        filter.downloadLabels[filter.speedDownload[0]],
                                        filter.downloadLabels[filter.speedDownload[1]],
                                        filter.uploadLabels[filter.speedUpload[0]],
                                        filter.uploadLabels[filter.speedUpload[1]]
                                      )
                                    "
                                  >
                                  </v-range-slider>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" sm="12">
                                  <v-list-item-title
                                    :style="{
                                      color: $store.state.currentOrg.orderSecondaryColour
                                        ? $store.state.currentOrg.orderSecondaryColour
                                        : $store.state.currentOrg.secondaryColour,
                                    }"
                                    class="px-2 pt-1 pb-2 subheading font-weight-bold"
                                    >Upload Speed:</v-list-item-title
                                  >
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" sm="12">
                                  <v-range-slider
                                    :style="{
                                      color: $store.state.currentOrg.orderSecondaryColour
                                        ? $store.state.currentOrg.orderSecondaryColour
                                        : $store.state.currentOrg.secondaryColour,
                                    }"
                                    v-model="filter.speedUpload"
                                    style="font-size: 15px"
                                    :value="[0, 1]"
                                    :tick-labels="filter.uploadLabels"
                                    min="0"
                                    :max="filter.uploadLabels.length - 1"
                                    @change="
                                      filterPackageSpeeds(
                                        filter.downloadLabels[filter.speedDownload[0]],
                                        filter.downloadLabels[filter.speedDownload[1]],
                                        filter.uploadLabels[filter.speedUpload[0]],
                                        filter.uploadLabels[filter.speedUpload[1]]
                                      )
                                    "
                                  ></v-range-slider>
                                </v-col>
                              </v-row>
                            </v-container>
                          </v-list>
                        </v-menu>
                      </v-col>
                    </v-row>
                  </v-container>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="12">
                        <v-menu offset-y open-on-hover v-if="!$route.query.isp">
                          <template v-slot:activator="{ on }">
                            <v-btn
                              depressed
                              block
                              :style="{
                                color: $store.state.currentOrg.orderSecondaryColour
                                  ? $store.state.currentOrg.orderSecondaryColour
                                  : $store.state.currentOrg.secondaryColour,
                              }"
                              v-on="on"
                              medium
                            >
                              <h2
                                style="color: white"
                                :class="{
                                  mobileStep: $vuetify.breakpoint.xsOnly,
                                }"
                              >
                                PROVIDER <v-icon>arrow_drop_down</v-icon>
                              </h2>
                            </v-btn>
                          </template>
                          <v-list>
                            <v-container
                              :style="{
                                color: $store.state.currentOrg.orderSecondaryColour
                                  ? $store.state.currentOrg.orderSecondaryColour
                                  : $store.state.currentOrg.secondaryColour,
                              }"
                            >
                              <v-row>
                                <v-col cols="12" sm="12">
                                  <v-list-item
                                    :style="{
                                      color: $store.state.currentOrg.orderSecondaryColour
                                        ? $store.state.currentOrg.orderSecondaryColour
                                        : $store.state.currentOrg.secondaryColour,
                                    }"
                                    style="cursor: pointer"
                                    @click="filterPackages('ISP', 'All')"
                                  >
                                    <v-list-item-title
                                      style="cursor: pointer"
                                      :style="{
                                        color: $store.state.currentOrg.orderSecondaryColour
                                          ? $store.state.currentOrg.orderSecondaryColour
                                          : $store.state.currentOrg.secondaryColour,
                                      }"
                                      >All ISP's</v-list-item-title
                                    ></v-list-item
                                  >
                                </v-col></v-row
                              >
                              <v-row>
                                <v-col cols="12" sm="12">
                                  <v-list-item
                                    style="cursor: pointer"
                                    v-for="x in providerList"
                                    :key="x.id"
                                    @click="filterPackages('ISP', x.name)"
                                  >
                                    <v-list-item-avatar tile size="60">
                                      <v-img contain :src="x.logo"></v-img>
                                    </v-list-item-avatar>
                                    <v-list-item-content>
                                      <v-list-item-title
                                        style="cursor: pointer"
                                        :style="{
                                          color: $store.state.currentOrg.orderSecondaryColour
                                            ? $store.state.currentOrg.orderSecondaryColour
                                            : $store.state.currentOrg.secondaryColour,
                                        }"
                                        >{{ x.name }}</v-list-item-title
                                      >
                                    </v-list-item-content>
                                  </v-list-item>
                                </v-col></v-row
                              >
                            </v-container>
                          </v-list>
                        </v-menu>
                      </v-col>
                    </v-row>
                  </v-container>

                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="12">
                        <v-menu offset-y open-on-hover v-if="flags.hasBusinessPacks">
                          <template v-slot:activator="{ on }">
                            <v-btn
                              depressed
                              block
                              :style="{
                                color: $store.state.currentOrg.orderSecondaryColour
                                  ? $store.state.currentOrg.orderSecondaryColour
                                  : $store.state.currentOrg.secondaryColour,
                              }"
                              v-on="on"
                              medium
                            >
                              <h2
                                style="color: white"
                                :class="{
                                  'width:20px': $vuetify.breakpoint.xs,
                                }"
                              >
                                Type<v-icon>arrow_drop_down</v-icon>
                              </h2>
                            </v-btn>
                          </template>
                          <v-list>
                            <v-container
                              :style="{
                                color: $store.state.currentOrg.orderSecondaryColour
                                  ? $store.state.currentOrg.orderSecondaryColour
                                  : $store.state.currentOrg.secondaryColour,
                              }"
                              style="text-align: left"
                            >
                              <v-row>
                                <v-col cols="12" sm="12">
                                  <v-list-item
                                    :style="{
                                      color: $store.state.currentOrg.orderSecondaryColour
                                        ? $store.state.currentOrg.orderSecondaryColour
                                        : $store.state.currentOrg.secondaryColour,
                                    }"
                                    style="cursor: pointer"
                                    @click="filterPackageTypes('All')"
                                  >
                                    <v-list-item-title
                                      style="cursor: pointer"
                                      :style="{
                                        color: $store.state.currentOrg.orderSecondaryColour
                                          ? $store.state.currentOrg.orderSecondaryColour
                                          : $store.state.currentOrg.secondaryColour,
                                      }"
                                      >All Packages</v-list-item-title
                                    ></v-list-item
                                  >
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" sm="12">
                                  <v-list-item
                                    :style="{
                                      color: $store.state.currentOrg.orderSecondaryColour
                                        ? $store.state.currentOrg.orderSecondaryColour
                                        : $store.state.currentOrg.secondaryColour,
                                    }"
                                    style="cursor: pointer"
                                    @click="filterPackageTypes('Residential')"
                                  >
                                    <v-list-item-title
                                      style="cursor: pointer"
                                      :style="{
                                        color: $store.state.currentOrg.orderSecondaryColour
                                          ? $store.state.currentOrg.orderSecondaryColour
                                          : $store.state.currentOrg.secondaryColour,
                                      }"
                                      >Residential Packages</v-list-item-title
                                    ></v-list-item
                                  >
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" sm="12">
                                  <v-list-item
                                    :style="{
                                      color: $store.state.currentOrg.orderSecondaryColour
                                        ? $store.state.currentOrg.orderSecondaryColour
                                        : $store.state.currentOrg.secondaryColour,
                                    }"
                                    style="cursor: pointer"
                                    @click="filterPackageTypes('Business')"
                                  >
                                    <v-list-item-title
                                      style="cursor: pointer"
                                      :style="{
                                        color: $store.state.currentOrg.orderSecondaryColour
                                          ? $store.state.currentOrg.orderSecondaryColour
                                          : $store.state.currentOrg.secondaryColour,
                                      }"
                                      >Business Packages</v-list-item-title
                                    ></v-list-item
                                  >
                                </v-col>
                              </v-row>
                            </v-container>
                          </v-list>
                        </v-menu>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-toolbar>

                <v-toolbar style="text-align: center" flat color="white" v-if="this.$vuetify.breakpoint.xs">
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="12">
                        <v-menu offset-y open-on-hover :close-on-content-click="false">
                          <template v-slot:activator="{ on }">
                            <v-btn block depressed color="secondary" v-on="on" medium>
                              <h2
                                style="color: white"
                                :class="{
                                  mobileStep: $vuetify.breakpoint.xsOnly,
                                }"
                              >
                                SORT <v-icon>arrow_drop_down</v-icon>
                              </h2>
                            </v-btn>
                          </template>
                          <v-list>
                            <v-list-group v-for="item in priceListGroup" :key="item.title" no-action>
                              <template v-slot:activator>
                                <v-list-item-content>
                                  <v-list-item-title
                                    style="text-align: center"
                                    :style="{
                                      color: $store.state.currentOrg.orderSecondaryColour
                                        ? $store.state.currentOrg.orderSecondaryColour
                                        : $store.state.currentOrg.secondaryColour,
                                    }"
                                    v-text="item.title"
                                  ></v-list-item-title>
                                </v-list-item-content>
                              </template>
                              <v-list>
                                <v-container
                                  :style="{
                                    color: $store.state.currentOrg.orderSecondaryColour
                                      ? $store.state.currentOrg.orderSecondaryColour
                                      : $store.state.currentOrg.secondaryColour,
                                  }"
                                >
                                  <v-row>
                                    <v-col cols="12" sm="12">
                                      <v-list-item @click="sortpackages('PLTH')"
                                        ><v-list-item-title
                                          :style="{
                                            color: $store.state.currentOrg.orderSecondaryColour
                                              ? $store.state.currentOrg.orderSecondaryColour
                                              : $store.state.currentOrg.secondaryColour,
                                          }"
                                          style="
                                            text-align: center;
                                            cursor: pointer;
                                          "
                                          >Price (Low-High)</v-list-item-title
                                        >
                                      </v-list-item>
                                    </v-col>
                                  </v-row>
                                  <v-row>
                                    <v-col cols="12" sm="12">
                                      <v-list-item @click="sortpackages('PHTL')"
                                        ><v-list-item-title
                                          :style="{
                                            color: $store.state.currentOrg.orderSecondaryColour
                                              ? $store.state.currentOrg.orderSecondaryColour
                                              : $store.state.currentOrg.secondaryColour,
                                          }"
                                          style="
                                            text-align: center;
                                            cursor: pointer;
                                          "
                                          >Price (High-Low)</v-list-item-title
                                        >
                                      </v-list-item>
                                    </v-col>
                                  </v-row>
                                </v-container>
                              </v-list>
                            </v-list-group>

                            <v-list-group v-for="item in speedListGroup" :key="item.title" no-action>
                              <template v-slot:activator>
                                <v-list-item-content>
                                  <v-list-item-title
                                    style="text-align: center"
                                    :style="{
                                      color: $store.state.currentOrg.orderSecondaryColour
                                        ? $store.state.currentOrg.orderSecondaryColour
                                        : $store.state.currentOrg.secondaryColour,
                                    }"
                                    v-text="item.title"
                                  ></v-list-item-title>
                                </v-list-item-content>
                              </template>
                              <v-list>
                                <v-container
                                  :style="{
                                    color: $store.state.currentOrg.orderSecondaryColour
                                      ? $store.state.currentOrg.orderSecondaryColour
                                      : $store.state.currentOrg.secondaryColour,
                                  }"
                                >
                                  <v-row>
                                    <v-col cols="12" sm="12">
                                      <v-list-item @click="sortpackages('SLTH')"
                                        ><v-list-item-title
                                          :style="{
                                            color: $store.state.currentOrg.orderSecondaryColour
                                              ? $store.state.currentOrg.orderSecondaryColour
                                              : $store.state.currentOrg.secondaryColour,
                                          }"
                                          style="
                                            text-align: center;
                                            cursor: pointer;
                                          "
                                          >Speed (Low-High)</v-list-item-title
                                        >
                                      </v-list-item>
                                    </v-col>
                                  </v-row>
                                  <v-row>
                                    <v-col cols="12" sm="12">
                                      <v-list-item @click="sortpackages('SHTL')"
                                        ><v-list-item-title
                                          :style="{
                                            color: $store.state.currentOrg.orderSecondaryColour
                                              ? $store.state.currentOrg.orderSecondaryColour
                                              : $store.state.currentOrg.secondaryColour,
                                          }"
                                          style="
                                            text-align: center;
                                            cursor: pointer;
                                          "
                                          >Speed (High-Low)</v-list-item-title
                                        >
                                      </v-list-item>
                                    </v-col>
                                  </v-row>
                                </v-container>
                              </v-list>
                            </v-list-group>

                            <v-list-group v-for="item in providerListGroup" :key="item.title" no-action>
                              <template v-slot:activator>
                                <v-list-item-content>
                                  <v-list-item-title
                                    style="text-align: center"
                                    :style="{
                                      color: $store.state.currentOrg.orderSecondaryColour
                                        ? $store.state.currentOrg.orderSecondaryColour
                                        : $store.state.currentOrg.secondaryColour,
                                    }"
                                    v-text="item.title"
                                  ></v-list-item-title>
                                </v-list-item-content>
                              </template>
                              <v-list>
                                <v-container
                                  :style="{
                                    color: $store.state.currentOrg.orderSecondaryColour
                                      ? $store.state.currentOrg.orderSecondaryColour
                                      : $store.state.currentOrg.secondaryColour,
                                  }"
                                >
                                  <v-row>
                                    <v-col cols="12" sm="12">
                                      <v-list-item
                                        :style="{
                                          color: $store.state.currentOrg.orderSecondaryColour
                                            ? $store.state.currentOrg.orderSecondaryColour
                                            : $store.state.currentOrg.secondaryColour,
                                        }"
                                        style="
                                          text-align: center;
                                          cursor: pointer;
                                        "
                                        @click="filterPackages('ISP', 'All')"
                                      >
                                        <v-list-item-title
                                          style="cursor: pointer"
                                          :style="{
                                            color: $store.state.currentOrg.orderSecondaryColour
                                              ? $store.state.currentOrg.orderSecondaryColour
                                              : $store.state.currentOrg.secondaryColour,
                                          }"
                                          >All ISP's</v-list-item-title
                                        ></v-list-item
                                      >
                                    </v-col></v-row
                                  >
                                  <v-row>
                                    <v-col cols="12" sm="12">
                                      <v-list-item
                                        style="
                                          text-align: center;
                                          cursor: pointer;
                                        "
                                        v-for="x in providerList"
                                        :key="x.id"
                                        @click="filterPackages('ISP', x.name)"
                                      >
                                        <v-row>
                                          <v-col cols="12" sm="12">
                                            <v-list-item-content>
                                              <v-list-item-title
                                                style="
                                                  text-align: center;
                                                  cursor: pointer;
                                                "
                                                :style="{
                                                  color: $store.state.currentOrg.orderSecondaryColour
                                                    ? $store.state.currentOrg.orderSecondaryColour
                                                    : $store.state.currentOrg.secondaryColour,
                                                }"
                                                >{{ x.name }}</v-list-item-title
                                              >
                                            </v-list-item-content>
                                          </v-col></v-row
                                        >
                                      </v-list-item>
                                    </v-col></v-row
                                  >
                                </v-container>
                              </v-list>
                            </v-list-group>
                          </v-list>
                        </v-menu>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-toolbar>

                <v-container v-if="this.$vuetify.breakpoint.name == 'xl'">
                  <v-row class="justify-center">
                    <v-col cols="12" sm="10">
                      <v-card flat min-width="700px">
                        <v-form>
                          <PackagesIspsCards
                            :keepColor="borderId"
                            :cardsPerPage="12"
                            :packagesIsps="packagesIsps"
                            @selectPackage="selectPackage"
                            :preSelectedPackage="detail.selectedInternetPackage"
                          ></PackagesIspsCards>
                        </v-form>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-container>

                <v-container v-if="this.$vuetify.breakpoint.name == 'lg'">
                  <v-row>
                    <v-col cols="12" sm="12">
                      <v-card flat min-width="400px">
                        <v-form>
                          <PackagesIspsCards
                            :keepColor="borderId"
                            :cardsPerPage="12"
                            :packagesIsps="packagesIsps"
                            @selectPackage="selectPackage"
                            :preSelectedPackage="detail.selectedInternetPackage"
                          ></PackagesIspsCards>
                        </v-form>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-container>

                <v-container v-if="this.$vuetify.breakpoint.name == 'md'">
                  <v-row>
                    <v-col cols="12" sm="12">
                      <v-card flat>
                        <v-form>
                          <PackagesIspsCards
                            :keepColor="borderId"
                            :sizeScreen="this.$vuetify.breakpoint.name"
                            :cardsPerPage="8"
                            :packagesIsps="packagesIsps"
                            @selectPackage="selectPackage"
                            :preSelectedPackage="detail.selectedInternetPackage"
                          ></PackagesIspsCards>
                        </v-form>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-container>

                <v-container v-if="this.$vuetify.breakpoint.name == 'sm'">
                  <v-row>
                    <v-col cols="12" sm="12">
                      <v-card flat>
                        <v-form>
                          <PackagesIspsCards
                            :keepColor="borderId"
                            :sizeScreen="this.$vuetify.breakpoint.name"
                            :cardsPerPage="6"
                            :packagesIsps="packagesIsps"
                            @selectPackage="selectPackage"
                            :preSelectedPackage="detail.selectedInternetPackage"
                          ></PackagesIspsCards>
                        </v-form>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-container>

                <v-container style="padding-left: 0px" v-if="this.$vuetify.breakpoint.name == 'xs'">
                  <v-row>
                    <v-col cols="12" sm="12">
                      <v-card flat style="padding-left: 0px">
                        <v-form>
                          <PackagesIspsCards
                            :keepColor="borderId"
                            :sizeScreen="this.$vuetify.breakpoint.name"
                            :cardsPerPage="6"
                            :packagesIsps="packagesIsps"
                            @selectPackage="selectPackage"
                            :preSelectedPackage="detail.selectedInternetPackage"
                          ></PackagesIspsCards>
                        </v-form>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-container>

                <!-- <h2
                  style="text-align: center"
                  :style="{ color: $store.state.currentOrg.orderSecondaryColour }"
                >
                  Other ISPs on the network
                </h2>

                <v-carousel
                  light
                  cycle
                  height="300"
                  hide-delimiter-background
                  show-arrows-on-hover
                >
                  <v-carousel-item v-for="item in customerList" :key="item.id">
                    <v-sheet color="white" height="100%">
                      <v-row
                        class="fill-height"
                        align="center"
                        justify="center"
                      >
                        <div
                          hover
                          style="cursor: pointer"
                          height="210px"
                          @click="goToWebUrl(item.websiteUrl)"
                          :id="item.id"
                        >
                          <v-responsive class="px-2">
                            <v-img
                              :src="item.logo"
                              max-height="50"
                              aspect-ratio="1.4"
                              contain
                            ></v-img>
                          </v-responsive>
                          <v-card-text>
                            <h3
                              v-if="item.customerSupportTelephone"
                              style="text-align: center; font-size: 17px"
                              :style="{ color: $store.state.currentOrg.orderSecondaryColour }"
                            >
                              <v-icon size="medium">phone</v-icon>
                              {{ item.customerSupportTelephone }}
                            </h3>
                            <h3
                              v-if="item.salesEmailAddress"
                              style="text-align: center; font-size: 17px"
                              :style="{ color: $store.state.currentOrg.orderSecondaryColour }"
                            >
                              <v-icon size="medium">mail</v-icon>
                              {{ item.salesEmailAddress }}
                            </h3>
                            <h3
                              v-if="item.websiteUrl"
                              style="text-align: center; font-size: 17px"
                              :style="{ color: $store.state.currentOrg.orderSecondaryColour }"
                            >
                              <v-icon size="medium">language</v-icon>
                              {{ item.websiteUrl }}
                            </h3>
                          </v-card-text>
                        </div>
                      </v-row>
                    </v-sheet>
                  </v-carousel-item>
                </v-carousel> -->

                <v-toolbar :dense="true" :flat="true">
                  <v-btn medium rounded @click="setHeaderModal('previous', 'choosePackage', false)" color="primary"
                    ><v-icon>chevron_left</v-icon>PREVIOUS</v-btn
                  >
                  <div class="flex-grow-1"></div>
                  <v-btn
                    medium
                    v-if="this.max == calculateMaxModal('choosePackage')"
                    rounded
                    @click="setHeaderModal('next', 'choosePackage', true)"
                    color="primary"
                    >NEXT<v-icon>chevron_right</v-icon></v-btn
                  >
                  <v-btn
                    medium
                    v-else-if="this.max != calculateMaxModal('choosePackage')"
                    rounded
                    @click="setHeaderModal('next', 'choosePackage', false)"
                    color="primary"
                    >NEXT<v-icon>chevron_right</v-icon></v-btn
                  >
                </v-toolbar>
              </v-card>
            </v-stepper-content>

            <v-stepper-content :step="calculateStepContent('chooseAdditional')" v-if="productCards.length > 0">
              <!-- Activation Date -->
              <v-card
                flat
                :class="{
                  mobileStep: $vuetify.breakpoint.xsOnly,
                  'compact-form': $vuetify.breakpoint.smAndUp,
                }"
                v-if="chooseAdditional"
              >
                <v-container style="text-align: center">
                  <h2
                    :style="{
                      color: $store.state.currentOrg.orderPrimaryColour
                        ? $store.state.currentOrg.orderPrimaryColour
                        : $store.state.currentOrg.primaryColour,
                    }"
                  >
                    SELECT ADDITIONAL PRODUCTS
                  </h2>
                </v-container>
                <v-container style="text-align: center" v-if="productCards.length == 0">
                  <h3
                    :style="{
                      color: $store.state.currentOrg.orderSecondaryColour
                        ? $store.state.currentOrg.orderSecondaryColour
                        : $store.state.currentOrg.secondaryColour,
                    }"
                  >
                    There are no additional products available on this network
                  </h3>
                </v-container>
                <v-container v-if="this.$vuetify.breakpoint.name == 'xl' && productCards.length > 0">
                  <v-row class="justify-center">
                    <v-col cols="12" sm="10">
                      <v-card flat min-width="700px">
                        <v-form>
                          <ProductCards
                            :cardsPerPage="12"
                            :productCards="productCards"
                            @selectProduct="selectProduct"
                          ></ProductCards>
                        </v-form>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-container>

                <v-container v-if="this.$vuetify.breakpoint.name == 'lg' && productCards.length > 0">
                  <v-row>
                    <v-col cols="12" sm="12">
                      <v-card flat min-width="400px">
                        <v-form>
                          <ProductCards
                            :cardsPerPage="12"
                            :productCards="productCards"
                            @selectProduct="selectProduct"
                          ></ProductCards>
                        </v-form>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-container>

                <v-container v-if="this.$vuetify.breakpoint.name == 'md' && productCards.length > 0">
                  <v-row>
                    <v-col cols="12" sm="12">
                      <v-card flat>
                        <v-form>
                          <ProductCards
                            :sizeScreen="this.$vuetify.breakpoint.name"
                            :cardsPerPage="8"
                            :productCards="productCards"
                            @selectProduct="selectProduct"
                          ></ProductCards>
                        </v-form>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-container>

                <v-container v-if="this.$vuetify.breakpoint.name == 'sm' && productCards.length > 0">
                  <v-row>
                    <v-col cols="12" sm="12">
                      <v-card flat>
                        <v-form>
                          <ProductCards
                            :sizeScreen="this.$vuetify.breakpoint.name"
                            :cardsPerPage="6"
                            :productCards="productCards"
                            @selectProduct="selectProduct"
                          ></ProductCards>
                        </v-form>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-container>

                <v-container
                  style="padding-left: 0px"
                  v-if="this.$vuetify.breakpoint.name == 'xs' && productCards.length > 0"
                >
                  <v-row>
                    <v-col cols="12" sm="12">
                      <v-card flat style="padding-left: 0px">
                        <v-form>
                          <ProductCards
                            :sizeScreen="this.$vuetify.breakpoint.name"
                            :cardsPerPage="4"
                            :productCards="productCards"
                            @selectProduct="selectProduct"
                          ></ProductCards>
                        </v-form>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-container>

                <v-toolbar :dense="true" :flat="true">
                  <v-btn medium rounded @click="setHeaderModal('previous', 'chooseAdditional', false)" color="primary"
                    ><v-icon>chevron_left</v-icon>PREVIOUS</v-btn
                  >
                  <div class="flex-grow-1"></div>

                  <v-btn
                    medium
                    v-if="this.max == calculateMaxModal('chooseAdditional')"
                    rounded
                    @click="setHeaderModal('next', 'chooseAdditional', true)"
                    color="primary"
                    >NEXT<v-icon>chevron_right</v-icon></v-btn
                  >
                  <v-btn
                    medium
                    v-else-if="this.max != calculateMaxModal('chooseAdditional')"
                    rounded
                    @click="setHeaderModal('next', 'chooseAdditional', false)"
                    color="primary"
                    >NEXT<v-icon>chevron_right</v-icon></v-btn
                  >
                </v-toolbar>
              </v-card>
            </v-stepper-content>

            <v-stepper-content :step="calculateStepContent('chooseContact')">
              <v-card
                flat
                :class="{
                  mobileStep: $vuetify.breakpoint.xsOnly,
                  'compact-form': $vuetify.breakpoint.smAndUp,
                }"
                v-if="chooseContact && !$vuetify.breakpoint.xsOnly && !$vuetify.breakpoint.smOnly"
              >
                <v-row style="text-align: center" row wrap>
                  <v-col cols="12" sm="12">
                    <h2
                      :style="{
                        color: $store.state.currentOrg.orderPrimaryColour
                          ? $store.state.currentOrg.orderPrimaryColour
                          : $store.state.currentOrg.primaryColour,
                      }"
                    >
                      CONTACT INFORMATION
                    </h2>
                  </v-col>

                  <v-row>
                    <v-col cols="12" sm="12">
                      <v-form style="text-align: center">
                        <v-container>
                          <v-row justify="center" >
                            <v-col cols="12" sm="4" class="text-center">
                              <h2
                                v-if="!$vuetify.breakpoint.xsOnly"
                                class="input-flex-min-space"
                                :style="{
                                  color: $store.state.currentOrg.orderSecondaryColour
                                    ? $store.state.currentOrg.orderSecondaryColour
                                    : $store.state.currentOrg.secondaryColour,
                                }"
                              >
                                Primary Contact Info
                              </h2>
                              <v-row>
                                <v-col cols="12" sm="12">
                                  <v-select
                                    v-model="detail.primaryContact.title"
                                    :items="titles"
                                    @change="checkProceedToSummary()"
                                    :rules="titleRules"
                                    label="Title*"
                                  >
                                  </v-select>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" sm="12">
                                  <v-text-field
                                    v-model="detail.primaryContact.firstName"
                                    label="First Name* "
                                    :rules="nameRules"
                                    class="input-flex-min-space"
                                  >
                                  </v-text-field>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" sm="12">
                                  <v-text-field
                                    v-model="detail.primaryContact.lastName"
                                    label="Last Name*"
                                    :rules="surnameRules"
                                    class="input-flex-min-space"
                                  >
                                  </v-text-field>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" sm="12">
                                  <v-text-field
                                    class="input-flex-min-space"
                                    v-model="detail.primaryContact.contactNumber"
                                    :rules="contactNumberRules"
                                    label="Contact Number*"
                                  >
                                  </v-text-field>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" sm="12" v-if="verifyEmailComplete">
                                  <v-text-field
                                    class="input-flex-min-space"
                                    v-model="detail.primaryContact.emailAddress"
                                    :rules="emailRules"
                                    persistent-hint
                                    :key="keyEmail"
                                    :hint="
                                      isSuccessful === false ? 'Verification Unsuccessful.' : 'Verification Successful!'
                                    "
                                    label="Email Address*"
                                    @change="(isSuccessful = false), (verifyEmailComplete = false)"
                                  >
                                  </v-text-field>
                                </v-col>
                                <v-col cols="12" sm="12" v-else-if="!verifyEmailComplete && isSuccessful == false">
                                  <v-text-field
                                    class="input-flex-min-space"
                                    v-model="detail.primaryContact.emailAddress"
                                    :rules="emailRules"
                                    persistent-hint
                                    :key="keyEmail"
                                    :hint="verifyResult"
                                    label="Email Address*"
                                  >
                                  </v-text-field>
                                </v-col>
                                <v-col cols="12" sm="12" v-else-if="!verifyEmailComplete && isSuccessful == null">
                                  <v-text-field
                                    class="input-flex-min-space"
                                    :key="keyEmail"
                                    v-model="detail.primaryContact.emailAddress"
                                    :rules="emailRules"
                                    label="Email Address*"
                                  >
                                  </v-text-field>
                                </v-col>
                              </v-row>
                              <v-row v-if="!verifyEmailComplete">
                                <v-col cols="7" style="text-align: left">
                                  <h3
                                    style="text-align: left"
                                    class="mt-1"
                                    :style="{
                                      color: $store.state.currentOrg.orderSecondaryColour
                                        ? $store.state.currentOrg.orderSecondaryColour
                                        : $store.state.currentOrg.secondaryColour,
                                    }"
                                  >
                                    Email Verification
                                    <span
                                      style="font-weight: normal"
                                      :style="{
                                        color: $store.state.currentOrg.orderSecondaryColour
                                          ? $store.state.currentOrg.orderSecondaryColour
                                          : $store.state.currentOrg.secondaryColour,
                                      }"
                                    >
                                      (One Time Pin)</span
                                    >
                                  </h3>
                                  <span
                                    v-if="firstOtp > 0"
                                    style="text-align: left"
                                    :style="{
                                      color: $store.state.currentOrg.orderSecondaryColour
                                        ? $store.state.currentOrg.orderSecondaryColour
                                        : $store.state.currentOrg.secondaryColour,
                                    }"
                                  >
                                    Please check your email for the code
                                  </span>
                                </v-col>
                                <v-col
                                  class="justify-center align-center"
                                  cols="5"
                                  v-if="validateEmail() == true && !verifyEmailComplete"
                                >
                                  <v-btn
                                    rounded
                                    v-if="firstOtp == 0"
                                    @click="sendOtp(detail.primaryContact.emailAddress)"
                                    color="primary"
                                    >Send OTP</v-btn
                                  >
                                  <v-btn
                                    rounded
                                    v-if="firstOtp > 0"
                                    @click="sendOtp(detail.primaryContact.emailAddress)"
                                    color="primary"
                                    >Resend OTP</v-btn
                                  >
                                </v-col>
                                <v-col cols="5" v-else-if="!verifyEmailComplete">
                                  <v-btn
                                    disabled
                                    rounded
                                    @click="sendOtp(detail.primaryContact.emailAddress)"
                                    color="primary"
                                    >Send OTP</v-btn
                                  >
                                </v-col>
                              </v-row>

                              <v-row class="justify-center">
                                <v-otp-input
                                  v-if="!isSuccessful"
                                  ref="otpInput"
                                  separator="-"
                                  input-classes="otp-input"
                                  :num-inputs="4"
                                  :is-input-num="true"
                                  @on-complete="onComplete($event)"
                                />
                              </v-row>

                              <v-row>
                                <v-col cols="12" sm="12">
                                  <v-text-field
                                    class="input-flex-min-space"
                                    v-model="detail.primaryContact.idNumber"
                                    :rules="idNumberRules"
                                    label="ID Number*"
                                  >
                                  </v-text-field>
                                </v-col>
                              </v-row>
                            </v-col>

                      <v-col class="text-center" cols="12" sm="4" v-if="detail.showInterest">
                              <v-checkbox v-model="termsSignedShowInterest">
                                <template v-slot:label>
                                  <v-form style="text-align: left" class="subheading">
                                    I accept the {{ org.name }}
                                    <v-tooltip bottom>
                                      <template v-slot:activator="{ on }">
                                        <v-btn v-if="fnoTerms" text color="primary" @click="viewFnoTerms = true">
                                          Terms and Conditions
                                        </v-btn>
                                        <a
                                          v-else
                                          target="_blank"
                                          :href="org.termsAndConditionsLink"
                                          @click.stop
                                          v-on="on"
                                        >
                                          Terms and Conditions
                                        </a>
                                      </template>
                                      Opens link to T&C's in new window
                                    </v-tooltip>
                                  </v-form>
                                </template>
                              </v-checkbox>
                            
                              <v-checkbox v-model="agreeShareDetails">
                                <template v-slot:label>
                                  <v-form style="text-align: left" class="subheading">
                                    I agree to Fibre Geeks sharing my contact details with the ISPs on their network
                                  </v-form>
                                </template>
                              </v-checkbox>
                            </v-col>

                            <v-col v-if="this.detail.showSecondaryContact == true && !detail.showInterest" cols="12" sm="4">
                              <h2
                                :style="{
                                  color: $store.state.currentOrg.orderSecondaryColour
                                    ? $store.state.currentOrg.orderSecondaryColour
                                    : $store.state.currentOrg.secondaryColour,
                                }"
                              >
                                Secondary Contact Info
                              </h2>
                              <v-row>
                                <v-col cols="12" sm="12">
                                  <v-select
                                    class="input-flex-min-space"
                                    v-model="detail.secondaryContact.title"
                                    :items="titles"
                                    :rules="titleRules"
                                    label="Title* "
                                  >
                                  </v-select>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" sm="12">
                                  <v-text-field
                                    class="input-flex-min-space"
                                    v-model="detail.secondaryContact.firstName"
                                    :rules="nameRules"
                                    label="First Name* "
                                  >
                                  </v-text-field>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" sm="12">
                                  <v-text-field
                                    class="input-flex-min-space"
                                    v-model="detail.secondaryContact.lastName"
                                    :rules="surnameRules"
                                    label="Last Name*"
                                  >
                                  </v-text-field>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" sm="12">
                                  <v-text-field
                                    class="input-flex-min-space"
                                    v-model="detail.secondaryContact.contactNumber"
                                    :rules="contactNumberRules"
                                    label="Contact Number*"
                                  >
                                  </v-text-field>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" sm="12">
                                  <v-text-field
                                    class="input-flex-min-space"
                                    v-model="detail.secondaryContact.emailAddress"
                                    :rules="emailRules"
                                    label="Email Address*"
                                  >
                                  </v-text-field>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" sm="12">
                                  <v-text-field
                                    class="input-flex-min-space"
                                    v-model="detail.secondaryContact.idNumber"
                                    :rules="idNumberRules"
                                    label="ID Number*"
                                  >
                                  </v-text-field>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" sm="12">
                                  <v-text-field
                                    class="input-flex-min-space"
                                    v-model="detail.secondaryContact.relationToPrimary"
                                    label="Relation to primary contact"
                                  >
                                  </v-text-field>
                                </v-col>
                              </v-row>

                              <v-row
                                ><v-col>
                                  <v-container v-if="this.detail.showSecondaryContact == true">
                                    <v-btn rounded color="primary" @click="resetSec()">
                                      <v-icon rounded dark flat>remove</v-icon>
                                      Secondary Contact
                                    </v-btn>
                                  </v-container>
                                </v-col></v-row
                              >
                            </v-col>
                            <v-col v-if="this.detail.addBillingContact == true && !detail.showInterest" cols="12" sm="4">
                              <h2
                                :style="{
                                  color: $store.state.currentOrg.orderSecondaryColour
                                    ? $store.state.currentOrg.orderSecondaryColour
                                    : $store.state.currentOrg.secondaryColour,
                                }"
                              >
                                Billing Contact Info
                              </h2>
                              <v-row>
                                <v-col cols="12" sm="12">
                                  <v-select
                                    class="input-flex-min-space"
                                    v-model="detail.billingContact.title"
                                    :items="titles"
                                    :rules="titleRules"
                                    label="Title*"
                                  >
                                  </v-select>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" sm="12">
                                  <v-text-field
                                    class="input-flex-min-space"
                                    v-model="detail.billingContact.firstName"
                                    :rules="nameRules"
                                    label="Billing Contact First Name* "
                                  >
                                  </v-text-field>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" sm="12">
                                  <v-text-field
                                    class="input-flex-min-space"
                                    v-model="detail.billingContact.lastName"
                                    :rules="surnameRules"
                                    label="Billing Contact Last Name*"
                                  >
                                  </v-text-field>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" sm="12">
                                  <v-text-field
                                    class="input-flex-min-space"
                                    v-model="detail.billingContact.contactNumber"
                                    :rules="contactNumberRules"
                                    label="Billing Contact Contact Number*"
                                  >
                                  </v-text-field>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" sm="12">
                                  <v-text-field
                                    class="input-flex-min-space"
                                    v-model="detail.billingContact.emailAddress"
                                    :rules="emailRules"
                                    label="Billing Contact Email Address*"
                                  >
                                  </v-text-field>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" sm="12">
                                  <v-text-field
                                    class="input-flex-min-space"
                                    :rules="idNumberRules"
                                    v-model="detail.billingContact.idNumber"
                                    label="Billing Contact ID Number*"
                                  >
                                  </v-text-field>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" sm="12">
                                  <v-checkbox
                                    v-model="detail.billingAddressSame"
                                    label=" My Billing Address is the same as my Residential Address"
                                  >
                                  </v-checkbox>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" sm="12" v-if="!detail.billingAddressSame">
                                  <v-text-field
                                    class="input-flex-min-space"
                                    v-model="detail.billingContact.physicalAddressLine1"
                                    label="Physical address line 1*"
                                  >
                                  </v-text-field>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" sm="12" v-if="!detail.billingAddressSame">
                                  <v-text-field
                                    class="input-flex-min-space"
                                    v-model="detail.billingContact.physicalAddressLine2"
                                    label="Physical address line 2*"
                                  >
                                  </v-text-field>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" sm="12" v-if="!detail.billingAddressSame">
                                  <v-text-field
                                    class="input-flex-min-space"
                                    v-model="detail.billingContact.physicalAddressLine3"
                                    label="Physical address line 3*"
                                  >
                                  </v-text-field>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" sm="12">
                                  <v-checkbox v-model="detail.isBusiness">
                                    <template v-slot:label>
                                      <v-form class="subheading">
                                        Billing needs to be sent to a company
                                      </v-form>
                                    </template>
                                  </v-checkbox>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" sm="12" v-if="detail.isBusiness">
                                  <v-text-field
                                    class="input-flex-min-space"
                                    v-model="detail.organisationName"
                                    label="Company Name"
                                  >
                                  </v-text-field>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" sm="12" v-if="detail.isBusiness">
                                  <v-text-field
                                    class="input-flex-min-space"
                                    v-model="detail.billingContact.vatNumber"
                                    label="VAT Number"
                                  >
                                  </v-text-field>
                                </v-col>
                              </v-row>

                              <v-row
                                ><v-col>
                                  <v-container cols="12" sm="12" v-if="this.detail.addBillingContact == true">
                                    <v-btn rounded color="primary" @click="resetBill()">
                                      <v-icon rounded dark flat>remove</v-icon>
                                      Billing Contact
                                    </v-btn>
                                  </v-container>
                                </v-col></v-row
                              >
                            </v-col>

                            <v-col
                              v-if="this.detail.showSecondaryContact == false && !this.$vuetify.breakpoint.xs && !detail.showInterest"
                              cols="12"
                              sm="4"
                            >
                              <br v-if="!this.$vuetify.breakpoint.xs" /><br />
                              <br v-if="!this.$vuetify.breakpoint.xs" /><br />
                              <br v-if="!this.$vuetify.breakpoint.xs" /><br />
                              <br v-if="!this.$vuetify.breakpoint.xs" /><br />
                              <br v-if="!this.$vuetify.breakpoint.xs" /><br />

                              <v-btn medium rounded color="primary" @click="detail.showSecondaryContact = true">
                                <v-icon rounded dark flat>add</v-icon>
                                Secondary Contact
                              </v-btn>
                            </v-col>
                            <v-col
                              v-if="this.detail.addBillingContact == false && !this.$vuetify.breakpoint.xs && !detail.showInterest"
                              cols="12"
                              sm="4"
                            >
                              <br v-if="!this.$vuetify.breakpoint.xs" /><br />
                              <br v-if="!this.$vuetify.breakpoint.xs" /><br />
                              <br v-if="!this.$vuetify.breakpoint.xs" /><br />
                              <br v-if="!this.$vuetify.breakpoint.xs" /><br />
                              <br v-if="!this.$vuetify.breakpoint.xs" /><br />

                              <v-btn rounded color="primary" @click="detail.addBillingContact = true">
                                <v-icon rounded dark flat>add</v-icon>
                                Billing Contact
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-form>
                    </v-col>
                  </v-row>
                </v-row>
                <v-row v-if="this.$vuetify.breakpoint.xs&& !detail.showInterest">
                  <v-col>
                    <v-row class="justify-center">
                      <v-col cols="12" sm="3">
                        <v-container v-if="this.detail.showSecondaryContact == false" style="text-align: center">
                          <v-btn
                            v-if="this.detail.showSecondaryContact == false"
                            medium
                            rounded
                            color="primary"
                            @click="detail.showSecondaryContact = true"
                          >
                            <v-icon rounded dark flat>add</v-icon>
                            Secondary Contact
                          </v-btn>
                        </v-container>
                        <v-container v-if="this.detail.addBillingContact == false" style="text-align: center">
                          <v-btn
                            v-if="this.detail.addBillingContact == false"
                            rounded
                            color="primary"
                            @click="detail.addBillingContact = true"
                          >
                            <v-icon rounded dark flat>add</v-icon>
                            Billing Contact
                          </v-btn>
                        </v-container>
                        <br /><br />
                      </v-col>
                    </v-row> </v-col
                ></v-row>
                <v-toolbar :dense="true" :flat="true">
                  <v-btn
                    v-if="detail.showInterest !== true"
                    medium
                    rounded
                    @click="setHeaderModal('previous', 'chooseContact', false)"
                    color="primary"
                    ><v-icon>chevron_left</v-icon>PREVIOUS</v-btn
                  >
                  <v-btn
                    v-else
                    medium
                    rounded
                    @click="
                      e1 = 1;
                      chooseEstate = true;
                    "
                    color="primary"
                    ><v-icon>chevron_left</v-icon>PREVIOUS</v-btn
                  >
                  <div class="flex-grow-1"></div>
                  <v-btn
                    :key="keyEmail"
                    v-if="
                      validatePrim() == true &&
                        validateSec() == true &&
                        validateBill() == true &&
                        this.max == calculateMaxModal('chooseContact') &&
                        verifyEmailComplete &&
                        detail.showInterest !== true
                    "
                    medium
                    rounded
                    @click="setHeaderModal('next', 'chooseContact', true), fetchFNOTerms()"
                    color="primary"
                    >NEXT<v-icon>chevron_right</v-icon></v-btn
                  >
                  <v-btn
                    :key="keyEmail"
                    v-else-if="
                      validatePrim() == true &&
                        detail.showInterest !== true &&
                        validateSec() == true &&
                        validateBill() == true &&
                        this.max != calculateMaxModal('chooseContact') &&
                        verifyEmailComplete
                    "
                    medium
                    rounded
                    @click="setHeaderModal('next', 'chooseContact', false)"
                    color="primary"
                    >NEXT<v-icon>chevron_right</v-icon></v-btn
                  >
                  <v-btn
                    :key="keyEmail"
                    v-else-if="checkProceedToSummaryButton && detail.showInterest !== true"
                    medium
                    rounded
                    @click="setHeaderModal('next', 'chooseContact', true)"
                    color="primary"
                    >NEXT<v-icon>chevron_right</v-icon></v-btn
                  >
                  <v-btn
                    :key="keyEmail"
                    v-else-if="detail.showInterest !== true"
                    medium
                    rounded
                    disabled
                    color="primary"
                    >NEXT<v-icon>chevron_right</v-icon></v-btn
                  >

                  <v-btn
                    @click="submitShowOfInterest('Interest')"
                    :key="keyEmail"
                    v-else-if="
                      validatePrim() == true &&
                        validateSec() == true &&
                        validateBill() == true &&
                        verifyEmailComplete &&
                        detail.showInterest === true &&
                        !isInWirelessRange &&termsSignedShowInterest
                    "
                    medium
                    rounded
                    color="primary"
                    >SUBMIT</v-btn
                  >
                  <v-btn
                    @click="submitShowOfInterest('Feasibility')"
                    :key="keyEmail"
                    v-else-if="
                      validatePrim() == true &&
                        validateSec() == true &&
                        validateBill() == true &&
                        verifyEmailComplete &&
                        detail.showInterest === true &&
                        isInWirelessRange&&termsSignedShowInterest
                    "
                    medium
                    rounded
                    color="primary"
                    >SUBMIT</v-btn
                  >
                  <v-btn
                    disabled
                    :key="keyEmail"
                    v-else-if="detail.showInterest === true"
                    medium
                    rounded
                    color="primary"
                    >SUBMIT</v-btn
                  >
                </v-toolbar>
              </v-card>
              <v-card
                flat
                :class="{
                  mobileStep: $vuetify.breakpoint.xsOnly,
                  'compact-form': $vuetify.breakpoint.smAndUp,
                }"
                v-if="chooseContact && ($vuetify.breakpoint.xsOnly || $vuetify.breakpoint.smOnly)"
              >
                <v-row style="text-align: center" row wrap>
                  <v-col cols="12" sm="12">
                    <h2
                      :style="{
                        color: $store.state.currentOrg.orderPrimaryColour
                          ? $store.state.currentOrg.orderPrimaryColour
                          : $store.state.currentOrg.primaryColour,
                      }"
                    >
                      CONTACT INFORMATION
                    </h2>
                    <br />
                    <h2
                      style="text-justify: center"
                      :style="{
                        color: $store.state.currentOrg.orderSecondaryColour
                          ? $store.state.currentOrg.orderSecondaryColour
                          : $store.state.currentOrg.secondaryColour,
                      }"
                      class="input-flex-min-space"
                    >
                      Primary Contact Info
                    </h2>
                  </v-col>

                  <v-container>
                    <v-row justify="center">
                      <v-col cols="12" sm="12">
                        <v-row>
                          <v-col cols="12" sm="12">
                            <v-select
                              v-model="detail.primaryContact.title"
                              :items="titles"
                              @change="checkProceedToSummary()"
                              :rules="titleRules"
                              label="Title*"
                            >
                            </v-select>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" sm="12">
                            <v-text-field
                              v-model="detail.primaryContact.firstName"
                              label="First Name* "
                              :rules="nameRules"
                              class="input-flex-min-space"
                            >
                            </v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" sm="12">
                            <v-text-field
                              v-model="detail.primaryContact.lastName"
                              label="Last Name*"
                              :rules="surnameRules"
                              class="input-flex-min-space"
                            >
                            </v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" sm="12">
                            <v-text-field
                              class="input-flex-min-space"
                              v-model="detail.primaryContact.contactNumber"
                              :rules="contactNumberRules"
                              label="Contact Number*"
                            >
                            </v-text-field>
                          </v-col>
                        </v-row>

                        <v-row>
                          <v-col cols="12" sm="12" v-if="verifyEmailComplete">
                            <v-text-field
                              class="input-flex-min-space"
                              v-model="detail.primaryContact.emailAddress"
                              :rules="emailRules"
                              persistent-hint
                              :key="keyEmail"
                              :hint="isSuccessful === false ? 'Verification Unsuccessful.' : 'Verification Successful!'"
                              label="Email Address*"
                              @change="(isSuccessful = false), (verifyEmailComplete = false)"
                            >
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" sm="12" v-else-if="!verifyEmailComplete && isSuccessful == false">
                            <v-text-field
                              class="input-flex-min-space"
                              v-model="detail.primaryContact.emailAddress"
                              :rules="emailRules"
                              persistent-hint
                              :key="keyEmail"
                              :hint="verifyResult"
                              label="Email Address*"
                            >
                            </v-text-field>
                          </v-col>
                          <v-col cols="12" sm="12" v-else-if="!verifyEmailComplete && isSuccessful == null">
                            <v-text-field
                              class="input-flex-min-space"
                              :key="keyEmail"
                              v-model="detail.primaryContact.emailAddress"
                              :rules="emailRules"
                              label="Email Address*"
                            >
                            </v-text-field>
                          </v-col>
                        </v-row>
                        <v-row v-if="!verifyEmailComplete">
                          <v-col cols="7" style="text-align: left">
                            <h2
                              style="text-align: left"
                              class="mt-1"
                              :style="{
                                color: $store.state.currentOrg.orderSecondaryColour
                                  ? $store.state.currentOrg.orderSecondaryColour
                                  : $store.state.currentOrg.secondaryColour,
                              }"
                            >
                              Email Verification
                              <span
                                style="font-weight: normal"
                                :style="{
                                  color: $store.state.currentOrg.orderSecondaryColour
                                    ? $store.state.currentOrg.orderSecondaryColour
                                    : $store.state.currentOrg.secondaryColour,
                                }"
                              >
                                (OTP)</span
                              >
                            </h2>
                          </v-col>

                          <v-col
                            class="justify-center align-center"
                            cols="5"
                            v-if="validateEmail() == true && !verifyEmailComplete"
                          >
                            <v-btn
                              rounded
                              v-if="firstOtp == 0"
                              @click="sendOtp(detail.primaryContact.emailAddress)"
                              color="primary"
                              >Send OTP</v-btn
                            >
                            <v-btn
                              rounded
                              v-if="firstOtp > 0"
                              @click="sendOtp(detail.primaryContact.emailAddress)"
                              color="primary"
                              >Resend OTP</v-btn
                            >
                          </v-col>
                        </v-row>
                        <h3
                          v-if="firstOtp > 0 && !verifyEmailComplete"
                          style="text-align: left"
                          :style="{
                            color: $store.state.currentOrg.orderSecondaryColour
                              ? $store.state.currentOrg.orderSecondaryColour
                              : $store.state.currentOrg.secondaryColour,
                          }"
                        >
                          Please check your email for the code
                        </h3>
                        <v-row class="justify-center">
                          <v-otp-input
                            ref="otpInput"
                            separator="-"
                            input-classes="otp-input"
                            :num-inputs="4"
                            :is-input-num="true"
                            @on-complete="onComplete($event)"
                          />
                          <!-- <h3 v-else>Verified <v-icon color="light-green">check_circle_outline</v-icon></h3> -->
                        </v-row>

                        <v-row>
                          <v-col cols="12" sm="12">
                            <v-text-field
                              class="input-flex-min-space"
                              v-model="detail.primaryContact.idNumber"
                              :rules="idNumberRules"
                              label="ID Number*"
                            >
                            </v-text-field>
                          </v-col>
                        </v-row>
                      </v-col>

  <v-col cols="12" sm="4" v-if="detail.showInterest">
                              <v-checkbox v-model="termsSignedShowInterest">
                                <template v-slot:label>
                                  <v-form style="text-align: left" class="subheading">
                                    I accept the {{ org.name }}
                                    <v-tooltip bottom>
                                      <template v-slot:activator="{ on }">
                                        <v-btn v-if="fnoTerms" text color="primary" @click="viewFnoTerms = true">
                                          Terms and Conditions
                                        </v-btn>
                                        <a
                                          v-else
                                          target="_blank"
                                          :href="org.termsAndConditionsLink"
                                          @click.stop
                                          v-on="on"
                                        >
                                          Terms and Conditions
                                        </a>
                                      </template>
                                      Opens link to T&C's in new window
                                    </v-tooltip>
                                  </v-form>
                                </template>
                              </v-checkbox>
                            
                              <v-checkbox v-model="agreeShareDetails">
                                <template v-slot:label>
                                  <v-form style="text-align: left" class="subheading">
                                    I agree to Fibre Geeks sharing my contact details with the ISPs on their network
                                    </v-btn>
                                  </v-form>
                                </template>
                              </v-checkbox>
                            </v-col>

                      <v-col v-if="this.detail.showSecondaryContact == true&& !detail.showInterest" cols="12" sm="4">
                        <h2
                          :style="{
                            color: $store.state.currentOrg.orderSecondaryColour
                              ? $store.state.currentOrg.orderSecondaryColour
                              : $store.state.currentOrg.secondaryColour,
                          }"
                        >
                          Secondary Contact Info
                        </h2>
                        <v-row>
                          <v-col cols="12" sm="12">
                            <v-select
                              class="input-flex-min-space"
                              v-model="detail.secondaryContact.title"
                              :items="titles"
                              :rules="titleRules"
                              label="Title* "
                            >
                            </v-select>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" sm="12">
                            <v-text-field
                              class="input-flex-min-space"
                              v-model="detail.secondaryContact.firstName"
                              :rules="nameRules"
                              label="First Name* "
                            >
                            </v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" sm="12">
                            <v-text-field
                              class="input-flex-min-space"
                              v-model="detail.secondaryContact.lastName"
                              :rules="surnameRules"
                              label="Last Name*"
                            >
                            </v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" sm="12">
                            <v-text-field
                              class="input-flex-min-space"
                              v-model="detail.secondaryContact.contactNumber"
                              :rules="contactNumberRules"
                              label="Contact Number*"
                            >
                            </v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" sm="12">
                            <v-text-field
                              class="input-flex-min-space"
                              v-model="detail.secondaryContact.emailAddress"
                              :rules="emailRules"
                              label="Email Address*"
                            >
                            </v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" sm="12">
                            <v-text-field
                              class="input-flex-min-space"
                              v-model="detail.secondaryContact.idNumber"
                              :rules="idNumberRules"
                              label="ID Number*"
                            >
                            </v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" sm="12">
                            <v-text-field
                              class="input-flex-min-space"
                              v-model="detail.secondaryContact.relationToPrimary"
                              label="Relation to primary contact"
                            >
                            </v-text-field>
                          </v-col>
                        </v-row>

                        <v-row
                          ><v-col>
                            <v-container v-if="this.detail.showSecondaryContact == true&& !detail.showInterest">
                              <v-btn rounded color="primary" @click="resetSec()">
                                <v-icon rounded dark flat>remove</v-icon>
                                Secondary Contact
                              </v-btn>
                            </v-container>
                          </v-col></v-row
                        >
                      </v-col>
                      <v-col v-if="this.detail.addBillingContact == true&& !detail.showInterest" cols="12" sm="4">
                        <h2
                          :style="{
                            color: $store.state.currentOrg.orderSecondaryColour
                              ? $store.state.currentOrg.orderSecondaryColour
                              : $store.state.currentOrg.secondaryColour,
                          }"
                        >
                          Billing Contact Info
                        </h2>
                        <v-row>
                          <v-col cols="12" sm="12">
                            <v-select
                              class="input-flex-min-space"
                              v-model="detail.billingContact.title"
                              :items="titles"
                              :rules="titleRules"
                              label="Title*"
                            >
                            </v-select>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" sm="12">
                            <v-text-field
                              class="input-flex-min-space"
                              v-model="detail.billingContact.firstName"
                              :rules="nameRules"
                              label="Billing Contact First Name* "
                            >
                            </v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" sm="12">
                            <v-text-field
                              class="input-flex-min-space"
                              v-model="detail.billingContact.lastName"
                              :rules="surnameRules"
                              label="Billing Contact Last Name*"
                            >
                            </v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" sm="12">
                            <v-text-field
                              class="input-flex-min-space"
                              v-model="detail.billingContact.contactNumber"
                              :rules="contactNumberRules"
                              label="Billing Contact Contact Number*"
                            >
                            </v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" sm="12">
                            <v-text-field
                              class="input-flex-min-space"
                              v-model="detail.billingContact.emailAddress"
                              :rules="emailRules"
                              label="Billing Contact Email Address*"
                            >
                            </v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" sm="12">
                            <v-text-field
                              class="input-flex-min-space"
                              :rules="idNumberRules"
                              v-model="detail.billingContact.idNumber"
                              label="Billing Contact ID Number*"
                            >
                            </v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" sm="12">
                            <v-checkbox
                              v-model="detail.billingAddressSame"
                              label=" My Billing Address is the same as my Residential Address"
                            >
                            </v-checkbox>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" sm="12" v-if="!detail.billingAddressSame">
                            <v-text-field
                              class="input-flex-min-space"
                              v-model="detail.billingContact.physicalAddressLine1"
                              label="Physical address line 1*"
                            >
                            </v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" sm="12" v-if="!detail.billingAddressSame">
                            <v-text-field
                              class="input-flex-min-space"
                              v-model="detail.billingContact.physicalAddressLine2"
                              label="Physical address line 2*"
                            >
                            </v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" sm="12" v-if="!detail.billingAddressSame">
                            <v-text-field
                              class="input-flex-min-space"
                              v-model="detail.billingContact.physicalAddressLine3"
                              label="Physical address line 3*"
                            >
                            </v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" sm="12">
                            <v-checkbox v-model="detail.isBusiness">
                              <template v-slot:label>
                                <v-form class="subheading">
                                  Billing needs to be sent to a company
                                </v-form>
                              </template>
                            </v-checkbox>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" sm="12" v-if="detail.isBusiness">
                            <v-text-field
                              class="input-flex-min-space"
                              v-model="detail.organisationName"
                              label="Company Name"
                            >
                            </v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" sm="12" v-if="detail.isBusiness">
                            <v-text-field
                              class="input-flex-min-space"
                              v-model="detail.billingContact.vatNumber"
                              label="VAT Number"
                            >
                            </v-text-field>
                          </v-col>
                        </v-row>

                        <v-row
                          ><v-col>
                            <v-container cols="12" sm="12" v-if="this.detail.addBillingContact == true&& !detail.showInterest">
                              <v-btn rounded color="primary" @click="resetBill()">
                                <v-icon rounded dark flat>remove</v-icon>
                                Billing Contact
                              </v-btn>
                            </v-container>
                          </v-col></v-row
                        >
                      </v-col>
                    </v-row>
                  </v-container>
                </v-row>

                <v-row class="justify-center">
                  <v-col cols="12" sm="4" xs="4">
                    <v-container v-if="this.detail.showSecondaryContact == false&& !detail.showInterest" style="text-align: center">
                      <v-btn
                        v-if="this.detail.showSecondaryContact == false"
                        medium
                        rounded
                        color="primary"
                        @click="detail.showSecondaryContact = true"
                      >
                        <v-icon rounded dark flat>add</v-icon>
                        Secondary Contact
                      </v-btn>
                    </v-container>
                    <v-container v-if="this.detail.addBillingContact == false&& !detail.showInterest" style="text-align: center">
                      <v-btn
                        v-if="this.detail.addBillingContact == false"
                        rounded
                        color="primary"
                        @click="detail.addBillingContact = true"
                      >
                        <v-icon rounded dark flat>add</v-icon>
                        Billing Contact
                      </v-btn>
                    </v-container>
                  </v-col>
                </v-row>
                <v-toolbar :dense="true" :flat="true">
                  <v-btn
                    v-if="detail.showInterest !== true"
                    medium
                    rounded
                    @click="setHeaderModal('previous', 'chooseContact', false)"
                    color="primary"
                    ><v-icon>chevron_left</v-icon>PREVIOUS</v-btn
                  >
                  <v-btn
                    v-else
                    medium
                    rounded
                    @click="
                      e1 = 1;
                      chooseEstate = true;
                    "
                    color="primary"
                    ><v-icon>chevron_left</v-icon>PREVIOUS</v-btn
                  >
                  <div class="flex-grow-1"></div>
                  <v-btn
                    :key="keyEmail"
                    v-if="
                      validatePrim() == true &&
                        validateSec() == true &&
                        validateBill() == true &&
                        this.max == calculateMaxModal('chooseContact') &&
                        verifyEmailComplete &&
                        detail.showInterest !== true
                    "
                    medium
                    rounded
                    @click="setHeaderModal('next', 'chooseContact', true)"
                    color="primary"
                    >NEXT<v-icon>chevron_right</v-icon></v-btn
                  >
                  <v-btn
                    :key="keyEmail"
                    v-else-if="
                      validatePrim() == true &&
                        detail.showInterest !== true &&
                        validateSec() == true &&
                        validateBill() == true &&
                        this.max != calculateMaxModal('chooseContact') &&
                        verifyEmailComplete
                    "
                    medium
                    rounded
                    @click="setHeaderModal('next', 'chooseContact', false)"
                    color="primary"
                    >NEXT<v-icon>chevron_right</v-icon></v-btn
                  >
                  <v-btn
                    :key="keyEmail"
                    v-else-if="checkProceedToSummaryButton && detail.showInterest !== true"
                    medium
                    rounded
                    @click="setHeaderModal('next', 'chooseContact', true)"
                    color="primary"
                    >NEXT<v-icon>chevron_right</v-icon></v-btn
                  >
                  <v-btn
                    :key="keyEmail"
                    v-else-if="detail.showInterest !== true"
                    medium
                    rounded
                    disabled
                    color="primary"
                    >NEXT<v-icon>chevron_right</v-icon></v-btn
                  >

                  <v-btn
                    @click="submitShowOfInterest('Interest')"
                    :key="keyEmail"
                    v-else-if="
                      validatePrim() == true &&
                        validateSec() == true &&
                        validateBill() == true &&
                        verifyEmailComplete &&
                        detail.showInterest === true &&
                        !isInWirelessRange &&termsSignedShowInterest
                    "
                    medium
                    rounded
                    color="primary"
                    >SUBMIT</v-btn
                  >
                  <v-btn
                    @click="submitShowOfInterest('Feasibility')"
                    :key="keyEmail"
                    v-else-if="
                      validatePrim() == true &&
                        validateSec() == true &&
                        validateBill() == true &&
                        verifyEmailComplete &&
                        detail.showInterest === true &&
                        isInWirelessRange &&termsSignedShowInterest
                    "
                    medium
                    rounded
                    color="primary"
                    >SUBMIT</v-btn
                  >
                  <v-btn
                    disabled
                    :key="keyEmail"
                    v-else-if="this.detail.showInterest === true"
                    medium
                    rounded
                    color="primary"
                    >SUBMIT</v-btn
                  >
                </v-toolbar>
              </v-card>
            </v-stepper-content>

            <v-stepper-content :step="calculateStepContent('chooseSummary')">
              <v-card
                flat
                :class="{
                  mobileStep: $vuetify.breakpoint.xsOnly,
                  'compact-form': $vuetify.breakpoint.smAndUp,
                }"
                v-if="chooseSummary"
              >
                <!-- Order Summary -->
                <v-row justify="center" align-center>
                  <v-col cols="12" sm="12" class="text-center">
                    <v-row no-gutters justify="center" align-center style="text-align: center">
                      <v-col cols="12" sm="12">
                        <h2
                          :style="{
                            color: $store.state.currentOrg.orderPrimaryColour
                              ? $store.state.currentOrg.orderPrimaryColour
                              : $store.state.currentOrg.primaryColour,
                          }"
                        >
                          ORDER SUMMARY
                        </h2>
                        <v-row no-gutters justify="center" align-center>
                          <v-col cols="12" xl="4" lg="4" md="4" sm="12" class="text-center">
                            <v-img
                              :src="
                                $store.state.currentOrg.orderPageLogo
                                  ? $store.state.currentOrg.orderPageLogo
                                  : $store.state.currentOrg.logo
                              "
                              min-height="50px"
                              min-width="200px"
                              max-height="120px"
                              max-width="280px"
                              aspect-ratio="1.4"
                              contain
                            ></v-img>
                          </v-col>

                          <v-col xl="4" lg="4" md="4" sm="6" class="text-center">
                            <h4
                              style="text-align: left"
                              :style="{
                                color: $store.state.currentOrg.orderSecondaryColour
                                  ? $store.state.currentOrg.orderSecondaryColour
                                  : $store.state.currentOrg.secondaryColour,
                              }"
                              class="subheading"
                              v-if="
                                detail.selectedInternetPackage !== null &&
                                  typeof detail.selectedInternetPackage !== 'undefined'
                              "
                            >
                              Installation Fee:
                            </h4>
                          </v-col>
                          <v-col xl="4" lg="4" md="4" sm="6" class="text-center">
                            <h4
                              style="text-align: left"
                              :style="{
                                color: $store.state.currentOrg.orderSecondaryColour
                                  ? $store.state.currentOrg.orderSecondaryColour
                                  : $store.state.currentOrg.secondaryColour,
                              }"
                              class="subheading"
                              v-if="
                                detail.selectedInternetPackage !== null &&
                                  typeof detail.selectedInternetPackage !== 'undefined' &&
                                  fnoPackagesPromoIdList.includes(detail.selectedInternetPackage.packagesFnoId)
                              "
                            >
                              <b>{{ 0 | currency }}</b>
                            </h4>
                            <h4
                              style="text-align: left"
                              :style="{
                                color: $store.state.currentOrg.orderSecondaryColour
                                  ? $store.state.currentOrg.orderSecondaryColour
                                  : $store.state.currentOrg.secondaryColour,
                              }"
                              class="subheading"
                              v-else-if="
                                detail.selectedInternetPackage !== null &&
                                  typeof detail.selectedInternetPackage !== 'undefined' &&
                                  detail.selectedInternetPackage.packagesFno.packagesFnoCat.packageCatType ===
                                    'Residential'
                              "
                            >
                              <b>{{ residentialInstallFee | currency }}</b>
                            </h4>
                            <h4
                              style="text-align: left"
                              :style="{
                                color: $store.state.currentOrg.orderSecondaryColour
                                  ? $store.state.currentOrg.orderSecondaryColour
                                  : $store.state.currentOrg.secondaryColour,
                              }"
                              class="subheading"
                              v-else-if="
                                detail.selectedInternetPackage !== null &&
                                  typeof detail.selectedInternetPackage !== 'undefined' &&
                                  detail.selectedInternetPackage.packagesFno.packagesFnoCat.packageCatType ===
                                    'Business'
                              "
                            >
                              <b>{{ businessInstallFee | currency }}</b>
                            </h4>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" sm="12" class="text-center">
                        <v-row no-gutters align="center" v-if="detail.selectedInternetPackage != null">
                          <v-col
                            class="text-center"
                            cols="4"
                            v-if="
                              !$vuetify.breakpoint.xs &&
                                detail.selectedInternetPackage.customerOrganisation.orderPageLogo
                            "
                          >
                            <v-img
                              :src="detail.selectedInternetPackage.customerOrganisation.orderPageLogo"
                              class="compact-form"
                              min-height="50px"
                              min-width="200px"
                              max-height="100px"
                              max-width="250px"
                              aspect-ratio="1.4"
                              contain
                            ></v-img>
                          </v-col>
                          <v-col cols="4" v-else-if="!$vuetify.breakpoint.xs" class="text-center">
                            <v-img
                              :src="detail.selectedInternetPackage.customerOrganisation.logo"
                              class="compact-form"
                              min-height="50px"
                              min-width="200px"
                              max-height="100px"
                              max-width="250px"
                              aspect-ratio="1.4"
                              contain
                            ></v-img>
                          </v-col>
                          <v-col
                            class="text-center"
                            cols="12"
                            sm="12"
                            v-else-if="
                              $vuetify.breakpoint.xs &&
                                detail.selectedInternetPackage.customerOrganisation.orderPageLogo
                            "
                          >
                            <v-img
                              :src="detail.selectedInternetPackage.customerOrganisation.orderPageLogo"
                              class="compact-form"
                              min-height="50px"
                              min-width="200px"
                              max-height="100px"
                              max-width="250px"
                              aspect-ratio="1.4"
                              contain
                            ></v-img>
                          </v-col>
                          <v-col cols="12" sm="12" class="text-center" v-else-if="$vuetify.breakpoint.xs">
                            <v-img
                              :src="detail.selectedInternetPackage.customerOrganisation.logo"
                              class="compact-form"
                              min-height="50px"
                              min-width="200px"
                              max-height="100px"
                              max-width="250px"
                              aspect-ratio="1.4"
                              contain
                            ></v-img>
                          </v-col>

                          <v-col xl="4" lg="4" md="4" sm="6" class="text-center">
                            <h4
                              style="text-align: left"
                              :style="{
                                color: $store.state.currentOrg.orderSecondaryColour
                                  ? $store.state.currentOrg.orderSecondaryColour
                                  : $store.state.currentOrg.secondaryColour,
                              }"
                              v-if="
                                detail.selectedInternetPackage !== null &&
                                  typeof detail.selectedInternetPackage !== 'undefined'
                              "
                            >
                              Selected Package:
                            </h4>
                            <h4
                              style="text-align: left"
                              :style="{
                                color: $store.state.currentOrg.orderSecondaryColour
                                  ? $store.state.currentOrg.orderSecondaryColour
                                  : $store.state.currentOrg.secondaryColour,
                              }"
                              v-if="
                                detail.selectedInternetPackage !== null &&
                                  typeof detail.selectedInternetPackage !== 'undefined'
                              "
                            >
                              Once-Off Cost:
                            </h4>
                            <h4
                              style="text-align: left"
                              :style="{
                                color: $store.state.currentOrg.orderSecondaryColour
                                  ? $store.state.currentOrg.orderSecondaryColour
                                  : $store.state.currentOrg.secondaryColour,
                              }"
                              v-if="
                                detail.selectedInternetPackage !== null &&
                                  typeof detail.selectedInternetPackage !== 'undefined'
                              "
                            >
                              Monthly Cost:
                            </h4>
                          </v-col>
                          <v-col xl="4" lg="4" md="4" sm="6" class="text-center">
                            <h4
                              style="text-align: left"
                              :style="{
                                color: $store.state.currentOrg.orderSecondaryColour
                                  ? $store.state.currentOrg.orderSecondaryColour
                                  : $store.state.currentOrg.secondaryColour,
                              }"
                              v-if="
                                detail.selectedInternetPackage !== null &&
                                  typeof detail.selectedInternetPackage !== 'undefined'
                              "
                            >
                              <b>{{ detail.selectedInternetPackage.name }}</b>
                            </h4>
                            <h4
                              style="text-align: left"
                              :style="{
                                color: $store.state.currentOrg.orderSecondaryColour
                                  ? $store.state.currentOrg.orderSecondaryColour
                                  : $store.state.currentOrg.secondaryColour,
                              }"
                              v-if="
                                detail.selectedInternetPackage !== null &&
                                  typeof detail.selectedInternetPackage !== 'undefined'
                              "
                            >
                              <b>{{ detail.selectedInternetPackage.onceOffPriceVatInc | currency }}</b>
                            </h4>
                            <h4
                              style="text-align: left"
                              :style="{
                                color: $store.state.currentOrg.orderSecondaryColour
                                  ? $store.state.currentOrg.orderSecondaryColour
                                  : $store.state.currentOrg.secondaryColour,
                              }"
                              v-if="
                                detail.selectedInternetPackage !== null &&
                                  typeof detail.selectedInternetPackage !== 'undefined'
                              "
                            >
                              <b>{{ detail.selectedInternetPackage.recurringPriceVatInc | currency }}</b>
                            </h4>
                          </v-col>
                        </v-row>
                      </v-col>

                      <v-col cols="12" sm="12" class="text-center" v-for="item in productArray" :key="item.id">
                        <v-row no-gutters align="center">
                          <v-col
                            cols="4"
                            class="text-center"
                            v-if="!$vuetify.breakpoint.xs && item.stockItem && item.stockItem.image"
                          >
                            <v-img
                              class="compact-form"
                              :src="item.stockItem.image"
                              min-height="50px"
                              min-width="200px"
                              max-height="120px"
                              max-width="280px"
                              aspect-ratio="1.4"
                              contain
                            ></v-img>
                          </v-col>
                          <v-col
                            cols="4"
                            class="text-center"
                            v-else-if="!$vuetify.breakpoint.xs && item.deviceMakeModel && item.deviceMakeModel.image"
                          >
                            <v-img
                              class="compact-form"
                              :src="item.deviceMakeModel.image"
                              min-height="50px"
                              min-width="200px"
                              max-height="120px"
                              max-width="280px"
                              aspect-ratio="1.4"
                              contain
                            ></v-img>
                          </v-col>
                          <v-col cols="4" class="text-center" v-else-if="!$vuetify.breakpoint.xs">
                            <v-img
                              class="compact-form"
                              src="../noImage.png"
                              min-height="50px"
                              min-width="200px"
                              max-height="120px"
                              max-width="280px"
                              aspect-ratio="1.4"
                              contain
                            ></v-img>
                          </v-col>
                          <v-col
                            class="text-center"
                            cols="12"
                            sm="12"
                            v-else-if="$vuetify.breakpoint.xs && item.stockItem && item.stockItem.image"
                          >
                            <v-img
                              class="compact-form"
                              :src="item.stockItem.image"
                              min-height="50px"
                              min-width="200px"
                              max-height="120px"
                              max-width="280px"
                              aspect-ratio="1.4"
                              contain
                            ></v-img>
                          </v-col>
                          <v-col
                            class="text-center"
                            cols="12"
                            sm="12"
                            v-else-if="$vuetify.breakpoint.xs && item.deviceMakeModel && item.deviceMakeModel.image"
                          >
                            <v-img
                              class="compact-form"
                              :src="item.deviceMakeModel.image"
                              min-height="50px"
                              min-width="200px"
                              max-height="120px"
                              max-width="280px"
                              aspect-ratio="1.4"
                              contain
                            ></v-img>
                          </v-col>
                          <v-col cols="12" sm="12" class="text-center" v-else-if="$vuetify.breakpoint.xs">
                            <v-img
                              class="compact-form"
                              src="../noImage.png"
                              min-height="50px"
                              min-width="200px"
                              max-height="120px"
                              max-width="280px"
                              aspect-ratio="1.4"
                              contain
                            ></v-img>
                          </v-col>
                          <v-col xl="4" lg="4" md="4" sm="6" class="text-center">
                            <h4
                              style="text-align: left"
                              :style="{
                                color: $store.state.currentOrg.orderSecondaryColour
                                  ? $store.state.currentOrg.orderSecondaryColour
                                  : $store.state.currentOrg.secondaryColour,
                              }"
                              class="subheading"
                              v-if="productArray.length > 0"
                            >
                              Product Name:
                            </h4>
                            <h4
                              style="text-align: left"
                              :style="{
                                color: $store.state.currentOrg.orderSecondaryColour
                                  ? $store.state.currentOrg.orderSecondaryColour
                                  : $store.state.currentOrg.secondaryColour,
                              }"
                              class="subheading"
                              v-if="productArray.length > 0"
                            >
                              Product Type:
                            </h4>
                            <h4
                              style="text-align: left"
                              :style="{
                                color: $store.state.currentOrg.orderSecondaryColour
                                  ? $store.state.currentOrg.orderSecondaryColour
                                  : $store.state.currentOrg.secondaryColour,
                              }"
                              class="subheading"
                              v-if="productArray.length > 0"
                            >
                              Price Incl. VAT:
                            </h4>
                          </v-col>
                          <v-col xl="4" lg="4" md="4" sm="6" class="text-center">
                            <h4
                              style="text-align: left"
                              :style="{
                                color: $store.state.currentOrg.orderSecondaryColour
                                  ? $store.state.currentOrg.orderSecondaryColour
                                  : $store.state.currentOrg.secondaryColour,
                              }"
                              class="subheading"
                              v-if="productArray.length > 0"
                            >
                              <b v-if="item.stockItem">{{ item.stockItem.name }}</b>
                              <b v-else-if="item.deviceMakeModel">{{ item.deviceMakeModel.name }}</b>
                            </h4>
                            <h4
                              style="text-align: left"
                              :style="{
                                color: $store.state.currentOrg.orderSecondaryColour
                                  ? $store.state.currentOrg.orderSecondaryColour
                                  : $store.state.currentOrg.secondaryColour,
                              }"
                              class="subheading"
                              v-if="productArray.length > 0"
                            >
                              <b v-if="item.stockItem">{{ item.stockItem.stockType.name }}</b>
                              <b v-else-if="item.deviceMakeModel">{{ item.deviceMakeModel.deviceMake.name }}</b>
                            </h4>
                            <h4
                              style="text-align: left"
                              :style="{
                                color: $store.state.currentOrg.orderSecondaryColour
                                  ? $store.state.currentOrg.orderSecondaryColour
                                  : $store.state.currentOrg.secondaryColour,
                              }"
                              class="subheading"
                              v-if="productArray.length > 0"
                            >
                              <b v-if="item.stockItem">{{ (item.stockItem.priceExclVat * (1 + $VAT)) | currency }}</b>
                              <b v-else-if="item.deviceMakeModel">{{ item.deviceMakeModel.priceInclVat | currency }}</b>
                            </h4>
                          </v-col>
                        </v-row>
                      </v-col>

                      <v-row no-gutters>
                        <v-col xl="4" lg="4" md="4" sm="6" v-if="!$vuetify.breakpoint.xs" class="text-center"></v-col>
                        <v-col xl="4" lg="4" md="4" sm="6" class="text-center">
                          <h4
                            style="text-align: left"
                            :style="{
                              color: $store.state.currentOrg.orderSecondaryColour
                                ? $store.state.currentOrg.orderSecondaryColour
                                : $store.state.currentOrg.secondaryColour,
                            }"
                            class="subheading"
                          >
                            Promotion Code:
                          </h4>
                        </v-col>
                        <v-col xl="4" lg="4" md="4" sm="6" class="text-center">
                          <v-text-field
                            class="input-flex-min-space"
                            v-model="detail.promoCode"
                            placeholder="Promotion Code"
                          >
                          </v-text-field>
                        </v-col>
                      </v-row>
                    </v-row>
                  </v-col>
                </v-row>
                <v-toolbar :dense="true" :flat="true">
                  <v-btn medium rounded @click="setHeaderModal('previous', 'chooseSummary', false)" color="primary"
                    ><v-icon>chevron_left</v-icon>PREVIOUS</v-btn
                  >
                  <div class="flex-grow-1"></div>
                  <v-btn
                    v-if="this.max == calculateMaxModal('chooseSummary')"
                    medium
                    rounded
                    color="primary"
                    @click="setHeaderModal('next', 'chooseSummary', true)"
                    >ACCEPT<v-icon>chevron_right</v-icon></v-btn
                  >
                  <v-btn v-else medium rounded color="primary" @click="setHeaderModal('next', 'chooseSummary', false)"
                    >ACCEPT<v-icon>chevron_right</v-icon></v-btn
                  >
                </v-toolbar>
              </v-card>
            </v-stepper-content>

            <v-stepper-content :step="calculateStepContent('chooseTerms')">
              <v-card
                flat
                :class="{
                  mobileStep: $vuetify.breakpoint.xsOnly,
                  'compact-form': $vuetify.breakpoint.smAndUp,
                }"
                v-if="chooseTerms"
              >
                <!--Signature Pad and Terms and conditions  -->
                <v-col cols="12" sm="12" v-if="this.$vuetify.breakpoint.xsOnly">
                  <h2
                    style="text-align: center"
                    id="about"
                    :style="{
                      color: $store.state.currentOrg.orderPrimaryColour
                        ? $store.state.currentOrg.orderPrimaryColour
                        : $store.state.currentOrg.primaryColour,
                    }"
                  >
                    SELECT YOUR PREFERRED ACTIVATION DATE
                  </h2>
                </v-col>
                <h3
                  v-if="this.$vuetify.breakpoint.xsOnly"
                  :style="{
                    color: $store.state.currentOrg.orderSecondaryColour
                      ? $store.state.currentOrg.orderSecondaryColour
                      : $store.state.currentOrg.secondaryColour,
                  }"
                  class="font-weight-light pt-0 mt-0 mb-1"
                >
                  We will do our best to accommodate you, however this date is subject to availability.
                </h3>
                <v-container v-if="this.$vuetify.breakpoint.xsOnly" style="text-align: center">
                  <v-date-picker
                    no-title
                    scrollable
                    v-model="detail.activationDate"
                    :min="minActivationDate"
                    :allowed-dates="allowedDates"
                  ></v-date-picker>
                </v-container>
                <v-container v-if="!this.$vuetify.breakpoint.xsOnly" style="text-align: center" class="mb-0">
                  <v-row>
                    <v-col cols="3" sm="6">
                      <v-container v-if="!this.$vuetify.breakpoint.xsOnly" style="text-align: left">
                        <v-row>
                          <v-col cols="3" sm="12">
                            <h4
                              style="text-align: left"
                              class="ml-5"
                              id="about"
                              :style="{
                                color: $store.state.currentOrg.orderSecondaryColour
                                  ? $store.state.currentOrg.orderSecondaryColour
                                  : $store.state.currentOrg.secondaryColour,
                              }"
                            >
                              SELECT YOUR PREFERRED ACTIVATION DATE
                            </h4>

                            <h3
                              :style="{
                                color: $store.state.currentOrg.orderSecondaryColour
                                  ? $store.state.currentOrg.orderSecondaryColour
                                  : $store.state.currentOrg.secondaryColour,
                              }"
                              class="text-xs-left section-heading font-weight-light pt-0 mt-0"
                            >
                              We will do our best to accommodate you, however this date is subject to availability.
                            </h3>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-col>
                    <v-col cols="3" sm="6">
                      <v-date-picker
                        no-title
                        scrollable
                        v-model="detail.activationDate"
                        :min="minActivationDate"
                        :allowed-dates="allowedDates"
                      ></v-date-picker> </v-col></v-row
                ></v-container>
                <v-row align="center">
                  <v-col cols="12" sm="6">
                    <v-row>
                      <v-col cols="12" sm="12">
                        <v-form>
                          <v-row style="padding-left: 15px">
                            <h2
                              :style="{
                                color: $store.state.currentOrg.orderPrimaryColour
                                  ? $store.state.currentOrg.orderPrimaryColour
                                  : $store.state.currentOrg.primaryColour,
                              }"
                            >
                              Please accept the T's & C's to continue
                            </h2>
                          </v-row>
                          <v-container style="text-align: left">
                            <v-row
                              v-if="this.detail.selectedInternetPackage != null && this.detail.internetPackageSelected"
                            >
                              <v-checkbox v-model="acceptInfoSharing">
                                <template v-slot:label>
                                  <v-form class="subheading">
                                    I agree to my details being shared with my chosen Internet Service Provider
                                  </v-form>
                                </template>
                              </v-checkbox>
                            </v-row>
                            <v-row
                              v-if="
                                this.detail.selectedInternetPackage != null &&
                                  this.detail.internetPackageSelected &&
                                  detail.selectedInternetPackage.customerOrganisationId != $store.state.currentOrg.id
                              "
                            >
                              <v-checkbox v-model="ISPTermsSigned">
                                <template v-slot:label>
                                  <v-form style="text-align: left" class="subheading">
                                    I accept the
                                    {{ detail.selectedInternetPackage.customerOrganisation.name }}
                                    <v-tooltip bottom>
                                      <template v-slot:activator="{ on }">
                                        <v-btn v-if="ispTerms" text color="primary" @click="viewISPTerms = true">
                                          Terms and Conditions
                                        </v-btn>
                                        <a
                                          v-else
                                          target="_blank"
                                          :href="
                                            detail.selectedInternetPackage.customerOrganisation.termsAndConditionsLink
                                          "
                                          @click.stop
                                          v-on="on"
                                        >
                                          Terms and Conditions
                                        </a>
                                      </template>
                                      Opens link to T&C's in new window
                                    </v-tooltip>
                                  </v-form>
                                </template>
                              </v-checkbox>
                            </v-row>
                            <v-row v-if="detail.selectedInternetPackage && agreement">
                              <v-checkbox v-model="acceptISPAgreement">
                                <template v-slot:label>
                                  <v-form style="text-align: left" class="subheading">
                                    I accept the
                                    {{ detail.selectedInternetPackage.customerOrganisation.name }}
                                    {{ agreement.name }}
                                    <v-btn text color="primary" @click="viewISPAgreement = true">
                                      agreement.
                                    </v-btn>
                                  </v-form>
                                </template>
                              </v-checkbox>
                            </v-row>
                            <v-row>
                              <v-checkbox v-model="termsSigned">
                                <template v-slot:label>
                                  <v-form style="text-align: left" class="subheading">
                                    I accept the {{ org.name }}
                                    <v-tooltip bottom>
                                      <template v-slot:activator="{ on }">
                                        <v-btn v-if="fnoTerms" text color="primary" @click="viewFnoTerms = true">
                                          Terms and Conditions
                                        </v-btn>
                                        <a
                                          v-else
                                          target="_blank"
                                          :href="org.termsAndConditionsLink"
                                          @click.stop
                                          v-on="on"
                                        >
                                          Terms and Conditions
                                        </a>
                                      </template>
                                      Opens link to T&C's in new window
                                    </v-tooltip>
                                  </v-form>
                                </template>
                              </v-checkbox>
                            </v-row>
                            <v-row v-if="!detail.selectedInternetPackage">
                            <v-checkbox v-model="agreeShareDetails">
                                <template v-slot:label>
                                  <v-form style="text-align: left" class="subheading">
                                    I agree to Fibre Geeks sharing my contact details with the ISPs on their network
                                    </v-btn>
                                  </v-form>
                                </template>
                              </v-checkbox>
                              </v-row>
                          </v-container>
                        </v-form>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-textarea
                      outlined
                      placeholder="Any Additional notes/requirements"
                      v-model="detail.notes"
                    ></v-textarea>
                    <!-- <v-row class="justify-center">
                      <v-container style="width: 100%">
                        <v-row style="padding-left: 15px">
                          <h2
                            :style="{
                              color: $store.state.currentOrg.orderPrimaryColour
                                ? $store.state.currentOrg.orderPrimaryColour
                                : $store.state.currentOrg.primaryColour,
                            }"
                          >
                            Please sign here (Click & drag your cursor)
                          </h2>
                        </v-row>
                        <v-container
                          v-if="
                            !this.$vuetify.breakpoint.xs &&
                            !this.$vuetify.breakpoint.xl
                          "
                          class="text-center"
                          id="MySignaturePad"
                        >
                          <v-row
                            ><v-col cols="6" sm="12">
                              <VueSignaturePad
                                height="200px"
                                max-width="500px"
                                ref="signaturePad"
                                id="signature"
                                :options="{ onEnd }"
                              /> </v-col
                          ></v-row>
                        </v-container>
                        <v-container
                          v-if="this.$vuetify.breakpoint.xl"
                          class="text-center"
                          id="MySignaturePad"
                        >
                          <v-row
                            ><v-col cols="12" sm="4">
                              <VueSignaturePad
                                height="200px"
                                width="590px"
                                ref="signaturePad"
                                id="signature"
                                :options="{ onEnd }"
                              /> </v-col
                          ></v-row>
                        </v-container>
                        <v-container
                          v-if="this.$vuetify.breakpoint.xs"
                          class="text-center"
                          id="MySignaturePad"
                        >
                          <v-row
                            ><v-col cols="12" sm="6">
                              <VueSignaturePad
                                height="200px"
                                ref="signaturePad"
                                id="signature"
                                :options="{ onEnd }"
                              /> </v-col
                          ></v-row>
                        </v-container>
                        <v-container style="text-align: right">
                          <v-btn
                            rounded
                            color="secondary"
                            @click="clearSignature()"
                          >
                            <span style="color: white">Clear</span>
                          </v-btn>
                          <v-btn
                            :class="{ margeLarge: $vuetify.breakpoint.xl }"
                            rounded
                            color="secondary"
                            @click="undoSignature()"
                          >
                            <span style="color: white">Undo</span>
                          </v-btn>
                        </v-container>
                      </v-container>
                    </v-row> -->
                  </v-col>
                </v-row>
                <v-toolbar :dense="true" :flat="true">
                  <v-btn medium rounded @click="setHeaderModal('previous', 'chooseTerms', false)" color="primary"
                    ><v-icon>chevron_left</v-icon>PREVIOUS</v-btn
                  >
                  <div class="flex-grow-1"></div>
                  <v-btn
                    medium
                    v-if="
                      !submittingApplication &&
                        termsAllSigned && 
                        detail.activationDate &&
                        (!$store.state.currentOrg.enablePaymentGateway ||
                          !$store.state.currentOrg.billEndCustomerInstall ||
                          !payNowInfo)
                    "
                    rounded
                    color="primary"
                    @click="
                      resize();
                      submit('standard');
                    "
                    dark
                    >Submit</v-btn
                  >

                  <v-btn
                    medium
                    v-else-if="
                      !submittingApplication &&
                        termsAllSigned &&
                        detail.activationDate &&
                        $store.state.currentOrg.enablePaymentGateway &&
                        $store.state.currentOrg.billEndCustomerInstall &&
                        payNowInfo
                    "
                    rounded
                    color="primary"
                    @click="
                      resize();
                      submit('pay');
                    "
                    dark
                    >Submit & Pay</v-btn
                  >
                  <v-btn
                    medium
                    v-else-if="
                      !submittingApplication &&
                        termsAllSigned &&
                        detail.activationDate &&
                        !$store.state.currentOrg.enablePaymentGateway &&
                        $store.state.currentOrg.billEndCustomerInstall
                    "
                    rounded
                    color="primary"
                    @click="
                      resize();
                      submit('invoice');
                    "
                    dark
                    >Submit</v-btn
                  >
                  <v-btn
                    medium
                    rounded
                    v-else-if="submittingApplication && termsAllSigned && detail.activationDate"
                    round
                    disabled
                  >
                    <span>Submitting Order </span>
                    <v-progress-circular size="20" indeterminate color="white"></v-progress-circular
                  ></v-btn>
                  <v-btn medium v-if="!termsAllSigned || !detail.activationDate" rounded disabled>Submit</v-btn>
                  <!-- <v-form v-if="submittingApplication" style="visibility: hidden" ref="payNowForm" method="POST" action="https://paynow.netcash.co.za/site/paynow.aspx" target="_top">
                      <v-text-field type="text" name="M1" :value="payNowForm.M1"></v-text-field>
                      <v-text-field type="text" name="M2" :value="payNowForm.M2"></v-text-field>
                      <v-text-field type="text" name="p2" :value="payNowForm.p2"></v-text-field>
                      <v-text-field type="text" name="p3"  :value="payNowForm.p3"></v-text-field>
                      <v-text-field type="text" name="p4" :value="payNowForm.p4"></v-text-field>
                      <v-text-field type="text" name="Budget" :value="payNowForm.Budget"></v-text-field>
                      <v-text-field type="text" name="m4" :value="payNowForm.m4"></v-text-field>

                      <v-text-field type="text" name="m9" :value="payNowForm.m9"></v-text-field>
                      <v-text-field type="text" name="m11" :value="payNowForm.m11"></v-text-field>
                      <v-text-field type="text" name="m10" :value="payNowForm.m10"></v-text-field>
                      <v-text-field  type="text" name="m14" :value="payNowForm.m14"></v-text-field>
                      <v-btn name="submit" type="submit" value="PAY"> Pay</v-btn>            
                      </v-form> -->
                </v-toolbar>
              </v-card>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      <!-- </v-container> -->
      </div>

      <!-- Complete modal -->
      <v-card flat class="compact-formComplete" v-if="chooseComplete">
        <v-container style="text-align: center">
          <v-icon size="150" color="primary">mdi-checkbox-marked-circle</v-icon>
        </v-container>
        <v-container style="text-align: center">
          <h2
            :style="{
              color: $store.state.currentOrg.orderPrimaryColour
                ? $store.state.currentOrg.orderPrimaryColour
                : $store.state.currentOrg.primaryColour,
            }"
          >
            Submission Successful
          </h2>
          <h3
            v-if="!detail.showInterest"
            :style="{
              color: $store.state.currentOrg.orderPrimaryColour
                ? $store.state.currentOrg.orderPrimaryColour
                : $store.state.currentOrg.primaryColour,
            }"
          >
            Thank you for submitting your fibre order.
          </h3>
          <h3
            v-else
            :style="{
              color: $store.state.currentOrg.orderPrimaryColour
                ? $store.state.currentOrg.orderPrimaryColour
                : $store.state.currentOrg.primaryColour,
            }"
          >
            Thank you for submitting your show of interest.
          </h3>
          <br />

          <h3
            :style="{
              color: $store.state.currentOrg.orderPrimaryColour
                ? $store.state.currentOrg.orderPrimaryColour
                : $store.state.currentOrg.primaryColour,
            }"
            v-if="detail.netcashIntegration"
          >
            Please expect an email or sms with further instructions regarding your eMandate and payment details.
          </h3>
        </v-container>
        <v-container style="text-align: center">
          <v-btn
            medium
            color="primary"
            rounded
            @click="
              resize();
              clearDetail();
              e1 = 1;
              chooseEstate = true;
              chooseComplete = false;
            "
          >
            OK
          </v-btn>
        </v-container>
      </v-card>

      <!-- Modals -->
      <!-- Error modal -->
      <v-dialog v-model="showError" max-width="750px">
        <v-card>
          <v-toolbar flat color="primary">
            <h2 class="white--text">Oops!</h2>
          </v-toolbar>
          <v-card-text>
            <h3
              :style="{
                color: $store.state.currentOrg.orderSecondaryColour
                  ? $store.state.currentOrg.orderSecondaryColour
                  : $store.state.currentOrg.secondaryColour,
              }"
              class="align-center section-heading font-weight-light"
            >
              {{ errorMessage }}
            </h3>
          </v-card-text>
          <v-card-actions class="justify-center layout px-0 py-3">
            <v-btn color="primary" rounded dark @click="showError = false">
              OK
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Unit selection modal -->
      <v-dialog v-model="selectUnitModal" width="60vw" persistent>
        <v-card>
          <v-toolbar flat color="primary">
            <v-card-title class="headline white--text" dark primary-title>
              Find My Address
            </v-card-title>
          </v-toolbar>
          <v-card-text>
            <v-spacer></v-spacer>
            <v-data-table
              fixed-header
              :search="search"
              :headers="unitModalHeaders"
              class="elevation-1"
              @click:row="selectUnit"
              :expand="expand"
              :loading="loading"
              :items="unitList"
              :footer-props="{
                'items-per-page-options': [10, 25, 50, 100],
              }"
              item-key="name"
              style="cursor: pointer"
              align-center
            >
              <template v-slot:top>
                <v-toolbar flat>
                  <v-spacer></v-spacer>
                  <v-text-field v-model="search" append-icon="search" label="Search"></v-text-field>
                </v-toolbar>
              </template>

              <!-- Custom Row count and Paging text -->
              <template v-slot:pageText="props">
                Records {{ props.pageStart }} - {{ props.pageStop }} of
                {{ props.itemsLength }}
              </template>
            </v-data-table>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="selectUnitModal = false">
              Cancel
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Signature modal -->
      <v-dialog v-model="signature" width="750" id="MySignaturePad"> </v-dialog>

      <!-- ISP Agreement Modal -->
      <v-dialog v-model="viewISPAgreement" persistent width="750px">
        <v-card flat v-if="agreement">
          <v-toolbar flat color="primary">
            <h3 class="title white--text">{{ agreement.name }}</h3>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text style="overflow-y: auto; max-height: 600px">
            <vue-simple-markdown
              v-if="agreement.content"
              class="text-xs-left"
              :key="agreement.content"
              :image="true"
              :source="agreement.content"
            ></vue-simple-markdown>
          </v-card-text>
          <v-card-actions>
            <v-row justify="center">
              <v-btn
                rounded
                color="primary"
                class="white--text"
                @click="(acceptISPAgreement = true), (viewISPAgreement = false)"
                >I Accept</v-btn
              >
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- ISP Terms Modal -->
      <v-dialog v-model="viewISPTerms" persistent width="750px">
        <v-card flat v-if="ispTerms">
          <v-toolbar flat color="primary">
            <h3 class="title white--text">{{ ispTerms.name }}</h3>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text style="overflow-y: auto; max-height: 400px">
            <vue-simple-markdown
              v-if="ispTerms.content"
              class="text-xs-left"
              :key="ispTerms.content"
              :image="true"
              :source="ispTerms.content"
            ></vue-simple-markdown>
          </v-card-text>
          <v-card-actions>
            <v-row justify="center">
              <v-btn
                rounded
                color="primary"
                class="white--text"
                @click="(ISPTermsSigned = true), (viewISPTerms = false)"
                >I Accept</v-btn
              >
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- FNO Terms Modal -->
      <v-dialog v-model="viewFnoTerms" persistent width="750px">
        <v-card flat v-if="fnoTerms">
          <v-toolbar flat color="primary">
            <h3 class="title white--text">{{ fnoTerms.name }}</h3>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text style="overflow-y: auto; max-height: 400px">
            <vue-simple-markdown
              v-if="fnoTerms.content"
              class="text-xs-left"
              :key="fnoTerms.content"
              :image="true"
              :source="fnoTerms.content"
            ></vue-simple-markdown>
          </v-card-text>
          <v-card-actions>
            <v-row justify="center">
              <v-btn rounded color="primary" class="white--text" @click="(termsSigned = true), (viewFnoTerms = false)"
                >I Accept</v-btn
              >
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="otpModal" width="500px">
        <v-card flat color="white">
          <v-toolbar flat color="white">
            <h3 class="grey--text">One Time Pin</h3>
            <v-spacer></v-spacer>
            <v-btn text @click="otpModal = false">X</v-btn>
          </v-toolbar>
          <v-card-text>
            <v-row ma-2 justify="center" class="text-xs-center">
              <v-col cols="12" sm="10">
                <span style="color: grey">
                  We have sent a 4-digit code to
                  <b>{{ detail.primaryContact.emailAddress }}</b
                  >. Please check in your spam folder if not found.
                </span>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
    <!-- </v-form> -->
  </v-form>
  </div>
</template>
<script>
import Vue from "vue";
import Api from "@/services/Api.js";
import axios from "axios";
import PackagesIspsCards from "@/components/PackagesIspsCards.vue";
import ProductCards from "@/components/ProductCards.vue";
import VueSignaturePad from "vue-signature-pad";
import Loading from "vue-loading-overlay";
import GeoJsonGeometriesLookup from "geojson-geometries-lookup";
import { gmapApi } from "vue2-google-maps";
import AddressInfo from './pageComponents/AddressInfo.vue'
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
Vue.use(VueSignaturePad);
var disabledDates = [
  "2019-12-23",
  "2019-12-24",
  "2019-12-25",
  "2019-12-26",
  "2019-12-27",
  "2019-12-28",
  "2019-12-29",
  "2019-12-30",
  "2019-12-31",
  "2020-01-01",
  "2020-01-02",
  "2020-01-03",
  "2020-01-04",
  "2020-01-05",
  "2020-01-06",
  "2020-01-07",
  "2020-01-08",
  "2020-01-09",
  "2020-01-10",
];

export default {
  org: [],
  name: "MySignaturePad",
  components: {
    AddressInfo,
    PackagesIspsCards: PackagesIspsCards,
    ProductCards: ProductCards,
    Loading,
  },
  data() {
    return {
      outsidePolygons:false,
      termsSignedShowInterest:false,
      agreeShareDetails:false,
      keyHeader: 0,
      networkStatus: [
        { name: "Live", colour: "green" },
        { name: "Under Construction", colour: "blue" },
        { name: "Planned", colour: "orange" },
      ],
      verifyResult: "",
      checkProceedToSummaryButton: false,
      stepHeaders: [],
      submittingApplication: false,
      agreement: null,
      ispTerms: null,
      fnoTerms: null,
      acceptISPAgreement: false,
      viewISPAgreement: false,
      viewFnoTerms: false,
      viewISPTerms: false,
      keyEmail: 0,
      isSuccessful: null,
      firstOtp: 0,
      verifyEmailComplete: false,
      otp: "",
      otp1: "",
      otp2: "",
      otp3: "",
      otp4: "",
      otpModal: false,
      payNowInfo: null,
      payNowForm: {},
      verifyEmailCode: false,
      productArray: [],
      loadingAddressModal: false,
      foundLocationModal: false,
      isInWirelessRange: false,
      loadingFeasibility: false,
      oopsModal: false,
      center: { lat: -33.919473, lng: 18.427059 },
      locationMarker: {},
      errorWindow: false,
      locationInfo: {},
      networkData: {},
      locationInfoWindowOpen: false,
      geocoder: null,
      geoData: {},
      glookup: null,
      markers: [],
      places: [],
      polyInfo: {},
      map: undefined,
      mapLoaded: false,
      markerData: {},
      currentPlace: null,
      item: {},
      key: 0,
      myCityData: null,
      networkPolygons: [],
      infoContent: "",
      myStyles: [
        {
          elementType: "geometry",
          stylers: [
            {
              color: "#f5f5f5",
            },
          ],
        },
        {
          elementType: "labels.icon",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#616161",
            },
          ],
        },
        {
          elementType: "labels.text.stroke",
          stylers: [
            {
              color: "#f5f5f5",
            },
          ],
        },
        {
          featureType: "administrative",
          elementType: "geometry",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "administrative.land_parcel",
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#bdbdbd",
            },
          ],
        },
        {
          featureType: "poi",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "poi",
          elementType: "geometry",
          stylers: [
            {
              color: "#eeeeee",
            },
          ],
        },
        {
          featureType: "poi",
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#757575",
            },
          ],
        },
        {
          featureType: "poi.park",
          elementType: "geometry",
          stylers: [
            {
              color: "#e5e5e5",
            },
          ],
        },
        {
          featureType: "poi.park",
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#9e9e9e",
            },
          ],
        },
        {
          featureType: "road",
          elementType: "geometry",
          stylers: [
            {
              color: "#ffffff",
            },
          ],
        },
        {
          featureType: "road",
          elementType: "labels.icon",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "road.arterial",
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#757575",
            },
          ],
        },
        {
          featureType: "road.highway",
          elementType: "geometry",
          stylers: [
            {
              color: "#dadada",
            },
          ],
        },
        {
          featureType: "road.highway",
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#616161",
            },
          ],
        },
        {
          featureType: "road.local",
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#9e9e9e",
            },
          ],
        },
        {
          featureType: "transit",
          stylers: [
            {
              visibility: "off",
            },
          ],
        },
        {
          featureType: "transit.line",
          elementType: "geometry",
          stylers: [
            {
              color: "#e5e5e5",
            },
          ],
        },
        {
          featureType: "transit.station",
          elementType: "geometry",
          stylers: [
            {
              color: "#eeeeee",
            },
          ],
        },
        {
          featureType: "water",
          elementType: "geometry",
          stylers: [
            {
              color: "#c9c9c9",
            },
          ],
        },
        {
          featureType: "water",
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#9e9e9e",
            },
          ],
        },
      ],
      addressPromptWindow: false,
      addressInformation: {},
      infoWindowPos: {
        lat: 0,
        lng: 0,
      },
      infoWinOpen: false,
      currentMidx: null,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35,
        },
      },
      searchLocation: "",
      zoom: 14,
      loading: false,
      componentKey: 0,
      providerListGroup: [
        {
          title: "Providers",
          providerListGroup: [{ title: "All Providers" }],
        },
      ],
      priceListGroup: [
        {
          title: "Price",
          priceListGroup: [{ title: "All Providers" }],
        },
      ],
      speedListGroup: [
        {
          title: "Speed",
          speedListGroup: [{ title: "All Providers" }],
        },
      ],
      editIfValidEstate: false,
      editIfValidPackage: false,
      editIfValidDate: false,
      editIfValidContact: false,
      editIfValidSummary: false,
      editIfValidSubmit: false,
      altlabel: true,
      about: null,
      val: false,
      e1: 1,
      chooseTerms: false,
      chooseComplete: false,
      chooseEstate: true,
      choosePackage: false,
      chooseAdditional: false,
      chooseAddress: false,
      chooseContact: false,
      chooseSummary: false,
      chooseSubmit: false,
      key: 0,
      productCards: [],
      packagesIsps: [],
      customerList: [],
      installFee: false,
      acceptInfoSharing: false,
      businessInstallFee: null,
      residentialInstallFee: null,
      valid: false,
      allPackages: [],
      providerList: [],
      fnoPackagesResidentialPromoSpeeds: [],
      fnoPackagesBusinessPromoSpeeds: [],
      fnoPackagesPromoIdList: [],
      fnoPromoPackages: [],
      wirelessHighSites: [],
      appLoading: false,
      loadingText: null,
      packagesLoading: false,
      dateRules: [(v) => !!v || "Date is required"],
      nameRules: [(v) => !!v || "Name is required"],
      surnameRules: [(v) => !!v || "Last Name is required"],
      contactNumberRules: [
        (v) => !!v || "Contact Number is required",
        (v) => (v && v.length > 9) || "Contact Number should be 10 digits",
      ],
      idNumberRules: [
        (v) => !!v || "ID Number is required",
        (v) => (v && v.length > 8) || "Please Enter a Valid ID Number",
      ],
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) =>
          /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
            v
          ) || "E-mail must be valid",
      ],
      titleRules: [(v) => !!v || "Title is required"],
      unitModalHeaders: [
        {
          text: "Unit Number",
          align: "center",
          value: "unitNo",
        },
        {
          text: "Erf Number",
          align: "center",
          value: "erfNo",
        },
        {
          text: "Floor Number",
          align: "center",
          value: "floorNo",
        },
        {
          text: "Street",
          align: "center",
          value: "complexStreetName",
        },
        {
          text: "Sub Complex",
          align: "center",
          value: "locationNetworkSubCOmplex.subComplexName",
        },
      ],
      locationTemplate: null,
      detail: {
        primaryContact: {},
        secondaryContact: {},
        address: {
          unitNumber: null,
          fullUnitDetails: null,
        },
        billingAddressSame: true,
        isPropertyOwner: true,
        isPropertyTenant: false,
        internetPackageSelected: false,
        includeTVOverFibrePackage: false,
        tenantContact: {},
        ownerContact: {},
        billingContact: {},
        activationDate: "",
        selectedInternetPackage: null,
        selectedNetwork: {},
        showSecondaryContact: false,
        addBillingContact: false,
        signature: null,
        isBusiness: false,
        organisationName: "",
      },
      filter: {
        speedDownload: [0, 1],
        speedUpload: [0, 1],
        highestSpeedProfileDownload: 1000,
        lowestSpeedProfileDownload: 1,
        highestSpeedProfileUpload: 1000,
        lowestSpeedProfileUpload: 1,
        downloadLabels: [],
        uploadLabels: [],
        showBusiness: false,
        showAll: true,
        showResidential: false,
        providerList: [],
      },
      flags: {
        addPackageSelected: false,
        hasBusinessPacks: false,
      },
      titles: ["Mr", "Mrs", "Miss", "Dr", "Prof", "Sir", "Madam", "Other"],
      provinces: [
        "Eastern Cape",
        "Free State",
        "Gauteng",
        "KwaZulu-Natal",
        "Limpopo",
        "Mpumalanga",
        "Northern Cape",
        "North-West",
        "Western Cape",
      ],
      estateList: [],
      unitList: [],
      unusedUnitList: [],
      errorMessage: "",
      showError: false,
      success: false,
      formComplete: false,
      signature: false,
      termsSigned: false,
      ISPTermsSigned: false,
      showSignature: false,
      selectUnitModal: false,
      activationDateSelection: false,
      signatureIsEmpty: true,
      loading: false,
      expand: false,
      search: "",
      minActivationDate: null,
      pagination: { totalItems: 0 },
      fullPage: true,
      editIfValid: false,
      max: 1,
      estateArr: ["1"],
      borderId: null,
      confirmAddress: false,
    };
  },
  watch: {
    chooseSummary(value) {
      if (value && this.detail.selectedInternetPackage) {
        this.fetchISPUserAgreements();
        this.fetchISPTerms();
        this.checkNetcashIntegration();
      } else if (value && !this.detail.selectedInternetPackage) {
        this.agreement = null;
        this.ispTerms = null;
        this.detail.netcashIntegration = false;
      }
    },
    "$store.state.isUserLoggedIn": {
      immediate: true,
      async handler(value) {
        if (value === true) {
          this.detail.primaryContact.title = this.$store.state.user.title;
          this.detail.primaryContact.firstName = this.$store.state.user.name;
          this.detail.primaryContact.lastName = this.$store.state.user.surname;
          this.detail.primaryContact.contactNumber = this.$store.state.user.mobileNumber;
          this.detail.primaryContact.emailAddress = this.$store.state.user.emailAddress;
          this.detail.primaryContact.idNumber = this.$store.state.user.idNumber;
          this.verifyEmailComplete = true;
          this.isSuccessful = true;
          this.keyEmail++;
        }
        // else{
        //   this.detail.primaryContact.title = ''
        // this.detail.primaryContact.firstName = ''
        // this.detail.primaryContact.lastName = ''
        // this.detail.primaryContact.contactNumber = ''
        // this.detail.primaryContact.emailAddress = ''
        // this.detail.primaryContact.idNumber = ''
        // this.verifyEmailComplete= false
        // this.isSuccessful=false
        // this.keyEmail++;
        // }
      },
    },
    // chooseEstate(value) {
    //   if (value == true) {
    //     setTimeout(() => {
    //       this.plotMap();
    //     }, 1000);
    //   }
    // },
    locationTemplate(value) {
      if (typeof value !== "undefined" && value !== null) {
        this.selectUnit(value);
      }
    },
    "detail.address.estate": {
      immediate: true,
      handler(value) {
        this.estateArr.push(value);
        if (this.estateArr[0] != value) {
          this.max = 1;
        }
        this.estateArr.shift();
      },
    },
    // "$vuetify.breakpoint.xs": {
    //   immediate: true,
    //   handler(value) {
    //     if (value) {
    //       this.altlabel = false;
    //     } else {
    //       this.altlabel = true;
    //     }
    //   },
    // },
    choosePackage: {
      immediate: true,
      handler(value) {
        if (value) {
          if (
            this.detail.selectedInternetPackage !== null &&
            typeof this.detail.selectedInternetPackage !== "undefined"
          ) {
            this.borderId = this.detail.selectedInternetPackage.id;
          }
        }
      },
    },
  },
  computed: {
    google: gmapApi,
    termsAllSigned() {
      if (
        this.detail.selectedInternetPackage != null &&
        this.detail.selectedInternetPackage.customerOrganisationId != this.$store.state.currentOrg.id &&
        this.ISPTermsSigned &&
        this.termsSigned &&
        this.acceptInfoSharing
      ) {
        return true;
      } else if (
        this.detail.selectedInternetPackage != null &&
        this.detail.selectedInternetPackage.customerOrganisationId == this.$store.state.currentOrg.id &&
        this.termsSigned &&
        this.acceptInfoSharing
      ) {
        return true;
      } else if (this.detail.selectedInternetPackage == null && this.termsSigned) {
        return true;
      } else {
        return false;
      }
    },
    pages() {
      if (this.pagination.rowsPerPage == null || this.pagination.totalItems == null)
        this.pages = Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage);
      return 0;
      return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage);
    },
  },
  created() {    
    this.initialize();
    this.fetchFNOTerms();

    if (this.$store.state.currentOrg.enablePaymentGateway) {
      this.fetchPayNowServiceDetails();
    }
  },
  mounted() {
    // this.plotMap();
  },
  methods: {
    circleLocation(event) {
      if (this.detail.address.estate == "My area is not in the list") {
        this.confirmAddress = false;
        this.center = {
          lat: event.latLng.lat(),
          lng: event.latLng.lng(),
        };
        this.locationMarker = this.center;
        this.getAddressData(event);
      }
    },
    fetchPayNowServiceDetails() {
      Api()
        .get("/netcash/PayNow")
        .then((res) => {
          this.payNowInfo = res.data;
        });
    },
    submitShowOfInterest(type) {
      if (this.checkForm()) {
        this.detail.address.coordinates = null;
        if (this.detail.address.lat && this.detail.address.lng) {
          this.detail.address.coordinates = JSON.stringify({
            lat: this.detail.address.lat,
            lng: this.detail.address.lng,
          });
        }
        let base64String = "";
        this.detail.primaryContact.emailAddress = this.detail.primaryContact.emailAddress.replace(/\s/g, "");
        if (typeof this.detail.secondaryContact.emailAddress !== "undefined") {
          this.detail.secondaryContact.emailAddress = this.detail.secondaryContact.emailAddress.replace(/\s/g, "");
        }
        if (typeof this.detail.billingContact.emailAddress !== "undefined") {
          this.detail.billingContact.emailAddress = this.detail.billingContact.emailAddress.replace(/\s/g, "");
        }
        if (this.detail.selectedInternetPackage !== null) {
          if (this.detail.selectedInternetPackage.packagesFno.packagesFnoCat.packageCatType == "Business") {
            this.detail.isBusiness = true;
          } else {
            this.detail.isBusiness = false;
          }
          // base64String = this.getBase64Image(
          //   this.detail.selectedInternetPackage.customerOrganisation.logo
          // );
        }
        if (this.locationTemplate) {
          this.detail.supplierOrganisationId = this.locationInfo.fno.id;
          this.detail.streetNumber = this.locationTemplate.unitNo;
          this.detail.streetName = this.locationTemplate.complexStreetName;
        } else {
          this.detail.supplierOrganisationId = this.org.id;
          this.detail.streetNumber = this.addressInformation.streetNumber;
          this.detail.streetName = this.addressInformation.streetName;
        }
        this.detail.leadType = type;
        this.detail.agreeShareDetails = this.agreeShareDetails
        Api()
          .post("/ftthApplication/lead", {
            data: this.detail,
          })
          .then((response) => {
            this.chooseComplete = true;
            this.e1 = 0;
          });
      }
    },
    setHeaderModal(action, card, setMax) {
      if (action == "next") {
        let find = this.stepHeaders.find((x) => x.card == card);
        let index = this.stepHeaders.indexOf(find);

        if (setMax == true) {
          this.max = index + 2;
          this.e1 = index + 2;
        } else {
          this.e1 = index + 2;
        }
        this.stepHeaders[index].next();
        this.resize();
        // this.keyHeader++;
      } else if (action == "previous") {
        let find = this.stepHeaders.find((x) => x.card == card);
        let index = this.stepHeaders.indexOf(find);

        this.e1 = index;

        this.stepHeaders[index].previous();
        this.resize();
        // this.keyHeader++;
      }
    },
    calculateStepContent(card) {
      let find = this.stepHeaders.find((x) => x.card == card);

      let index = this.stepHeaders.indexOf(find);

      if (find) {
        return index + 1;
      } else {
        return 0;
      }
    },
    calculateMaxModal(card) {
      let find = this.stepHeaders.find((x) => x.card == card);
      let index = this.stepHeaders.indexOf(find);
      return index + 1;
    },
    setStepperHeader() {
      if (this.detail.showInterest == true) {
        this.stepHeaders = [
          {
            editCheck: this.editIfValidEstate,
            clickEvent: this.stepEstate,
            name: "Address Info",
            card: "chooseEstate",
            next: this.stepContactShowInterest,
          },
          {
            editCheck: this.editIfValidContact,
            clickEvent: this.stepContactShowInterest,
            name: "Contact Info",
            card: "chooseContact",
            previous: this.stepEstate,
          },
        ];
      } else {
        if (this.productCards.length > 0) {
          this.stepHeaders = [
            {
              editCheck: this.editIfValidEstate,
              clickEvent: this.stepEstate,
              name: "Address Info",
              card: "chooseEstate",
              next: this.stepPackage,
            },
            {
              editCheck: this.editIfValidPackage,
              clickEvent: this.stepPackage,
              name: "Package",
              card: "choosePackage",
              previous: this.stepEstate,
              next: this.stepDate,
            },
            {
              editCheck: this.editIfValidDate,
              clickEvent: this.stepDate,
              name: "Products",
              card: "chooseAdditional",
              previous: this.stepPackage,
              next: this.stepContactProduct,
            },
            {
              editCheck: this.editIfValidContact,
              clickEvent: this.stepContactProduct,
              name: "Contact Info",
              card: "chooseContact",
              previous: this.stepDate,
              next: this.stepSummaryProduct,
            },
            {
              editCheck: this.editIfValidSummary,
              clickEvent: this.stepSummaryProduct,
              name: "Order Summary",
              card: "chooseSummary",
              previous: this.stepContactProduct,
              next: this.stepSubmitProduct,
            },
            {
              editCheck: this.editIfValidSubmit,
              clickEvent: this.stepSubmitProduct,
              name: "Submit",
              card: "chooseTerms",
              previous: this.stepSummaryProduct,
            },
          ];
        } else {
          this.stepHeaders = [
            {
              editCheck: this.editIfValidEstate,
              clickEvent: this.stepEstate,
              name: "Address Info",
              card: "chooseEstate",
              next: this.stepPackage,
            },
            {
              editCheck: this.editIfValidPackage,
              clickEvent: this.stepPackage,
              name: "Package",
              card: "choosePackage",
              previous: this.stepEstate,
              next: this.stepContactNoProduct,
            },
            {
              editCheck: this.editIfValidContact,
              clickEvent: this.stepContactNoProduct,
              name: "Contact Info",
              card: "chooseContact",
              previous: this.stepPackage,
              next: this.stepSummaryNoProduct,
            },
            {
              editCheck: this.editIfValidSummary,
              clickEvent: this.stepSummaryNoProduct,
              name: "Order Summary",
              card: "chooseSummary",
              previous: this.stepContactNoProduct,
              next: this.stepSubmitNoProduct,
            },
            {
              editCheck: this.editIfValidSubmit,
              clickEvent: this.stepSubmitNoProduct,
              name: "Submit",
              card: "chooseTerms",
              previous: this.stepSummaryNoProduct,
            },
          ];
        }
      }
    },
    checkProceedToSummary() {
      if (this.$store.state.isUserLoggedIn) {
        this.checkProceedToSummaryButton = true;
      }
    },
    async fetchISPUserAgreements() {
      await Api()
        .get("/agreements/endUser/" + this.detail.selectedInternetPackage.customerOrganisationId)
        .then((res) => {
          let result = res.data;
          if (result.content) {
            result.content = result.content.replace(/@firstname/g, this.detail.primaryContact.firstName);
            result.content = result.content.replace(/@lastname/g, this.detail.primaryContact.lastName);
            result.content = result.content.replace(/@emailAddress/g, this.detail.primaryContact.emailAddress);
            result.content = result.content.replace(/@timestamp/g, new Date());
          }
          this.agreement = result;
        });
    },
    async fetchISPTerms() {
      await Api()
        .get("/agreements/termsAndConditions/" + this.detail.selectedInternetPackage.customerOrganisationId)
        .then((res) => {
          let result = res.data;
          if (result.content) {
            result.content = result.content.replace(/@firstname/g, this.detail.primaryContact.firstName);
            result.content = result.content.replace(/@lastname/g, this.detail.primaryContact.lastName);
            result.content = result.content.replace(/@emailAddress/g, this.detail.primaryContact.emailAddress);
            result.content = result.content.replace(/@timestamp/g, new Date());
          }
          this.ispTerms = result;
        });
    },
    async fetchFNOTerms() {
      await Api()
        .get("/agreements/termsAndConditions")
        .then((res) => {
          let result = res.data;
          if (result.content) {
            result.content = result.content.replace(/@firstname/g, this.detail.primaryContact.firstName);
            result.content = result.content.replace(/@lastname/g, this.detail.primaryContact.lastName);
            result.content = result.content.replace(/@emailAddress/g, this.detail.primaryContact.emailAddress);
            result.content = result.content.replace(/@timestamp/g, new Date());
          }
          this.fnoTerms = result;
        });
    },

    async checkNetcashIntegration() {
      await Api()
        .get("/netcash/checkIntegration/" + this.detail.selectedInternetPackage.customerOrganisationId)
        .then((res) => {
          this.detail.netcashIntegration = res.data;
        });
    },
    assertMaxChars(otp) {
      if (otp.length >= 1) {
        this.otp1 = this.otp1.substring(0, 1);
        this.otp2 = this.otp2.substring(0, 1);
        this.otp3 = this.otp3.substring(0, 1);
        this.otp4 = this.otp4.substring(0, 1);
      }
    },
    onComplete(value) {
      Api()
        .post("/compareOtp", {
          otp: value,
          emailAddress: this.detail.primaryContact.emailAddress,
        })
        .then((response) => {
          if (response.data.result === "Email Verified") {
            this.verifyEmailComplete = true;
            this.verifyResult = "Verification Successful";
            this.isSuccessful = true;
            this.keyEmail++;
          } else if (response.data.result === "OTP Expired") {
            this.isSuccessful = false;
            this.verifyResult = "OTP Expired";
            this.keyEmail++;
          } else if (response.data.result === "Verification Unsuccessful") {
            this.isSuccessful = false;
            this.verifyResult = "Verification Unsuccessful";
            this.keyEmail++;
          }
        });
    },
    sendOtp(email) {
      Api()
        .post("/sendOtp", {
          emailAddress: email,
        })
        .then((response) => {
          this.otp = response.data.result;
          this.firstOtp++;
          this.otpModal = true;
          // confirm(
          //   "We have sent a 4-digit code to " +
          //     email +
          //     ". Please check in your spam folder if not found."
          // );
          this.verifyEmailCode = true;
        });
    },
    goToWebUrl(websiteUrl) {
      if (websiteUrl) {
        // window.open(websiteUrl, "_blank");
      }
    },
    stepEstate() {
      (this.chooseEstate = true), (this.e1 = 1);
      // if (this.max >= 1) {
      //   this.editIfValidEstate = true;
      // } else {
      //   this.editIfValidEstate = false;
      // }
    },
    stepPackage() {
      if (this.max < 2) {
        this.max = 2;
      }
      (this.choosePackage = true), (this.e1 = 2);
      if (this.max >= 2) {
        this.editIfValidPackage = true;
      } else {
        this.editIfValidPackage = false;
      }
    },
    stepDate() {
      if (this.max < 3) {
        this.max = 3;
      }
      (this.chooseAdditional = true), (this.e1 = 3);
      if (this.max >= 3) {
        if (this.detail.activationDate != null) {
          this.editIfValidDate = true;
        } else {
          this.editIfValidDate = false;
        }
      } else {
        this.editIfValidDate = false;
      }
    },
    stepContactNoProduct() {
      if (this.max < 3) {
        this.max = 3;
      }

      (this.chooseContact = true), (this.e1 = 3);
      if (this.max >= 3) {
        this.editIfValidContact = true;
      } else {
        this.editIfValidContact = false;
      }
    },
    stepContactShowInterest() {
      if (this.max < 2) {
        this.max = 2;
      }
      (this.chooseContact = true), (this.e1 = 2);
      if (this.max >= 2) {
        this.editIfValidContact = true;
      } else {
        this.editIfValidContact = false;
      }
    },
    stepContactProduct() {
      if (this.max < 4) {
        this.max = 4;
      }

      (this.chooseContact = true), (this.e1 = 4);
      if (this.max >= 4) {
        this.editIfValidContact = true;
      } else {
        this.editIfValidContact = false;
      }
    },
    stepSummaryProduct() {
      if (this.max < 5) {
        this.max = 5;
      }
      (this.chooseSummary = true), (this.e1 = 5);
      if (this.max >= 5) {
        this.editIfValidSummary = true;
      } else {
        this.editIfValidSummary = false;
      }
    },
    stepSubmitProduct() {
      if (this.max < 6) {
        this.max = 6;
      }
      (this.chooseTerms = true), (this.e1 = 6);
      if (this.max >= 6) {
        this.editIfValidSubmit = true;
      } else {
        this.editIfValidSubmit = false;
      }
    },
    stepSummaryNoProduct() {
      if (this.max < 4) {
        this.max = 4;
      }
      (this.chooseSummary = true), (this.e1 = 4);
      if (this.max >= 4) {
        this.editIfValidSummary = true;
      } else {
        this.editIfValidSummary = false;
      }
    },
    stepSubmitNoProduct() {
      if (this.max < 5) {
        this.max = 5;
      }
      (this.chooseTerms = true), (this.e1 = 5);
      if (this.max >= 5) {
        this.editIfValidSubmit = true;
      } else {
        this.editIfValidSubmit = false;
      }
    },
    resize() {
      // window.scrollTo(0, 0);
    },
    clearDetail() {
      this.detail.address.unitNumber = null;
      this.detail.address.fullUnitDetails = null;
      this.detail.address.estate = null;
      (this.oopsModal = false), (this.loadingAddressModal = false), (this.foundLocationModal = false);
      this.e1 = 1;
      this.chooseEstate = true;
      this.chooseComplete = false;
      // if (this.$store.state.currentOrg.redirectUrl) {
      //   window.open(this.$store.state.currentOrg.redirectUrl, "_self");
      // } else {
      //   window.location.reload(false);
      // }
    },
    // getAddressData: async function(addressData) {
     
    //   //this.confirmAddress = false;
    //   var latlng = new google.maps.LatLng(addressData.latLng.lat(), addressData.latLng.lng());
    //   this.infoWindowPos = {
    //     lat: addressData.latLng.lat(),
    //     lng: addressData.latLng.lng(),
    //   };
    //   let resultData = null;
    //   var geocoder = new google.maps.Geocoder();
    //   await geocoder.geocode(
    //     {
    //       latLng: latlng,
    //     },
    //     async function(results, status) {
    //       if (status === google.maps.GeocoderStatus.OK) {
    //         if (results[1]) {
    //           resultData = results[1];
    //         } else {
    //           alert("No results found");
    //         }
    //       } else {
    //         alert("Geocoder failed due to: " + status);
    //       }
    //     }
    //   );
    //   this.searchLocation = resultData.formatted_address;
    //   if (
    //     resultData.address_components.find((x) => x.types.includes("street_number")) &&
    //     resultData.address_components.find((x) => x.types.includes("route"))
    //   ) {
    //     this.addressInformation = {
    //       streetNumber: resultData.address_components.find((x) => x.types.includes("street_number")).long_name,
    //       streetName: resultData.address_components.find((x) => x.types.includes("route")).long_name,
    //     };
    //     this.confirmAddress = true;
    //   }
    // },
//     plotMap() {
//       this.$refs.mapRef.$mapPromise.then((map) => {
//         // this.initMapAutocompletePlot();
//         // this.initMapAutocompleteOutsideNetworks();
//         this.map = map;
//         this.mapLoaded = true;
//         this.map.data.addGeoJson(this.geoData);
//         this.map.data.setStyle((feature) => {
//           let color = "";
//           if ((feature.h&&feature.h.network.networkStatus === "Live")||(feature.i&&feature.i.network.networkStatus === "Live")) {
//             color = "green";
//           } else if ((feature.h&&feature.h.network.networkStatus === "In Progress")||(feature.i&&feature.i.network.networkStatus === "In Progress")) {
//             color = "blue";
//           } else if ((feature.h&&feature.h.network.networkStatus === "Planned")||(feature.i&&feature.i.network.networkStatus === "Planned")) {
//             color = "orange";
//           }
//           return {
//             fillColor: color,
//             fillOpacity: 0.3,
//             strokeWeight: 2,
//             strokeColor: color,
//           };
//         });
//         this.polyInfo = {};
//         this.locationInfo = {};
//         this.infoWinOpen = false;
//         this.locationMarker = {};
//         this.locationInfoWindowOpen = false;
//         this.map.data.addListener("click", (event) => {
//           if(event.feature.i){
// this.polyInfo = {
//             type: "Network",
//             name: event.feature.i.name,
//             units: event.feature.i.units,
//             fno: event.feature.i.fno,
//             network: event.feature.i.network,
//           };
//           }else if(event.feature.h){
// this.polyInfo = {
//             type: "Network",
//             name: event.feature.h.name,
//             units: event.feature.h.units,
//             fno: event.feature.h.fno,
//             network: event.feature.h.network,
//           };
//           }
          
//           this.detail.address.estate = this.polyInfo.network.id;
//           this.setUnitList(this.polyInfo.network.id);
//           this.openWindow(event);
//           let testPoly = new google.maps.Polygon({
//             paths: event.feature
//               .getGeometry()
//               .getAt(0)
//               .getArray(),
//           });
//           if (google.maps.geometry.poly.containsLocation(event.latLng, testPoly)) {
//             console.log(this.polyInfo);
//             this.searchLocation = this.polyInfo.name;
//           }
//         });
//       });
    // },
    // async initMapAutocompletePlot() {
     
    //   const input = document.getElementById("pac-input");
    //   console.log(this);
    //   const autocomplete = new this.google.maps.places.Autocomplete(input, {});
    //   autocomplete.setComponentRestrictions({
    //     country: ["za"],
    //   });
      
    //   // this.fetchPackages(this.detail.address.estate, "Fibre");
    //   google.maps.event.addListener(autocomplete, "place_changed", async () => {
    //    this.outsidePolygons=false
    //     this.detail.feasibilityTestData = null;
    //     this.locationInfoWindowOpen = false;
    //     this.errorWindow = false;
    //     const place = autocomplete.getPlace();
    //     const location = place.geometry.location;
    //     const point = {
    //       type: "Point",
    //       coordinates: [location.lng(), location.lat()],
    //     };
    //     let testPoly = this.glookup.getContainers(point);
    //     let curPlace = autocomplete.getPlace();
    //     this.center = curPlace.geometry.location;
    //     this.locationMarker = this.center;
    //     let streetNumber = curPlace.address_components.find((x) => x.types.includes("street_number"));
    //     let streetName = curPlace.address_components.find((x) => x.types.includes("route"));
    //     if (testPoly.features.length > 0) {
    //       if (!streetName || !streetNumber) {
    //         let predictedStreet = autocomplete.gm_accessors_.place.qe.formattedPrediction.split(", ");
    //         let number = predictedStreet[0].substr(0, predictedStreet[0].indexOf(" "));
    //         let street = predictedStreet[0].substr(predictedStreet[0].indexOf(" ") + 1);
    //         this.locationTemplate = this.unitList.find((x) => x.unitNo == number && x.complexStreetName == street);
    //         this.searchLocation = autocomplete.gm_accessors_.place.qe.formattedPrediction;

    //         if (this.locationTemplate) {
    //           this.locationInfo = {
    //             address: curPlace.formatted_address,
    //             location: {
    //               fibrePulled: this.locationTemplate.fibrePulled,
    //               equipmentInstalled: this.locationTemplate.equipmentInstalled,
    //             },
    //           };
    //           this.fetchPackages(this.detail.address.estate, "Fibre");
    //           this.locationInfoWindowOpen = true;
    //         } else {
    //           this.addressInformation = {
    //             streetNumber: number,
    //             streetName: street,
    //           };
    //           this.fetchPackages(this.detail.address.estate, "Fibre");
    //           this.addressPromptWindow = true;
    //         }
    //         this.fetchPackages(this.detail.address.estate, "Fibre");
    //       } else {
    //         this.locationTemplate = this.unitList.find(
    //           (x) => x.unitNo == streetNumber.short_name && x.complexStreetName == streetName.short_name
    //         );
    //         this.searchLocation = curPlace.formatted_address;
    //         this.detail.address.lat = JSON.stringify(location.lat());
    //         this.detail.address.lng = JSON.stringify(location.lng());

    //         if (this.locationTemplate) {
    //           this.locationInfo = {
    //             address: curPlace.formatted_address,
    //             //fno: this.networkData.organisation,
    //             location: {
    //               fibrePulled: this.locationTemplate.fibrePulled,
    //               equipmentInstalled: this.locationTemplate.equipmentInstalled,
    //             },
    //           };
    //           this.fetchPackages(this.detail.address.estate, "Fibre");
    //           this.locationInfoWindowOpen = true;
    //         } else {
    //           this.addressInformation = {
    //             streetNumber: streetNumber.short_name,
    //             streetName: streetName.short_name,
    //           };
    //           this.fetchPackages(this.detail.address.estate, "Fibre");
    //           this.addressPromptWindow = true;
    //         }
    //         this.fetchPackages(this.detail.address.estate, "Fibre");
    //         this.zoom = 15;
    //       }
    //     } else {
    //       this.addressInformation = {
    //         streetNumber: streetNumber ? streetNumber.short_name : this.searchLocation.split(" ")[0],
    //         streetName: streetName ? streetName.short_name : this.searchLocation,
    //       };
    //       this.locationMarker = this.center;
    //       this.errorWindow = true;
    //       let feasible = await this.testLineOfSight(this.center);
    //       this.isInWirelessRange = feasible.length > 0 && feasible.filter((x) => x.success).length > 0;
    //       this.detail.address.lat = JSON.stringify(location.lat());
    //       this.detail.address.lng = JSON.stringify(location.lng());
    //       this.fetchPackages(this.detail.address.estate, "Wireless");
    //     }
    //     this.key++
    //   });
    // },
    openWindow(data) {
      this.infoWindowPos = {
        lat: data.latLng.lat(),
        lng: data.latLng.lng(),
      };
      this.infoWinOpen = true;
    },
    geolocate: function() {
      navigator.geolocation.getCurrentPosition((position) => {
        this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };
      });
    },
    // async initMapAutocomplete(network) {
    //   const input = document.getElementById("pac-input");
    //   const autocomplete = new google.maps.places.Autocomplete(input, {
    //     types: ["address"],
    //   });
    //   autocomplete.setComponentRestrictions({
    //     country: ["za"],
    //   });
    //   var circle = new google.maps.Circle({
    //     center: {
    //       lat: parseFloat(network.geoLatitude),
    //       lng: parseFloat(network.geoLongitude),
    //     },
    //     // center: new google.maps.LatLng(this.center.lat, this.center.lng),
    //     radius: 5000,
    //   });
    //   autocomplete.setBounds(circle.getBounds());
    //   autocomplete.setOptions({ strictBounds: true });
    //   this.fetchPackages(this.detail.address.estate, "Fibre");
    //   google.maps.event.addListener(autocomplete, "place_changed", async () => {
    //     this.outsidePolygons=false
    //     this.detail.feasibilityTestData = null;
    //     this.locationInfoWindowOpen = false;
    //     this.errorWindow = false;
    //     const place = autocomplete.getPlace();
    //     const location = place.geometry.location;
    //     const point = {
    //       type: "Point",
    //       coordinates: [location.lng(), location.lat()],
    //     };
    //     let testPoly = this.glookup.getContainers(point);
    //     let curPlace = autocomplete.getPlace();
    //     this.center = curPlace.geometry.location;
    //     this.locationMarker = this.center;
    //     let streetNumber = curPlace.address_components.find((x) => x.types.includes("street_number"));
    //     let streetName = curPlace.address_components.find((x) => x.types.includes("route"));
    //     if (testPoly.features.length > 0) {
    //       if (!streetName || !streetNumber) {
    //         let predictedStreet = autocomplete.gm_accessors_.place.qe.formattedPrediction.split(", ");
    //         let number = predictedStreet[0].substr(0, predictedStreet[0].indexOf(" "));
    //         let street = predictedStreet[0].substr(predictedStreet[0].indexOf(" ") + 1);
    //         this.locationTemplate = this.unitList.find((x) => x.unitNo == number && x.complexStreetName == street);
    //         this.searchLocation = autocomplete.gm_accessors_.place.qe.formattedPrediction;

    //         if (this.locationTemplate) {
    //           this.locationInfo = {
    //             address: curPlace.formatted_address,
    //             fno: this.networkData.organisation,
    //             location: {
    //               fibrePulled: this.locationTemplate.fibrePulled,
    //               equipmentInstalled: this.locationTemplate.equipmentInstalled,
    //             },
    //           };
    //           this.fetchPackages(this.detail.address.estate, "Fibre");
    //           this.locationInfoWindowOpen = true;
    //         } else {
    //           this.addressInformation = {
    //             streetNumber: number,
    //             streetName: street,
    //           };
    //           this.fetchPackages(this.detail.address.estate, "Fibre");
    //           this.addressPromptWindow = true;
    //         }
    //         this.fetchPackages(this.detail.address.estate, "Fibre");
    //       } else {
    //         this.locationTemplate = this.unitList.find(
    //           (x) => x.unitNo == streetNumber.short_name && x.complexStreetName == streetName.short_name
    //         );
    //         this.searchLocation = curPlace.formatted_address;
    //         this.detail.address.lat = JSON.stringify(location.lat());
    //         this.detail.address.lng = JSON.stringify(location.lng());

    //         if (this.locationTemplate) {
    //           this.locationInfo = {
    //             address: curPlace.formatted_address,
    //             fno: this.networkData.organisation,
    //             location: {
    //               fibrePulled: this.locationTemplate.fibrePulled,
    //               equipmentInstalled: this.locationTemplate.equipmentInstalled,
    //             },
    //           };
    //           this.fetchPackages(this.detail.address.estate, "Fibre");
    //           this.locationInfoWindowOpen = true;
    //         } else {
    //           this.addressInformation = {
    //             streetNumber: streetNumber.short_name,
    //             streetName: streetName.short_name,
    //           };
    //           this.fetchPackages(this.detail.address.estate, "Fibre");
    //           this.addressPromptWindow = true;
    //         }
    //         this.fetchPackages(this.detail.address.estate, "Fibre");
    //         this.zoom = 15;
    //       }
    //     } else {
    //       this.addressInformation = {
    //         streetNumber: streetNumber ? streetNumber.short_name : this.searchLocation.split(" ")[0],
    //         streetName: streetName.short_name,
    //       };
    //       this.locationMarker = this.center;
    //       this.errorWindow = true;
    //       let feasible = await this.testLineOfSight(this.center);
    //       this.isInWirelessRange = feasible.length > 0 && feasible.filter((x) => x.success).length > 0;
    //       this.detail.address.lat = JSON.stringify(location.lat());
    //       this.detail.address.lng = JSON.stringify(location.lng());
    //       this.fetchPackages(this.detail.address.estate, "Wireless");
    //     }
    //   });
    // },
    async initMapAutocompleteOutsideNetworks() {
      // const input = document.getElementById("pac-input");
      // const autocomplete = new google.maps.places.Autocomplete(input, {
      //   types: ["address"],
      // });
      // autocomplete.setComponentRestrictions({
      //   country: ["za"],
      // });
      
      // this.$refs.mapRef.$mapPromise.then(async (map) => {
      //   google.maps.event.addListener(map, "click", (event) => {
      //    this.outsidePolygons=true
      //    this.setUnitList()
      //     this.center = {
      //       lat: event.latLng.lat(),
      //       lng: event.latLng.lng(),
      //     };
      //     this.locationMarker = this.center;
      //     this.getAddressData(event);
      //   });
      // });
      // google.maps.event.addListener(autocomplete, "place_changed", async () => {
      // this.outsidePolygons=true
      // this.setUnitList()
      //   this.detail.feasibilityTestData = null;
      //   this.locationInfoWindowOpen = false;
      //   this.errorWindow = false;
      //   const place = autocomplete.getPlace();
      //   const location = place.geometry.location;
      //   const point = {
      //     type: "Point",
      //     coordinates: [location.lng(), location.lat()],
      //   };
      //   let testPoly = this.glookup.getContainers(point);
      //   let curPlace = autocomplete.getPlace();
      //   this.center = curPlace.geometry.location;
      //   this.locationMarker = this.center;
      //   let streetNumber = curPlace.address_components.find((x) => x.types.includes("street_number"));
      //   let streetName = curPlace.address_components.find((x) => x.types.includes("route"));

      //   this.addressInformation = {
      //     streetNumber: streetNumber ? streetNumber.short_name : this.searchLocation.split(" ")[0],
      //     streetName: streetName.short_name,
      //   };
      //   this.locationMarker = this.center;
      //   this.errorWindow = true;
      //   let feasible = await this.testLineOfSight(this.center);
      //   this.isInWirelessRange = feasible.length > 0 && feasible.filter((x) => x.success).length > 0;
      //   this.detail.address.lat = JSON.stringify(location.lat());
      //   this.detail.address.lng = JSON.stringify(location.lng());
      // });
    },
    async testLineOfSight(data) {
      let result = null;
      this.loadingFeasibility = true;
      await Api()
        .post("/gis/feasibility", {
          lat: data.lat().toString(),
          lng: data.lng().toString(),
        })
        .then((res) => {
          result = res.data;
          if (res.data && res.data.length > 0) {
            this.detail.feasibilityTestData = res.data;
          }
        });
      this.loadingFeasibility = false;
      return result;
    },
    resetSec() {
      this.detail.showSecondaryContact = false;
      this.detail.secondaryContact = {};
    },
    resetBill() {
      this.detail.addBillingContact = false;
      this.detail.billingContact = {};
    },
    validateEmail() {
      if (
        this.detail.primaryContact.emailAddress != null &&
        this.detail.primaryContact.emailAddress != "" &&
        this.validEmail(this.detail.primaryContact.emailAddress)
      ) {
        return true;
      } else {
        return false;
      }
    },
    validatePrim() {
      if (
        this.detail.primaryContact.title != null &&
        this.detail.primaryContact.title != "" &&
        this.detail.primaryContact.firstName != null &&
        this.detail.primaryContact.firstName != "" &&
        this.detail.primaryContact.lastName != null &&
        this.detail.primaryContact.lastName != "" &&
        this.detail.primaryContact.contactNumber != null &&
        this.detail.primaryContact.contactNumber != "" &&
        this.detail.primaryContact.contactNumber.length >= 10 &&
        this.detail.primaryContact.emailAddress != null &&
        this.detail.primaryContact.emailAddress != "" &&
        this.validEmail(this.detail.primaryContact.emailAddress) &&
        this.detail.primaryContact.idNumber != null &&
        this.detail.primaryContact.idNumber != "" &&
        this.detail.primaryContact.idNumber.length >= 9
      ) {
        return true;
      }
    },
    validateSec() {
      if (this.detail.showSecondaryContact == true) {
        if (
          this.detail.secondaryContact.title != null &&
          this.detail.secondaryContact.title != "" &&
          this.detail.secondaryContact.firstName != null &&
          this.detail.secondaryContact.firstName != "" &&
          this.detail.secondaryContact.lastName != null &&
          this.detail.secondaryContact.lastName != "" &&
          this.detail.secondaryContact.contactNumber != null &&
          this.detail.secondaryContact.contactNumber != "" &&
          this.detail.secondaryContact.contactNumber.length >= 10 &&
          this.detail.secondaryContact.emailAddress != null &&
          this.detail.secondaryContact.emailAddress != "" &&
          this.validEmail(this.detail.secondaryContact.emailAddress) &&
          this.detail.secondaryContact.idNumber != null &&
          this.detail.secondaryContact.idNumber != "" &&
          this.detail.secondaryContact.idNumber.length >= 9
        ) {
          return true;
        }
      } else if (this.detail.showSecondaryContact == false) {
        return true;
      }
    },
    validateBill() {
      if (this.detail.addBillingContact == true) {
        if (
          this.detail.billingContact.title != null &&
          this.detail.billingContact.title != "" &&
          this.detail.billingContact.firstName != null &&
          this.detail.billingContact.firstName != "" &&
          this.detail.billingContact.lastName != null &&
          this.detail.billingContact.lastName != "" &&
          this.detail.billingContact.contactNumber != null &&
          this.detail.billingContact.contactNumber != "" &&
          this.detail.billingContact.contactNumber.length >= 10 &&
          this.detail.billingContact.emailAddress != null &&
          this.detail.billingContact.emailAddress != "" &&
          this.validEmail(this.detail.billingContact.emailAddress) &&
          this.detail.billingContact.idNumber != null &&
          this.detail.billingContact.idNumber != "" &&
          this.detail.billingContact.idNumber.length >= 9
        ) {
          if (
            !this.detail.billingAddressSame &&
            this.detail.billingContact.physicalAddressLine1 != null &&
            this.detail.billingContact.physicalAddressLine1 != "" &&
            this.detail.billingContact.physicalAddressLine2 != null &&
            this.detail.billingContact.physicalAddressLine2 != "" &&
            this.detail.billingContact.physicalAddressLine3 != null &&
            this.detail.billingContact.physicalAddressLine3 != ""
          ) {
            return true;
          } else if (this.detail.billingAddressSame) {
            return true;
          } else {
            return false;
          }
        }
      } else if (this.detail.addBillingContact == false) {
        return true;
      }
    },
    reset() {
      this.infoWinOpen = false;
      this.locationInfoWindowOpen = false;
      this.errorWindow = false;
      this.polyInfo = {};
      this.locationTemplate = null;
      this.locationMarker = {};
      this.confirmAddress = false;
      this.center = {};
      this.detail.activationDate = "";
      this.detail.address.estate=null
      this.detail.address.unitNumber = null;
      this.detail.address.fullUnitDetails = null;
      this.detail.showInterest=false
      this.networkData = {};
      this.locationInfo = {};
      this.infoWindowPos={}
      this.addressPromptWindow=false
      this.key++
    },
    speedDownload(val) {
      return this.filter.downloadLabels[val];
    },
    speedUpload(val) {
      return this.filter.uploadLabels[val];
    },
    async initialize() {
      await this.fetchWirelessHighSites();
      // await this.fetchEstates();

      this.fetchPrimOrg();
      // eslint-disable-next-line no-undef
      this.geolocate();
      // this.geocoder = new google.
    },
    allowedDates: (val) => new Date(val).getDay() < 6 && new Date(val).getDay() > 0 && !disabledDates.includes(val),
    onEnd() {
      this.saveSignature();
    },
    addDays(date, days) {
      var result = new Date(date);
      result.setDate(result.getDate() + days);
      result.toISOString();
      return result;
    },
    validEmail(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    formatDate(date) {
      var dd = date.getDate();
      var mm = date.getMonth() + 1;
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }
      var yyyy = date.getFullYear();
      var result = yyyy + "-" + mm + "-" + dd;
      return result;
    },
    checkSignature() {
      if (this.$refs.signaturePad.isEmpty()) {
        return false;
      } else {
        return true;
      }
    },
    undoSignature() {
      this.$refs.signaturePad.undoSignature();
      if (!this.checkSignature()) {
        this.signatureIsEmpty = true;
      }
    },
    saveSignature() {
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
      this.signatureIsEmpty = isEmpty;
      this.detail.signature = data;
    },
    reloadPage() {
      // window.location.reload();
    },
    clearSignature() {
      this.$refs.signaturePad.clearSignature();
      this.signatureIsEmpty = true;
    },
    fetchWirelessHighSites() {
      Api()
        .get("/wireless/highSites")
        .then(async (res) => {
          this.wirelessHighSites = res.data;
          await this.wirelessHighSites.map((x) => {
            x.lat = parseFloat(x.lat);
            x.lng = parseFloat(x.lng);
          });
        });
    },
    fetchEstates() {
      this.appLoading = true;
      this.loadingText = " \n\nFetching Available Networks...";
      Api()
        .get("/ftthApplication/activelocationnetworks")
        .then(async (response) => {
          this.estateList = response.data;
          this.estateList.unshift("My area is not in the list");
          let geoObj = {
            type: "FeatureCollection",
            name: "Network Polygons",
            crs: {
              type: "name",
              properties: { name: "urn:ogc:def:crs:OGC:1.3:CRS84" },
            },
            features: [],
          };
          let objects = response.data;
          for (let x = 1; x < objects.length; x++) {
            let obj = {
              type: "Feature",
              properties: {
                name: objects[x].name,
                fno: objects[x].organisation,
                network: objects[x],
                tessellate: 1,
              },
              geometry: {
                type: "Polygon",
                coordinates:
                  objects[x].networkPolygons.length > 0
                    ? JSON.parse(objects[x].networkPolygons[objects[x].networkPolygons.length - 1].coordinates)
                    : [],
              },
            };
            if (obj.geometry.coordinates.length > 0) {
              if (
                obj.geometry.coordinates[0][0][0] !==
                  obj.geometry.coordinates[0][obj.geometry.coordinates[0].length - 1][0] ||
                obj.geometry.coordinates[0][0][1] !==
                  obj.geometry.coordinates[0][obj.geometry.coordinates[0].length - 1][1]
              ) {
                obj.geometry.coordinates[0].push(obj.geometry.coordinates[0][0]);
              }
              geoObj.features.push(obj);
            }
          }
          this.geoData = geoObj;
          this.glookup = new GeoJsonGeometriesLookup(this.geoData);

          this.appLoading = false;
          // this.plotMap();
        });
    },
    fetchPrimOrg() {
      Api()
        .get("/customer/show/organisation")
        .then((response) => {
          this.org = response.data;
        });
    },
    setLocationInfoCard() {
      this.confirmAddress = false;
      if (this.locationTemplate) {
        this.locationInfo = {
          address: this.locationTemplate.locationDescription,
          fno: this.networkData.organisation,
          location: {
            fibrePulled: this.locationTemplate.fibrePulled,
            equipmentInstalled: this.locationTemplate.equipmentInstalled,
          },
        };
        this.infoWinOpen = false;
        this.locationMarker = this.center;
        this.locationInfoWindowOpen = true;
      }
    },
    fetchProducts(id) {
      Api()
        .get("/locationNetworkProduct/byNetwork/" + id)
        .then((response) => {
          this.productCards = response.data;
        });
    },
    async setUnitList(e) {
     this.errorWindow = false
     this.locationMarker={}
     this.key++
      this.networkData = {};
      if (e) {
      this.detail.feasibilityTestData = null;
      let network = this.estateList.find((x) => x.id === e);
      this.networkData = network;

      // if (network.geoLatitude != 0 && network.geoLongitude != 0) {
      //   this.center = {
      //     lat: parseFloat(network.geoLatitude),
      //     lng: parseFloat(network.geoLongitude),
      //   };
      //   this.initMapAutocomplete(network);
      // } else if (
      //   network.networkPolygons.length > 0 &&
      //   network.networkPolygons[network.networkPolygons.length - 1].coordinates
      // ) {
      //   let coords = await JSON.parse(network.networkPolygons[network.networkPolygons.length - 1].coordinates);
      //   this.center = {
      //     lat: coords[0][0][0],
      //     lng: coords[0][0][1],
      //   };
      //   this.initMapAutocomplete(network);

      //   this.networkData.isMDU = true;
      // }
      this.fetchProducts(network.id);
      this.detail.address.unitNumber = null;
      this.detail.selectedInternetPackage = null;
      this.detail.internetPackageSelected = false;
      this.businessInstallFee = null;
      this.residentialInstallFee = null;
      let installFee = false;
      let run = true;
      this.unitList = network.locations;
      this.zoom = 15;
      this.detail.address.suburb = this.networkData.suburb;
      this.detail.address.streetName = this.networkData.streetName;
      this.detail.address.city = this.networkData.city;
      this.detail.selectedNetwork = this.networkData;
      this.installFee = this.networkData.routerInstallationFee;
      this.residentialInstallFee = this.networkData.residentialRouterInstallationFeeAmount;
      this.businessInstallFee = this.networkData.businessRouterInstallationFeeAmount;
      if (network.isMDU) {
        this.fetchPackages(this.detail.address.estate, "Fibre");
      }
      }
    },
    setAddressData(item){

    },
    selectUnit(obj) {
      this.selectUnitModal = false;
      this.detail.address.unitNumber = obj.locationDescription;
      this.detail.address.fullUnitDetails = obj;

      this.key += 1;
    },
    selectPackage(e) {
      if (e == null) {
        this.detail.selectedInternetPackage = null;
      } else {
        this.detail.selectedInternetPackage = e;

        //this.validPackage=true
      }
    },
    selectProduct(e) {
      if (e == null) {
        this.detail.selectedProduct = null;
      } else {
        this.detail.selectedProduct = e;
        this.productArray = e;
      }
    },
    HighToLowSort(property) {
      var sortOrder = -1;
      if (property[0] === "-") {
        sortOrder = -1;
        property = property.substr(1);
      }
      return function(a, b) {
        var result = a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
        return result * sortOrder;
      };
    },
    getDates() {
      let start = new Date(2019, 11, 23);
      let end = new Date(2020, 0, 10);
      for (var arr = [], dt = start; dt <= end; dt.setDate(dt.getDate() + 1)) {
        arr.push(new Date(dt));
      }
      this.disabledDates = arr;
      return arr;
    },
    LowToHighSort(property) {
      var sortOrder = 1;
      if (property[0] === "-") {
        sortOrder = -1;
        property = property.substr(1);
      }
      return function(a, b) {
        var result = a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
        return result * sortOrder;
      };
    },
    sortpackages(key) {
      if (key == "PHTL") {
        this.packagesIsps = this.packagesIsps.sort(this.HighToLowSort("recurringPriceVatInc"));
      }
      if (key == "PLTH") {
        this.packagesIsps = this.packagesIsps.sort(this.LowToHighSort("recurringPriceVatInc"));
      }
      if (key == "SHTL") {
        this.packagesIsps = this.packagesIsps.sort(this.HighToLowSort("downloadMbps"));
      }
      if (key == "SLTH") {
        this.packagesIsps = this.packagesIsps.sort(this.LowToHighSort("downloadMbps"));
      }
    },
    fetchPackages(e, type) {
      this.packagesLoading = true;
      this.loadingText = "Fetching Packages Available on Selected Network...";
      Api()
        .get("/ftthApplication/byNetwork/active/" + e + "/" + type, {
          params: this.$route.query
        })
        .then(async (response) => {
          this.customerList = response.data.customerOrganisations;
          this.pagination.totalItems = response.data.activePackages.length;
          await response.data.activePackages.map(async (x) => {
            x.isSelected = false;
            x.customerOrganisation = await response.data.organisations.find((y) => y.id == x.customerOrganisationId);
          });
          this.sivPackages(response.data.activePackages);
          this.flags.hasBusinessPacks = false;

          for (let i = 0; i < response.data.activePackages.length; i++) {
            if (response.data.activePackages[i].packagesFno.packagesFnoCat.packageCatType == "Business") {
              this.flags.hasBusinessPacks = true;
            }
          }
          this.loading = false;
          this.packagesLoading = false;
          let days = 0;
          if (this.$store.state.currentOrg.applicationNoticeDays) {
            days = parseInt(this.$store.state.currentOrg.applicationNoticeDays);
          }
          this.minActivationDate = this.formatDate(this.addDays(new Date(), days));
          this.detail.activationDate = this.formatDate(this.addDays(new Date(), days + 1));
          //this.detail.activationDate = this.formatDate(this.addDays(new Date(), parseInt(this.$store.state.currentOrg.applicationNoticeDays)))
        });
    },
    async sivPackages(packageArray) {
      let ISPList = [];
      this.providerList = [];
      let ISPListId = [];
      this.filter.downloadLabels = [];
      this.filter.uploadLabels = [];

      //preparing array for filtering and sorting
      for (let i = 0; i < packageArray.length; i++) {
        if (!this.filter.downloadLabels.includes(packageArray[i].packagesFno.speedProfile.downloadMbps)) {
          await this.filter.downloadLabels.push(packageArray[i].packagesFno.speedProfile.downloadMbps);
        }
        if (!this.filter.uploadLabels.includes(packageArray[i].packagesFno.speedProfile.uploadMbps)) {
          await this.filter.uploadLabels.push(packageArray[i].packagesFno.speedProfile.uploadMbps);
        }
        packageArray[i].downloadMbps = packageArray[i].packagesFno.speedProfile.downloadMbps;

        if (packageArray[i].customerOrganisation && !ISPListId.includes(packageArray[i].customerOrganisation.id)) {
          ISPListId.push(packageArray[i].customerOrganisation.id);
          ISPList.push({
            id: packageArray[i].customerOrganisation.id,
            name: packageArray[i].customerOrganisation.name,
            logo: packageArray[i].customerOrganisation.logo,
          });
        } else if (!packageArray[i].customerOrganisation) {
        }
      }
      this.filter.downloadLabels.sort((a, b) => a - b);
      this.filter.uploadLabels.sort((a, b) => a - b);
      this.providerList = ISPList;

      //Assign Auxillary packages
      this.packagesIsps = packageArray;
      this.allPackages = packageArray;
      //Set Filter values
      this.filter.highestSpeedProfileDownload = Math.max.apply(
        Math,
        packageArray.map(function(o) {
          return o.packagesFno.speedProfile.downloadMbps;
        })
      );
      this.filter.lowestSpeedProfileDownload = Math.min.apply(
        Math,
        packageArray.map(function(o) {
          return o.packagesFno.speedProfile.downloadMbps;
        })
      );
      this.filter.speedDownload[0] = this.filter.downloadLabels.indexOf(this.filter.lowestSpeedProfileDownload);
      this.filter.speedDownload[1] = this.filter.downloadLabels.indexOf(this.filter.highestSpeedProfileDownload);
      this.filter.highestSpeedProfileUpload = Math.max.apply(
        Math,
        packageArray.map(function(o) {
          return o.packagesFno.speedProfile.uploadMbps;
        })
      );
      this.filter.lowestSpeedProfileUpload = Math.min.apply(
        Math,
        packageArray.map(function(o) {
          return o.packagesFno.speedProfile.uploadMbps;
        })
      );
      this.filter.speedUpload[0] = this.filter.uploadLabels.indexOf(this.filter.lowestSpeedProfileUpload);
      this.filter.speedUpload[1] = this.filter.uploadLabels.indexOf(this.filter.highestSpeedProfileUpload);
      this.sortpackages("SLTH");
      this.detail.internetPackageSelected = true;
    },
    filterPackages(code, value) {
      let tempPackages = [];
      if (code == "ISP") {
        if (value == "All") {
          tempPackages = this.allPackages;
        } else {
          this.packagesIsps = [];
          for (let i = 0; i < this.allPackages.length; i++) {
            if (this.allPackages[i].customerOrganisation.name == value) {
              tempPackages.push(this.allPackages[i]);
            }
          }
        }
      } else {
        tempPackages = this.allPackages;
      }
      // slider filter
      let tempPackages2 = [];
      for (let k = 0; k < tempPackages.length; k++) {
        if (
          tempPackages[k].packagesFno.speedProfile.downloadMbps >=
            this.filter.downloadLabels[this.filter.speedDownload[0]] &&
          tempPackages[k].packagesFno.speedProfile.downloadMbps <=
            this.filter.downloadLabels[this.filter.speedDownload[1]] &&
          tempPackages[k].packagesFno.speedProfile.uploadMbps >= this.filter.uploadLabels[this.filter.speedUpload[0]] &&
          tempPackages[k].packagesFno.speedProfile.uploadMbps <= this.filter.uploadLabels[this.filter.speedUpload[1]]
        ) {
          tempPackages2.push(tempPackages[k]);
        }
      }
      this.packagesIsps = tempPackages2;

      //IsBusiness Filter
      let tempPackages3 = [];
      for (let ii = 0; ii < tempPackages2.length; ii++) {
        if (tempPackages2[ii].packagesFno.packagesFnoCat.packageCatType == "Business" && this.filter.showBusiness) {
          tempPackages3.push(tempPackages2[ii]);
        } else if (
          tempPackages2[ii].packagesFno.packagesFnoCat.packageCatType == "Residential" &&
          this.filter.showResidential
        ) {
          tempPackages3.push(tempPackages2[ii]);
        } else if (this.filter.showAll) {
          tempPackages3.push(tempPackages2[ii]);
        }
      }
      this.packagesIsps = tempPackages3;
    },
    filterPackageTypes(type) {
      if (type === "All") {
        this.packagesIsps = this.allPackages;
      } else {
        this.packagesIsps = this.allPackages.filter(function(el) {
          return el.packagesFno.packagesFnoCat.packageCatType === type;
        });
      }
    },
    filterPackageSpeeds(downMin, downMax, upMin, upMax) {
      this.packagesIsps = this.allPackages.filter(function(el) {
        return (
          el.packagesFno.speedProfile.downloadMbps >= downMin &&
          el.packagesFno.speedProfile.downloadMbps <= downMax &&
          el.packagesFno.speedProfile.uploadMbps >= upMin &&
          el.packagesFno.speedProfile.uploadMbps <= upMax
        );
      });
    },

    toggle(type) {
      if (type == "internetPackageSelection") {
        if (this.detail.internetPackageSelected == true) {
          this.detail.internetPackageSelected = false;
        } else {
          this.detail.internetPackageSelected = true;
        }
      }
      if (type == "TVPackageSelection") {
        if (this.detail.includeTVOverFibrePackage == true) {
          this.detail.includeTVOverFibrePackage = false;
        } else {
          this.detail.includeTVOverFibrePackage = true;
        }
      }
    },
    checkForm() {
      if (this.detail.selectedInternetPackage !== null && typeof this.detail.selectedInternetPackage !== "undefined") {
        if (this.fnoPackagesPromoIdList.includes(this.detail.selectedInternetPackage.packagesFnoId)) {
          this.detail.selectedNetwork.residentialRouterInstallationFeeAmount = 0;
          this.detail.selectedNetwork.businessRouterInstallationFeeAmount = 0;
        }
      }
      let error = false;
      if (this.detail.selectedNetwork.gtuIncluded) {
        this.detail.includeTVOverFibrePackage = true;
      }
      // Activation date validation
      if (this.detail.activationDate == null || typeof this.detail.activationDate == "undefined") {
        this.errorMessage = "Please select an activation date.";
        this.e1 = 2;
        this.choosePackage = true;
        error = true;
      }
      // Primary contact Validation
      if (this.detail.primaryContact.firstName == "" || typeof this.detail.primaryContact.firstName == "undefined") {
        this.errorMessage = "You need to fill in your first name to proceed with submission.";
        this.e1 = 5;
        this.chooseContact = true;
        error = true;
      }
      if (this.detail.primaryContact.lastName == "" || typeof this.detail.primaryContact.lastName == "undefined") {
        this.errorMessage = "You need to fill in your last name to proceed with submission.";
        this.e1 = 5;
        this.chooseContact = true;
        error = true;
      }
      if (
        this.detail.primaryContact.contactNumber == "" ||
        typeof this.detail.primaryContact.contactNumber == "undefined"
      ) {
        this.errorMessage = "You need to fill in your contact number to proceed with submission.";
        this.e1 = 5;
        this.chooseContact = true;
        error = true;
      }
      if (this.detail.primaryContact.idNumber == "" || typeof this.detail.primaryContact.idNumber == "undefined") {
        this.errorMessage = "You need to fill in your ID number to proceed with submission.";
        this.e1 = 5;
        this.chooseContact = true;
        error = true;
      }
      if (
        this.detail.primaryContact.emailAddress == "" ||
        typeof this.detail.primaryContact.emailAddress == "undefined"
      ) {
        this.errorMessage = "You need to fill in your email address to proceed with submission.";
        this.e1 = 5;
        this.chooseContact = true;
        error = true;
      }
      // Secondary contact Validation
      if (this.detail.showSecondaryContact) {
        if (
          this.detail.secondaryContact.firstName == "" ||
          typeof this.detail.secondaryContact.firstName == "undefined"
        ) {
          this.errorMessage = "You need to fill in the secondary contact's first name to proceed with submission.";
          this.e1 = 5;
          this.chooseContact = true;
          error = true;
        }
        if (
          this.detail.secondaryContact.lastName == "" ||
          typeof this.detail.secondaryContact.lastName == "undefined"
        ) {
          this.errorMessage = "You need to fill in the secondary contact's last name to proceed with submission.";
          this.e1 = 5;
          this.chooseContact = true;
          error = true;
        }
        if (
          this.detail.secondaryContact.contactNumber == "" ||
          typeof this.detail.secondaryContact.contactNumber == "undefined"
        ) {
          this.errorMessage = "You need to fill in the secondary contact's contact number to proceed with submission.";
          this.e1 = 5;
          this.chooseContact = true;
          error = true;
        }
        if (
          this.detail.secondaryContact.emailAddress == "" ||
          typeof this.detail.secondaryContact.emailAddress == "undefined"
        ) {
          this.errorMessage = "You need to fill in the secondary contact's email address to proceed with submission.";
          this.e1 = 5;
          this.chooseContact = true;
          error = true;
        }
        //if (this.detail.secondaryContact.relationToPrimary == '' || typeof (this.detail.secondaryContact.relationToPrimary) == 'undefined') {
        //    this.errorMessage = "You need to fill in the secondary contact's relation to primary contact to proceed with submission."
        //    error = true
        //}
      }
      // Billing contact Validation
      if (this.detail.addBillingContact) {
        if (this.detail.billingContact.firstName == "" || typeof this.detail.billingContact.firstName == "undefined") {
          this.errorMessage = "You need to fill in the billing contact's first name to proceed with submission.";
          this.e1 = 5;
          this.chooseContact = true;
          error = true;
        }
        if (this.detail.billingContact.lastName == "" || typeof this.detail.billingContact.lastName == "undefined") {
          this.errorMessage = "You need to fill in the billing contact's last name to proceed with submission.";
          this.e1 = 5;
          this.chooseContact = true;
          error = true;
        }
        if (
          this.detail.billingContact.contactNumber == "" ||
          typeof this.detail.billingContact.contactNumber == "undefined"
        ) {
          this.errorMessage = "You need to fill in the billing contact's contact number to proceed with submission.";
          this.e1 = 5;
          this.chooseContact = true;
          error = true;
        }
        if (
          this.detail.billingContact.emailAddress == "" ||
          typeof this.detail.billingContact.emailAddress == "undefined"
        ) {
          this.errorMessage = "You need to fill in the billing contact's email address to proceed with submission.";
          this.e1 = 5;
          this.chooseContact = true;
          error = true;
        }
        if (this.detail.billingContact.idNumber == "" || typeof this.detail.billingContact.idNumber == "undefined") {
          this.errorMessage = "You need to fill in the billing contact's ID number to proceed with submission.";
          this.e1 = 5;
          this.chooseContact = true;
          error = true;
        }
        if (
          (this.detail.billingContact.physicalAddressLine1 == "" ||
            (typeof this.detail.billingContact.physicalAddressLine1 && !this.detail.billingAddressSame)) == "undefined"
        ) {
          this.errorMessage = "You need to fill in the billing contact's address line 1 to proceed with submission.";
          this.e1 = 5;
          this.chooseContact = true;
          error = true;
        }
        if (
          (this.detail.billingContact.physicalAddressLine2 == "" ||
            (typeof this.detail.billingContact.physicalAddressLine2 && !this.detail.billingAddressSame)) == "undefined"
        ) {
          this.errorMessage = "You need to fill in the billing contact's address line 2 to proceed with submission.";
          this.e1 = 5;
          this.chooseContact = true;
          error = true;
        }
        if (
          (this.detail.billingContact.physicalAddressLine3 == "" ||
            (typeof this.detail.billingContact.physicalAddressLine3 && !this.detail.billingAddressSame)) == "undefined"
        ) {
          this.errorMessage = "You need to fill in the billing contact's address line 3 to proceed with submission.";
          this.e1 = 5;
          this.chooseContact = true;
          error = true;
        }
        //if (this.detail.billingContact.vatNumber == '' || typeof (this.detail.billingContact.vatNumber) == 'undefined') {
        //    this.errorMessage = "You need to fill in the billing contact's VAT number to proceed with submission."
        //    error = true
        //}
      }
      // Address Validation
      if (this.detail.address.estate == "" || typeof this.detail.address.estate == "undefined") {
        this.errorMessage = "You need to fill in the address estate detail to proceed with submission.";
        this.e1 = 1;
        this.chooseEstate = true;
        error = true;
      }
      if (this.detail.address.unitNumber == "" || typeof this.detail.address.unitNumber == "undefined") {
        this.errorMessage = "You need to fill in the address unit number detail to proceed with submission.";
        this.e1 = 3;
        this.chooseAddress = true;
        error = true;
      }
      if (error === true) {
        this.showError = true;
        return false;
      } else {
        return true;
      }
    },
    getBase64Image(imgUrl, callback) {
      var img = new Image();

      // onload fires when the image is fully loadded, and has width and height

      img.onload = function() {
        var canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        var ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);
        var dataURL = canvas.toDataURL("image/png"),
          dataURL = dataURL.replace(/^data:image\/(png|jpg);base64,/, "");

        return dataURL; // the base64 string
      };

      // set attributes and src
      img.setAttribute("crossOrigin", "anonymous"); //
      img.src = imgUrl;
    },
    submit(type) {
      if (this.checkForm()) {
        this.detail.address.coordinates = null;
        if (this.detail.address.lat && this.detail.address.lng) {
          this.detail.address.coordinates = JSON.stringify({
            lat: this.detail.address.lat,
            lng: this.detail.address.lng,
          });
        }

        this.detail.primaryContact.emailAddress = this.detail.primaryContact.emailAddress.replace(/\s/g, "");
        if (typeof this.detail.secondaryContact.emailAddress !== "undefined") {
          this.detail.secondaryContact.emailAddress = this.detail.secondaryContact.emailAddress.replace(/\s/g, "");
        }
        if (typeof this.detail.billingContact.emailAddress !== "undefined") {
          this.detail.billingContact.emailAddress = this.detail.billingContact.emailAddress.replace(/\s/g, "");
        }
        if (this.detail.selectedInternetPackage !== null) {
          if (this.detail.selectedInternetPackage.packagesFno.packagesFnoCat.packageCatType == "Business") {
            this.detail.isBusiness = true;
          } else {
            this.detail.isBusiness = false;
          }
          // base64String = this.getBase64Image(
          //   this.detail.selectedInternetPackage.customerOrganisation.logo
          // );
        }
        if (this.locationTemplate) {
          this.detail.supplierOrganisationId = this.locationInfo.fno.id;
          this.detail.streetNumber = this.locationTemplate.unitNo;
          this.detail.streetName = this.locationTemplate.complexStreetName;
        } else {
          this.detail.supplierOrganisationId = this.networkData.organisation.id;
          this.detail.streetNumber = this.addressInformation.streetNumber;
          this.detail.streetName = this.addressInformation.streetName;
        }
        this.detail.agreement = this.agreement;
        this.detail.fnoTermsAgreement = this.fnoTerms;
        this.detail.ispTermsAgreement = this.ispTerms;
        this.detail.vat = this.$VAT;
        this.submittingApplication = true;
         this.detail.agreeShareDetails = this.agreeShareDetails
        Api()
          .post("/ftthApplication", {
            data: this.detail,
          })
          .then((response) => {
            if (type == "standard") {
              this.submittingApplication = false;
              this.chooseComplete = true;
              this.e1 = 0;
            } else if (type == "pay") {
              this.payNowForm = {
                M1: this.payNowInfo.secretKey,
                M2: "24ade73c-98cf-47b3-99be-cc7b867b3080",
                p2: response.data.invoiceNumber,
                p3: "Order: " + response.data.id,
                p4: response.data.totalInvoiceAmount,
                Budget: "N",
                m4: "orderId=" + response.data.id,
                m5: response.data.invoiceId,
                m6: response.data.accountingCustomerId,
                m9: this.detail.primaryContact.emailAddress,
                m11: this.detail.primaryContact.contactNumber,
                m10: response.data.invoiceNumber,
                m14: 0,
              };
              document.body.innerHTML += `
              <form id="payNowForm" method="POST" action="https://paynow.netcash.co.za/site/paynow.aspx" target="_top"> <!---Form POST **--->
  <input type="text" name="M1" value="${this.payNowForm.M1}">  <!--- YOUR PAY NOW SERVICE KEY GOES IN HERE --->
  <input type="text" name="M2" value="${this.payNowForm.M2}">  <!--- SOFTWARE VENDOR KEY GOES IN HERE --->
  <input type="text" name="p2" value="${
    this.payNowForm.p2
  }">                                <!---Unique ID for this / each transaction--->
  <input type="text" name="p3"  value="${
    this.payNowForm.p3
  }">                    <!---Description of goods being purchased--->
  <input type="text" name="p4" value="${
    this.payNowForm.p4
  }">                                  <!---Amount to be settled / paid--->
  <input type="text" name="Budget" value="${
    this.payNowForm.Budget
  }">                                 <!---Compulsory should be Y--->
  <input type="text" name="m4" value="${this.payNowForm.m4}">
  <input type="text" name="m5" value="${
    this.payNowForm.m5
  }">                               <!---This is an extra field ***--->
  <input type="text" name="m6" value="${
    this.payNowForm.m6
  }">                               <!---This is an extra field ***--->
  <input type="text" name="m9" value="${this.payNowForm.m9}">                     <!---Card holders email address--->
  <input type="text" name="m11" value="${
    this.payNowForm.m11
  }">                           <!---Card holders mobile number--->
  <input type="text" name="m10" value="orderId=${
    this.payNowForm.m4
  }">             <!---Dataset used by shopping carts i.e. OSCommerce--->
  <input type="text" name="m14" value="${
    this.payNowForm.m14
  }">                                    <!---Request credit card subscription token 0 = no | 1 = yes--->

</form>
              `;
              document.getElementById("payNowForm").submit();
            }
          });
      }
    },
    test() {
      this.formComplete = true;
    },
  },
};
</script>
<style>
.centerCode {
  text-align: center;
}
h1 {
  font-size: -webkit-xxx-large;
}
.section-heading {
  float: left;
  margin: 20px;
  font-size: 18px;
  /*width: 100%;*/
}
.input-flex-min-space {
  padding: 0px;
  margin: 0px;
}
.pointer {
  cursor: pointer;
}
#signature {
  border: double 3px transparent;
  border-radius: 5px;
  background-image: linear-gradient(white, white), radial-gradient(circle at top left, grey, grey);
  background-origin: border-box;
  background-clip: content-box, border-box;
}

.compact-form {
  transform: scale(0.85);
  transform-origin: top;
  padding-left: 0px;
  padding-right: 0px;
}
.compact-formComplete {
  transform: scale(0.8);
  transform-origin: center;
}
.center {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 50%;
}
a {
  cursor: pointer;
}
.form-padding {
  padding: 1% 10%;
}
.lg-field-padding {
  padding: 0% 15%;
}
.md-field-padding {
  padding: 0% 5%;
}
.mobileStep {
  font-size: 12px;
  width: 100%;
}
.smallWidth {
  width: 40%;
}
.largeWidth {
  width: 40%;
}
.xlargeWidth {
  padding-left: 10px;
  padding-right: 10px;
  width: 100%
}
.margeLarge {
  margin-right: 90px;
}
.otp-input-xs {
  width: 25px;
  height: 25px;
  padding: 5px;
  margin: 0px 20px;
  font-size: 15px;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.3);
  text-align: center;
}
.otp-input-xs::-webkit-inner-spin-button,
.otp-input-xs::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.otp-input {
  width: 40px;
  height: 40px;
  padding: 5px;
  margin: 0px 10px;
  font-size: 20px;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.3);
  text-align: center;
  text-justify: center;
}
.otp-input::-webkit-inner-spin-button,
.otp-input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
